{
  "common": {
    "accountStatus": {
      "active": "Compte créé",
      "invitationSent": "Invitation envoyée le {date, date, short}",
      "invitationSentShort": "Invitation le {date, date, short}",
      "notInvited": "Non invité"
    },
    "activity": {
      "meetingLink": {
        "copied": "Lien de la visio copié dans le presse-papiers",
        "copy": "Copier le lien de la visio",
        "failedToCopy": "Échec de la copie du lien de la visio"
      },
      "participants": "Personnes concernées",
      "qualification": {
        "label": {
          "DOCTOR": "Médecin du travail",
          "NURSE": "Infirmier·ère"
        }
      }
    },
    "add": "Ajouter",
    "addFile": "Ajouter un fichier",
    "address": "{line}, {postalCode}, {city}",
    "andNOthers": "+ {count} autres",
    "back": "Retour",
    "cancel": "Annuler",
    "chat": {
      "empty": {
        "description": "Aucun message n'a encore été envoyé.",
        "title": "Aucun message"
      },
      "input": {
        "label": "Message",
        "placeholder": "Message"
      },
      "self": "Vous",
      "send": "Envoyer"
    },
    "close": "Fermer",
    "confirm": "Confirmer",
    "contactSupport": "Contacter le support",
    "continue": "Continuer",
    "date": "{date, date, short}",
    "dateAndDuration": "{date, date, short} ({duration})",
    "dateDay": "{date, date, ::dd}",
    "dateDayMonthTime": "{date, date, ::ddMM} – {date, time, ::HHmm}",
    "dateDayOfMonth": "{date, date, ::d}",
    "dateFull": "{date, date, full}",
    "dateLong": "{date, date, long}",
    "dateMonth": "{date, date, ::MMMM}",
    "dateTime": "{date, date, long} à {date, time, short}",
    "dateTime2Digits": "{date, time, ::HH mm}",
    "dateTimeShort": "{date, date, short} à {date, time, short}",
    "dateWeekNumber": "Semaine {weekNumber, number}",
    "dateWeekday": "{date, date, ::EEEE}",
    "day": "Jour",
    "dayOfWeek": {
      "friday": "Vendredi",
      "monday": "Lundi",
      "saturday": "Samedi",
      "sunday": "Dimanche",
      "thursday": "Jeudi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi"
    },
    "dayOfWeekLetter": {
      "friday": "V",
      "monday": "L",
      "saturday": "S",
      "sunday": "D",
      "thursday": "J",
      "tuesday": "M",
      "wednesday": "M"
    },
    "delete": "Supprimer",
    "deleteElement": "Supprimer {element}",
    "document": "Document",
    "download": "Télécharger",
    "downloadError": "Échec du téléchargement",
    "duration": {
      "lessThanOneMonth": "Moins d'un mois",
      "months": "{count, plural, one {{count} mois} other {{count} mois}}",
      "years": "{count, plural, one {{count} an} other {{count} ans}}",
      "yearsAndMonths": "{years} et {months}"
    },
    "edit": "Modifier",
    "errorPage": {
      "description": "Elle s’est égarée, mais rien de grave. On vous aide à retrouver le bon chemin.",
      "goToDashboard": "Retour au tableau de bord",
      "title": "Ooops, cette page n’a pas suivi le mouvement."
    },
    "fileCount": "{count, plural, one {{count} fichier} other {{count} fichiers}}",
    "fileImport": {
      "emptyFile": {
        "description": "Le fichier est vide. Vérifiez son contenu et réessayez.",
        "title": "Fichier vide"
      },
      "fileTooLarge": {
        "description": "Le fichier fait plus de 50mo. Veuillez réduire sa taille et réimporter.",
        "title": "Fichier trop lourd"
      },
      "importError": {
        "description": "Impossible d'importer le fichier. Veuillez réessayer.",
        "title": "Erreur lors de l'import"
      },
      "invalidFileType": {
        "description": "Seuls les fichiers .csv sont acceptés. Veuillez modifier le format et réimporter.",
        "title": "Format de fichier non pris en charge"
      },
      "tooManyFiles": {
        "description": "Vous ne pouvez importer qu'un seul fichier à la fois. Sélectionnez un seul fichier et réessayez.",
        "title": "Trop de fichiers"
      }
    },
    "fileUpload": {
      "invalidFileTypes": "Le fichier {fileName} n'est pas au bon format",
      "invalidFileTypesWithAllowedFormats": "Le fichier {fileName} n'est pas au bon format (les formats acceptés sont : {acceptedFormats})",
      "tooManyFiles": "Vous ne pouvez importer que 20 fichiers à la fois."
    },
    "fillIn": "Compléter",
    "filters": "Filtres",
    "finish": "Terminer",
    "for": "pour",
    "from": "de",
    "help": "Aide",
    "humanizeDate": "{date, date, fullUtc}",
    "import": "Importer",
    "irpRoles": {
      "CSE": "CSE",
      "CSE_OTHER": "Autres commission(s) du CSE",
      "CSSCT": "CSSCT",
      "UNION_REPRESENTATIVE": "Délégué·e·s syndicaux·ales",
      "UNION_SECTION_REPRESENTATIVE": "Représentant·e·s de la section syndicale"
    },
    "labelWithColon": "{label} : ",
    "loading": "Chargement",
    "loadingPleaseWait": "Merci de patienter, ça ne sera pas très long, promis !",
    "logMeOutNow": "Me déconnecter maintenant",
    "logOut": "Déconnexion",
    "madeWithLoveByPaladin": "Made with <heart /> by <paladin />",
    "maxLengthField": "Ce champ ne peut pas dépasser {max, number} caractères",
    "missingInformation": "Information manquante",
    "month": "Mois",
    "moreActions": "Plus d'actions",
    "moreInformation": "Plus d'informations",
    "new": "Nouveau",
    "next": "Suivant",
    "nextDay": "Jour suivant",
    "nextWeek": "Semaine suivante",
    "no": "Non",
    "noPreference": "Aucune préférence",
    "noResult": "Aucun résultat",
    "noResults": "Aucun résultat",
    "none": "Aucun",
    "notEmptyField": "Veuillez renseigner ce champ",
    "notGreaterThanOrEqualField": "Ce champ doit être inférieur à {value}",
    "notIntegerField": "Ce champ doit être un nombre entier",
    "notNegativeField": "Ce champ doit être supérieur ou égal à 0",
    "notNumberField": "Ce champ doit être un nombre",
    "notPositiveField": "Ce champ doit être supérieur à 0",
    "notStringField": "Ce champ doit être une chaîne de caractères",
    "notes": {
      "add": "Ajouter une note",
      "appointmentNote": "Consultation",
      "author": "Par {authorName}",
      "createdAt": "Le {date, date, short} à {date, time, short}",
      "deleteConfirmation": {
        "message": "Cette action est irréversible.",
        "title": "Supprimer cette note ?"
      },
      "empty": "Aucune note n'a été ajoutée.",
      "form": {
        "content": {
          "placeholder": "Renseignez la note ici…"
        },
        "document": {
          "label": "Document"
        },
        "type": {
          "label": "Type de note",
          "placeholder": "Choisissez le type de note…"
        }
      },
      "note": "Note",
      "title": "Notes",
      "toasts": {
        "created": "La note a bien été ajoutée",
        "deleted": "La note a bien été supprimée",
        "updated": "La note a bien été modifiée"
      },
      "updatedAt": "Modifiée le {date, date, short} à {date, time, short}"
    },
    "open": "Ouvrir",
    "optionalField_f": "facultative",
    "optionalField_m": "facultatif",
    "parameters": {
      "legalInformation": {
        "consent": {
          "approvedAt": "Approuvé le {date} à {time}",
          "general": "Général",
          "medical": "Médical",
          "notifications": "Envoi de notifications",
          "pdp": "Saisie des cellules spécialisées",
          "personalDataProcessing": "Collecte et traitement des données personnelles",
          "personalDataProcessingTooltip": "Pour faire valoir vos droits d'opposition, veuillez vous adresser à notre contact légal.",
          "personalizedExperience": "Personnalisation de l'expérience via mes données",
          "readAndApprovedAt": "Lu et approuvé le {date} à {time}",
          "teleconsultation": "Visites en téléconsultation / télésoin",
          "termsOfService": "Conditions générales d'utilisation et de vente",
          "title": "Consentement"
        },
        "legalContact": {
          "copied": "Adresse copiée dans le presse-papier",
          "email": "dpo@paladin.fr",
          "failedToCopy": "Échec de la copie dans le presse-papiers",
          "title": "Contact légal",
          "yourRights": "Pour exercer vos droits ou pour toute demande relative à la protection de vos données personnelles, contactez notre délégué à la protection des données :"
        },
        "links": {
          "dmstNotice": {
            "title": "Notice sur le DMST"
          },
          "legalNotice": {
            "title": "Mentions légales"
          },
          "pdpNotice": {
            "title": "Notice sur les cellules spécialisées"
          },
          "privacyPolicy": {
            "title": "Politique de confidentialité"
          },
          "teleconsultationNotice": {
            "title": "Notice sur la téléconsultation"
          },
          "termsOfService": {
            "title": "Conditions générales d'utilisation et de vente"
          },
          "title": "Liens"
        }
      }
    },
    "preventionButton": "Accéder à l’espace prévention",
    "preventionMembershipMissing": "Votre entreprise n'est pas encore adhérente, l'espace prévention n'est pas encore accessible",
    "preventionMembershipNotStarted": "L'espace prévention sera accessible à partir du {date, date, shortUtc}, date d'adhésion de votre entreprise",
    "previous": "Précédent",
    "previousDay": "Jour précédent",
    "previousWeek": "Semaine précédente",
    "radioGroupYesOrNo": {
      "NO": "Non",
      "YES": "Oui"
    },
    "range": "de {date, date, short} à {date, date, short}",
    "ras": "RAS",
    "readOnlyField": "Cette information ne peut être modifiée que par le support Paladin",
    "requiredFieldForVisits": "Cette information est importante pour définir les visites à effectuées.",
    "requiredFields": "Champs obligatoires",
    "save": "Enregistrer",
    "saveChanges": "Enregistrer les modifications",
    "saveDraft": "Enregistrer comme brouillon",
    "saveDraftError": "Erreur lors de l’enregistrement du brouillon",
    "saveDraftSuccess": "Brouillon enregistré",
    "search": "Rechercher",
    "searchMinLength": "Saisissez au moins {count, plural, one {{count} caractère} other {{count} caractères}}",
    "searchPlaceholder": "Rechercher…",
    "shareDocumentBy": "Partagé par {name}",
    "shareDocumentFileTooLarge": "Le fichier \"{fileName}\" est trop lourd (la limite de taille est de 50mo).",
    "shareDocuments": "Partager des documents",
    "shareDocumentsDetails": "Partager vos documents de manière sécurisée avec {name}.",
    "skipStep": "Passer l’étape et ajouter",
    "standardError": "Une erreur s'est produite, merci de recommencer",
    "table": {
      "linePerPage": "Lignes par page",
      "nthPageOverTotal": "Page {page} sur {total}",
      "tableFooter": "{count, plural, =0 {Aucun résultat} one {1 résultat} other {{count} résultats}}"
    },
    "teleconsultation": {
      "documents": {
        "delete": {
          "message": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible.",
          "title": "Supprimer le document"
        },
        "empty": {
          "description": "Aucun document n'a encore été partagé.",
          "title": "Aucun document"
        },
        "title": "Documents"
      }
    },
    "teleconsultationWarning": "En choisissant la téléconsultation, vous confirmez que votre collaborateur·trice <span>consent à réaliser sa consultation à distance</span>",
    "the": "Le",
    "time": "{date, time, short}",
    "timeFromTo": "De {from, time, ::H mm} à {to, time, ::H mm}",
    "timeFromToShort": "{from, time, ::HH mm} - {to, time, ::HH mm}",
    "today": "Aujourd'hui",
    "units": {
      "beatsPerMinute": "bpm",
      "centimeter": "cm",
      "gramPerLiter": "g/L",
      "kilogram": "kg",
      "millimeterOfMercury": "mmHg",
      "minute": "min"
    },
    "unknownValue": "Non renseigné",
    "update": "Mettre à jour",
    "upload": {
      "success": "{count, plural, one {Document ajouté avec succès} other {{count} documents ajoutés avec succès}}"
    },
    "utcDate": "{date, date, mediumUtc}",
    "utcNumericDate": "{date, date, shortUtc}",
    "validate": "Valider",
    "view": "Voir",
    "week": "Semaine",
    "weekNumber": "Semaine {weekNumber, number}",
    "yes": "Oui",
    "youAreGoingToGetLoggedOut": "Vous allez être déconnecté dans 5 secondes"
  },
  "company": {
    "bookingFlow": {
      "bookActivity": {
        "activityType": {
          "label": "Type de tiers-temps"
        },
        "companySheetCallout": "Vous avez déjà réalisé une Fiche Entreprise au cours des 12 derniers mois. Vérifiez qu'elle est toujours d'actualité (déménagement, changement d'activité…) avant de confirmer ce rendez-vous.",
        "locationChoice": {
          "COMPANY_BRANCH_ADDRESS": {
            "description": "Le rendez-vous aura lieu dans les locaux de votre entreprise.",
            "title": "Dans les bureaux"
          },
          "OTHER_ADDRESS": {
            "description": "L'adresse du rendez-vous doit être propre au lieu de consultation, distincte de l'adresse SIRET du siège de l'entreprise.",
            "error": "Veuillez renseigner l'adresse du rendez-vous.",
            "title": "Autre"
          }
        },
        "recap": {
          "activityType": "Type de tiers-temps : ",
          "date": "Date : ",
          "location": "Lieu : ",
          "locationLabel": {
            "COMPANY_BRANCH": "Au bureau",
            "HEALTH_CENTER": "Au centre",
            "TELECONSULTATION": "À distance"
          },
          "reason": "Motif de la demande : ",
          "time": "Horaire : ",
          "title": "Vous allez planifier un rendez-vous :"
        },
        "submit": "Planifier le rendez-vous",
        "success": {
          "description": "Votre {activityType, select, COMPANY_BRANCH_MEETING {réunion avec un médecin} COMPANY_SHEET {rendez-vous Fiche Entreprise} other {}} avec l'équipe {occupationalHealthCenterName} {activityType, select, COMPANY_BRANCH_MEETING {est confirmée} other {est confirmé}} le {from, date, ::d MMMM y} de {from, time, ::H mm} à {to, time, ::H mm}, {slotOption, select, HEALTH_CENTER {au centre de santé {nameAndAddress}} COMPANY_BRANCH {dans vos bureaux {nameAndAddress}} TELECONSULTATION {à distance} other {}}.",
          "modificationPolicy": "Vous pouvez annuler ou modifier votre créneau tiers-temps jusqu'à 48h avant le rendez-vous ; passé ce délai, toute modification doit se faire auprès de l'équipe Paladin.",
          "nameAndAddress": "{name}, {address}"
        },
        "successTitle": "Le rendez-vous a bien été planifié !",
        "title": "Planifier un rendez-vous avec l'équipe {name}"
      },
      "planButton": "Planifier",
      "planOptions": {
        "activity": "Une réunion avec l’équipe médicale",
        "visit": "Une visite pour un.e collaborateur.trice"
      },
      "planVisitButton": "Planifier une visite"
    },
    "collaborators": {
      "absenceCallout": {
        "declared": "{absenceType, select, LONG_LEAVE {Congé longue durée déclaré} MATERNITY {Congé maternité déclaré} NON_PROFESSIONAL_ACCIDENT {Accident non professionnel déclaré} NON_PROFESSIONAL_DISEASE {Maladie non professionnelle déclarée} PARTNER_BIRTH_LEAVE {Congé de naissance déclaré} PARTNER_PARENTAL_LEAVE {Congé parental déclaré} PROFESSIONAL_ACCIDENT {Accident du travail déclaré} PROFESSIONAL_DISEASE {Maladie professionnelle déclarée} SABBATICAL {Congé sabbatique déclaré} SECONDMENT {Détachement déclaré} other {Absence déclarée}} du <b>{startDate, date, shortUtc}</b> au <b>{endDate, date, shortUtc}</b>.",
        "duration": "{count, plural, one {# jour} other {# jours}}",
        "edit": "Modifier l’absence",
        "endDate": "Date de fin prévisionnelle :",
        "reason": "Motif :",
        "returnVisit": {
          "convocation": "La convocation de visite de reprise sera envoyée à {employeeFirstName} après votre confirmation de reprise effective.",
          "details": "{start, time, short} – {end, time, short} - {practitioner} - {healthCenter}",
          "plannedVisit": "Planifiée",
          "title": "Visite de reprise : {date, date, short}"
        },
        "returnVisitBooked": "Une visite de reprise est programmée le <b>{date, date, short}</b>.",
        "startDate": "Date de début d’arrêt :",
        "toggleDetails": "Afficher ou masquer les détails de l’absence",
        "updateComment": "Motif de la modification :"
      },
      "addCollaborator": {
        "back": "Retour",
        "backToList": "Retour à la liste des collaborateurs·trices",
        "form": {
          "address": "Adresse",
          "birthDate": "Date de naissance",
          "birthLocation": "Lieu de naissance",
          "city": "Ville",
          "contractStartDate": "Date de début de contrat",
          "contractType": "Type de contrat",
          "department": "Pôle",
          "firstName": "Prénom",
          "isNewEmployee": "Nouveau·elle collaborateur·trice - je ne connais pas sa date de dernière visite",
          "jobTitle": "Poste de travail",
          "lastCheckupDateAtOnboarding": "Date de dernière visite périodique",
          "lastName": "Nom",
          "monitoringType": "Type de suivi",
          "organizationUnit": "Division",
          "pcsCode": "Code PCS",
          "personalEmail": "Email personnel",
          "phoneNumber": "Téléphone",
          "postalCode": "Code postal",
          "professionalEmail": "Email professionnel",
          "sex": "Sexe",
          "socioProfessionalCategory": "Catégorie socio-professionnelle",
          "workMode": "Mode de travail"
        },
        "invitationEmailCallout": {
          "description": "Chaque collaborateur·trice reçoit un accès à un espace personnel et sécurisé, qui permet d’accéder en toute autonomie au service de médecine du travail.",
          "title": "Ce collaborateur·trice va recevoir un email d’invitation à Paladin"
        },
        "minorCallout": "Ce/cette salarié(e) est mineur(e) : sa visite d’embauche doit être réalisée avant sa date de début de contrat, pensez à la planifier en amont.",
        "minorCalloutLink": "Planifier sa visite d’embauche",
        "next": "Suivant",
        "submit": "Ajouter",
        "success": "{name} a bien été ajouté·e à vos collaborateurs·trices !",
        "successTitle": "Collaborateur·trice ajouté·e",
        "title": "Ajouter un·e collaborateur·trice"
      },
      "confirmReturn": {
        "action": "Confirmer le retour",
        "confirmDialog": {
          "description": "Vous êtes sur le point de confirmer le retour du·de la collaborateur·trice.",
          "title": "Confirmer le retour"
        },
        "success": "Le retour a bien été confirmé."
      },
      "declareAbsence": {
        "collaborator": "Collaborateur·trice",
        "confirmDialog": {
          "description": "Vous vous apprêtez à déclarer {absenceType} pour {employeeFirstName} {employeeLastName} du <b>{startDate, date, shortUtc}</b> au <b>{endDate, date, shortUtc}</b>.",
          "title": "Déclaration d’absence"
        },
        "conflict": "Une absence est déjà déclarée pour ce·tte collaborateur·trice",
        "endDate": "Date de fin prévisionnelle",
        "reason": "Motif",
        "reasonPlaceholder": "Sélectionnez un motif",
        "startDate": "Date de début",
        "submit": "Valider",
        "success": "Absence déclarée",
        "title": "Déclarer une absence"
      },
      "deleteAbsence": {
        "action": "Supprimer l’absence",
        "confirmDialog": {
          "description": "Vous êtes sur le point de supprimer l’absence.",
          "title": "Supprimer l’absence"
        },
        "success": "Absence supprimée"
      },
      "doctorVisitCallout": "Ce·tte collaborateur·trice est exposé·e à un risque qui nécessite une visite d’embauche avec un médecin avant sa date de début de contrat : pensez à la planifier en amont.",
      "editAbsence": {
        "confirmDialog": {
          "description": "Vous êtes sur le point de modifier la date de fin d'absence.",
          "needReturnVisit": "Cette absence dépasse le seuil de {absenceDurationThreshold} jours : une visite de reprise sera planifiée automatiquement.",
          "needReturnVisitReschedule": "Si une visite de reprise était déjà planifiée, elle sera automatiquement replanifiée en fonction de la nouvelle date.",
          "title": "Modifier la date de fin prévisionnelle"
        },
        "endDate": "Date de fin prévisionnelle",
        "reason": "Motif",
        "startDate": "Date de début d’arrêt",
        "success": "Absence modifiée",
        "updateComment": "Motif de la modification",
        "updateCommentTooLong": "Le motif de la modification ne peut pas dépasser {max, number} caractères"
      },
      "finishSetup": {
        "description": "Aucune donnée n'a encore été modifiée. Veuillez terminer la configuration de votre SIRH.",
        "title": "Votre SIRH est connecté mais doit être configuré."
      },
      "hrisWarning": "Certaines informations modifiées manuellement seront écrasées lors de la prochaine synchronisation avec le SIRH. Pour identifier les champs dont la source est le SIRH, veuillez consulter notre <a>FAQ</a>.",
      "importFile": {
        "backButton": "Précédent",
        "fileUpload": {
          "callout": "Certains champs sont obligatoires pour permettre l’import :\n<ul><li>Prénom</li><li>Nom de famille</li><li>Adresse e-mail personnelle</li><li>Date de début du contrat</li></ul>\nLes lignes sans ces informations ne seront pas importées.",
          "description": "Exporter le plus de données possibles de vos systèmes pour accélérer votre import de données.",
          "downloadExample": "Télécharger un modèle",
          "dropFile": "ou glisser votre fichier",
          "fileFormat": ".CSV",
          "howToStart": "Vous ne savez pas comment commencer ?",
          "importButton": "Lancer l'import",
          "title": "Importer un fichier",
          "uploadButton": "Télécharger"
        },
        "importFailed": {
          "addCollaborator": "Ajouter un·e collaborateur·trice",
          "description": "L'import n'a pas pu être réalisé.",
          "importAnotherFile": "Importer un autre fichier",
          "relaunchImport": "Relancer l'import",
          "title": "L'import a échoué !"
        },
        "mapping": {
          "aiConfidence": "Confiance",
          "aiMapping": "Champ détecté dans le fichier",
          "confidence": {
            "high": "Élevée",
            "low": "Faible",
            "medium": "Moyenne"
          },
          "description": "Vérifiez que les champs détectés sont associés aux bons champs Paladin.",
          "error": {
            "description": "Une erreur est survenue lors de l'analyse du fichier. Veuillez réessayer.",
            "title": "Erreur lors de l'analyse du fichier"
          },
          "example": "Aperçu des données",
          "exampleInfo": "Cet aperçu de données ne montre qu'une partie des valeurs du fichier.",
          "fields": {
            "addressCity": "Ville",
            "addressLine": "Adresse",
            "addressPostalCode": "Code postal",
            "birthLastName": "Nom de famille de naissance",
            "birthLocationCode": "Lieu de naissance",
            "birthday": "Date de naissance",
            "companyBranchName": "Nom de l'établissement",
            "contractEndDate": "Date de fin du contrat",
            "contractStartDate": "Date de début du contrat",
            "contractType": "Type de contrat",
            "department": "Pôle",
            "firstName": "Prénom",
            "invalidityCategory": "Invalidité",
            "isNewEmployee": "Aucun historique médecine et prévention au travail",
            "jobTitle": "Poste de travail",
            "lastCheckupDateAtOnboarding": "Date de dernière visite périodique",
            "lastName": "Nom de famille",
            "nextPeriodicCheckup": "Date de prochaine visite théorique",
            "none": "-- Aucun champ --",
            "organizationUnit": "Division",
            "pcsCode": "Code PCS",
            "personalEmail": "Adresse e-mail personnelle",
            "phoneNumber": "Numéro de téléphone",
            "placeholder": "Sélectionner un champ",
            "professionalEmail": "Adresse e-mail professionnelle",
            "recognitionEndDate": "Date de fin de RQTH",
            "recognitionStartDate": "Date de début de RQTH",
            "sex": "Sexe",
            "siret": "Numéro SIRET",
            "socioProfessionalCategory": "Catégorie socio-professionnelle",
            "workMode": "Mode de travail"
          },
          "loading": {
            "description": "Merci de patienter, ça ne sera pas très long, promis !",
            "title": "Analyse du fichier en cours"
          },
          "missingFieldsModal": {
            "cancel": "Retour",
            "confirm": "Ignorer et continuer",
            "title": "Attention, certains champs ne sont pas reliés"
          },
          "nextButton": "Suivant",
          "paladinField": "Champ Paladin",
          "previewButton": "Prévisualiser",
          "revertToAiMapping": "Revenir au mapping proposé",
          "title": "Association des champs"
        },
        "preview": {
          "backButton": "Retour",
          "backToEmployees": "Retour à la liste des collaborateurs·trices",
          "description": "Vérifiez que les données sont correctement importées.",
          "error": {
            "description": "Une erreur est survenue lors de l'import. Veuillez réessayer.",
            "title": "Erreur lors de l'import"
          },
          "importButton": "Importer",
          "invitationEmailCallout": {
            "description": "Chaque collaborateur·trice reçoit un accès à un espace personnel et sécurisé, qui permet d’accéder en toute autonomie au service de médecine du travail.",
            "title": "Ces collaborateurs·trices vont recevoir un email d’invitation à Paladin"
          },
          "loading": {
            "description": "Merci de patienter, ça ne sera pas très long, promis !",
            "title": "Import en cours"
          },
          "success": {
            "description": "Les données ont été importées avec succès.",
            "ignoredFields": {
              "department": "La colonne Pôle a été ignorée : le Pôle est alimenté par votre SIRH."
            },
            "notImportedReasons": {
              "COMPANY_BRANCH_NAME_MISMATCH": "{count, plural, one {Le nom d'établissement ne correspond pas} other {Les noms d'établissement ne correspondent pas}}",
              "DUPLICATE_COLLABORATOR": "{count, plural, one {Collaborateur·trice déjà existant·e} other {Collaborateurs·trices déjà existant·e·s}}",
              "INVALID_EMAIL": "{count, plural, one {Adresse e-mail invalide} other {Adresses e-mail invalides}}",
              "MISSING_MANDATORY_FIELDS": "{count, plural, one {Champ obligatoire manquant} other {Champs obligatoires manquants}}",
              "SIRET_MISMATCH": "{count, plural, one {SIRET ne correspond pas à l'établissement} other {SIRET ne correspondent pas aux établissements}}",
              "UNEXPECTED_ERROR": "{count, plural, one {Erreur inattendue} other {Erreurs inattendues}}",
              "andOthers": "{count, plural, one {et 1 autre} other {et {count} autres}}",
              "title": "Détail des non-importé·e·s"
            },
            "title": "Import réussi !"
          },
          "title": "Prévisualisation des données"
        }
      },
      "importHris": {
        "connection": {
          "description": "Merci de patienter, ça ne sera pas très long, promis !",
          "title": "Connexion à l'API..."
        },
        "import": {
          "loading": {
            "description": "Merci de patienter, ça ne sera pas très long, promis !",
            "title": "Import des données en cours..."
          },
          "success": {
            "backToCollaborators": "Retour à la liste des collaborateurs·trices",
            "description": "L'ensemble de vos données SIRH ont bien été synchronisées.",
            "imported": "{count, plural, one {Collaborateur·trice importé·e} other {Collaborateurs·trices importé·e·s}} avec succès",
            "incomplete": "{count, plural, one {Collaborateur·trice non importé·e} other {Collaborateurs·trices non importé·e·s}} à cause de données manquantes",
            "nextStep": "Importez les documents de suivi existants (ex. attestations de suivi) pour compléter les données de vos collaborateurs·trices, comme la date de la dernière visite.",
            "title": "Import réussi !"
          }
        },
        "preview": {
          "backButton": "Retour",
          "description": "Voici un aperçu de quelques collaborateurs·trices sélectionné·e·s aléatoirement.<br/>Vérifiez et validez les données avant de lancer l'import.",
          "importButton": "Importer les collaborateurs·trices",
          "invitationEmailCallout": {
            "description": "Chaque collaborateur·trice reçoit un accès à un espace personnel et sécurisé, qui permet d’accéder en toute autonomie au service de médecine du travail.",
            "title": "Ces collaborateurs·trices vont recevoir un email d’invitation à Paladin"
          },
          "title": "Prévisualisation de l'import"
        }
      },
      "information": {
        "absences": {
          "aucuneAbsence": "Aucune absence",
          "aucuneAbsenceDescription": "Aucune absence n’a encore été enregistrée.",
          "ongoing": "En cours",
          "period": "Du {startDate, date, shortUtc} au {endDate, date, shortUtc}",
          "upcoming": "À venir"
        },
        "backToList": "Retour à la liste des collaborateurs·trices",
        "disabilityCard": {
          "declared": "Déclaré",
          "edit": "Modifier le handicap",
          "invalidityCategory": "Invalidité",
          "noInvalidityCategory": "Aucune",
          "notDeclared": "Non déclaré",
          "recognitionEndDate": "Date de fin de reconnaissance",
          "recognitionOfDisabledWorkerStatus": "RQTH",
          "recognitionStartDate": "Date de reconnaissance",
          "title": "Handicap"
        },
        "documentsCard": {
          "addedBy": "Par {name}",
          "createdAt": "Ajouté le {date, date, short} à {date, time, short}",
          "delete": {
            "cta": "Supprimer l'attestation",
            "message": "Cette action est définitive. Les dates de visite renseignées à partir de ce document ne seront pas modifiées.",
            "success": "Attestation supprimée",
            "title": "Supprimer cette attestation ?"
          },
          "noDocument": "Aucun document",
          "noDocumentDescription": "Aucun document n'a encore été ajouté au dossier de votre collaborateur·trice.",
          "title": "Documents",
          "upload": {
            "cta": "Ajouter une attestation",
            "error": "Le document n'a pas pu être importé",
            "nameMismatch": {
              "confirm": "Importer quand même",
              "readName": "Nom lu sur le document : {name}",
              "unreadableName": "Aucun nom n'a pu être lu sur le document.",
              "warning": "Ce document ne semble pas être au nom de ce·tte collaborateur·trice. Vérifiez qu'il s'agit bien de la bonne personne avant de l'importer."
            },
            "notUpdatedTooOld": "Aucune information modifiée : l'attestation est plus ancienne que la dernière visite connue",
            "submit": "Importer l'attestation",
            "successWithDates": "Document importé, les dates de visite ont été mises à jour",
            "title": "Importer une attestation"
          }
        },
        "expectedInformation": {
          "BIRTH_DATE": "<bold>Date de naissance</bold>",
          "CONTRACT_TYPE": "<bold>Type de contrat</bold>",
          "JOB_TITLE": "<bold>Poste de travail</bold>",
          "MEDICAL_DATA": "<bold>Date de dernière et/ou prochaine visite</bold> (hors nouveau·elle collaborateur·trice)",
          "PROFESSIONAL_RISK": "<bold>Risque professionnel</bold>",
          "callout": "Complétez les informations suivantes du·de la collaborateur·trice pour activer la planification des visites :"
        },
        "header": {
          "absentIndicator": "En absence",
          "contractFrom": "Depuis le :",
          "contractType": "Type de contrat :",
          "department": "Pôle :",
          "inviteEmployeeButton": "Inviter",
          "organizationUnit": "Division :",
          "reinviteEmployeeButton": "Ré-inviter",
          "workstation": "Poste de travail :"
        },
        "identityCard": {
          "birthLocation": "Lieu de naissance",
          "birthday": "Date de naissance",
          "cancel": "Annuler",
          "edit": "Modifier les informations d’identité",
          "firstName": "Prénom",
          "fullName": "Nom",
          "lastName": "Nom",
          "sex": "Sexe",
          "submit": "Enregistrer",
          "title": "Informations d'identité"
        },
        "invitationToast": {
          "inviteEmployeeButtonError": "Erreur lors de l'envoi de l'invitation",
          "inviteEmployeeButtonSuccess": "Invitation envoyée avec succès"
        },
        "modificationHistory": {
          "createdBy": "Créé par {firstName} {lastName}",
          "createdByPaladin": "Créé par Paladin",
          "createdLabel": "Création de la fiche collaborateur·trice",
          "identityValidation": {
            "description": "Validé par {firstName} {lastName}",
            "title": "Validation d'identité"
          },
          "noShow": {
            "consultationType": {
              "IN_PERSON_CONSULTATION": "présentiel",
              "TELECONSULTATION": "téléconsultation"
            },
            "description": "Planifiée le {date, date, ::d MMMM y} de {from, time, ::H mm} à {to, time, ::H mm}",
            "title": "Non présentation à une {appointmentType}"
          },
          "updatedBy": "Modifié par {firstName} {lastName}",
          "updatedByPaladin": "Modifié par Paladin",
          "updatedField": "Changement de "
        },
        "notesCard": {
          "createTitle": "Ajouter une note",
          "createdLine": "Le {date, date, dateTime}",
          "deleteConfirmation": {
            "message": "Êtes-vous sûr de vouloir supprimer cette note ? Cette action est irréversible.",
            "title": "Supprimer la note"
          },
          "editTitle": "Modifier la note",
          "form": {
            "content": {
              "label": "Note",
              "placeholder": "Renseignez la note ici..."
            }
          },
          "toasts": {
            "created": "Note créée",
            "deleted": "Note supprimée",
            "updated": "Note modifiée"
          },
          "updatedLine": "Modifiée par {authorName} le {date, date, dateTime}"
        },
        "organizationCard": {
          "departmentLockedByHris": "Alimenté par votre SIRH",
          "edit": "Modifier l'organisation",
          "title": "Organisation"
        },
        "personalCard": {
          "address": "Adresse",
          "addressCity": "Ville",
          "addressPostalCode": "Code postal",
          "edit": "Modifier les informations personnelles",
          "personalEmail": "Email personnel",
          "phoneNumber": "Téléphone",
          "professionalEmail": "Email professionnel",
          "title": "Informations personnelles"
        },
        "professionalCard": {
          "contractEndDate": "Date de fin du contrat",
          "contractStartDate": "Date de début du contrat",
          "contractType": "Type de contrat",
          "edit": "Modifier le suivi professionnel",
          "isNewEmployee": "Nouveau·elle collaborateur·trice",
          "lastCheckupDate": "Date de dernière visite périodique",
          "nextPeriodicCheckup": "Date de prochaine visite théorique",
          "pcsCode": "Profession INSEE",
          "socioProfessionalCategory": "Catégorie socioprofessionnelle",
          "title": "Suivi professionnel",
          "workMode": "Mode de travail",
          "workstation": "Poste de travail"
        },
        "risksCard": {
          "addRisk": "Ajouter un risque",
          "addRiskToCompany": "Ajouter un risque à votre entreprise",
          "manageDuerp": "Gérer le DUERP",
          "noRisks": "Aucun risque n’est encore associé à ce collaborateur·trice",
          "noWorkUnitRisks": "Aucun risque professionnel n’est associé à ce collaborateur·trice",
          "title": "Risques professionnels"
        },
        "sidebarTabs": {
          "absences": "Absences",
          "documents": "Documents",
          "visites": "Visites"
        },
        "tabs": {
          "history": "Historique",
          "informations": "Informations"
        },
        "unknownMonitoringType": "Type de suivi inconnu",
        "visites": {
          "aVenir": "Visites à venir",
          "aucuneAVenir": "Aucune visite à venir",
          "aucunePassee": "Aucune visite passée",
          "aucuneVisite": "Aucune visite",
          "aucuneVisiteDescription": "Aucune visite n’a encore été programmée.",
          "byPractitioner": "Par {practitioner}",
          "passees": "Visites passées"
        }
      },
      "initialSync": {
        "description": "Les données de votre SIRH sont en cours de synchronisation et seront bientôt disponibles pour revue.",
        "title": "Votre SIRH est connecté et effectue sa première synchronisation."
      },
      "medicalAttestationsReview": {
        "description": "Les correspondances sûres sont validées automatiquement, sans action requise. Les correspondances « à vérifier » et « sans correspondance » attendent votre confirmation.",
        "matchLevel": {
          "CERTAIN": "Haut",
          "NO_MATCH": "Aucun",
          "TO_VERIFY": "Moyen"
        },
        "outcomes": {
          "CERTAIN": {
            "comment": "Nom, prénom et date de naissance identiques",
            "title": "Correspondances sûres"
          },
          "NO_MATCH": {
            "comment": "Aucun·e collaborateur·trice trouvé·e dans les effectifs",
            "title": "Sans correspondance"
          },
          "TO_VERIFY": {
            "comment": "Accent, nom composé ou date de naissance proche",
            "title": "Correspondances à vérifier"
          }
        },
        "table": {
          "accept": "Valider l'attestation",
          "accepted": "Validée",
          "attestation": "Attestation importée",
          "bornAt": "Né·e le {date}",
          "collaborator": "Collaborateur·trice",
          "confidence": "Niveau de confiance",
          "empty": "Aucune attestation dans cette catégorie.",
          "manualSelection": "Choix manuel",
          "noBirthDate": "Date de naissance non lue",
          "noCollaboratorFound": "Aucun·e collaborateur·trice trouvé·e",
          "noName": "Nom et prénom non lus",
          "readData": "Données lues sur l'attestation",
          "reject": "Rejeter l'attestation",
          "rejected": "Refusée",
          "searchCollaborator": "Rechercher dans les effectifs",
          "selectCollaborator": "Choisir un·e collaborateur·trice",
          "status": "Statut"
        },
        "title": "Résultat matching"
      },
      "switchCompanyBranch": {
        "confirm": "Changer d'établissement",
        "description": "Ses visites, ses documents et ses informations d'organisation suivront dans le nouvel établissement.",
        "menuItem": "Changer d'établissement",
        "selectLabel": "Nouvel établissement",
        "success": "{firstName} {lastName} a été déplacé·e vers {companyBranch}",
        "title": "Changer {firstName} {lastName} d'établissement"
      },
      "syncInProgress": {
        "description": "La première synchronisation peut prendre un moment. Vous pouvez fermer cette page et revenir plus tard.",
        "title": "La récupération de vos collaborateurs·trices depuis votre SIRH est en cours"
      },
      "syncPreview": {
        "backToCollaborators": "Retour à la liste des collaborateurs·trices",
        "columns": {
          "updates": "Modifications à appliquer"
        },
        "confirmDialog": {
          "cancel": "Annuler",
          "description": "Cette action fera de votre SIRH la source de vérité et appliquera les opérations affichées dans les 4 onglets. Cette action est irréversible.",
          "title": "Confirmer la synchronisation"
        },
        "description": "Voici ce que la prochaine synchronisation avec votre SIRH changerait. Aucune donnée n'est modifiée à cette étape.",
        "error": "La prévisualisation n'a pas pu être récupérée. La première synchronisation au SIRH peut prendre plusieurs minutes. Réessayez dans quelques instants.",
        "identity": {
          "address": "Adresse : ",
          "birthdate": "Date de naissance : ",
          "contractEndDate": "Date de fin du contrat : ",
          "contractStartDate": "Date de début du contrat : ",
          "contractType": "Type de contrat : ",
          "department": "Pôle : ",
          "firstName": "Prénom : ",
          "jobTitle": "Poste de travail : ",
          "lastName": "Nom : ",
          "phoneNumber": "Téléphone : ",
          "professionalEmail": "Email professionnel : ",
          "sex": "Sexe : "
        },
        "loading": {
          "title": "Récupération des données de votre SIRH…"
        },
        "sync": "Synchroniser",
        "syncNow": "Synchroniser maintenant",
        "syncingNow": "Synchronisation en cours…",
        "tabs": {
          "matchingUsers": {
            "description": "Ces collaborateurs·trices existent déjà dans Paladin : leurs informations seraient mises à jour avec celles de votre SIRH.",
            "label": "Mises à jour"
          },
          "missingInformation": {
            "description": "Ces collaborateurs·trices ne peuvent pas être importé·e·s : des informations obligatoires sont manquantes dans votre SIRH.",
            "label": "Informations manquantes"
          },
          "newUsers": {
            "description": "Ces collaborateurs·trices sont présent·e·s dans votre SIRH mais pas encore dans Paladin : ils·elles seraient créé·e·s.",
            "label": "Nouveaux·elles collaborateurs·trices"
          },
          "noMatch": {
            "description": "Ces collaborateurs·trices sont présent·e·s dans Paladin mais introuvables dans votre SIRH : leur contrat serait clôturé à la date du jour.",
            "label": "Absent·e·s du SIRH",
            "warning": "Si ces collaborateurs·trices ont des visites prévues, elles seront annulées."
          }
        },
        "title": "Prévisualisation SIRH"
      },
      "table": {
        "addCollaborator": "Ajouter un·e collaborateur·trice",
        "columns": {
          "contractType": "Type de contrat",
          "invitationStatus": {
            "header": "Statut du compte",
            "labels": {
              "active": "Actif",
              "invitationSentShort": "Invitation le {date, date, short}",
              "notInvited": "Non invité"
            }
          },
          "jobTitle": "Poste de travail",
          "lastVisitDate": "Date de\ndernière visite",
          "monitoringType": "Type de suivi",
          "name": "Collaborateur·trice",
          "nextPlannedVisitDate": "Date de prochaine\nvisite planifiée",
          "nextTheoreticalVisitDate": "Date de prochaine\nvisite théorique"
        },
        "configureHris": "Configurer votre SIRH",
        "connectHrisSuccess": "Votre SIRH a bien été configuré.",
        "empty": {
          "absences": "Aucune absence en cours",
          "deactivated": "Aucun compte désactivé",
          "description": "Ajoutez des collaborateurs·trices pour commencer à utiliser Paladin.",
          "filters": "Aucun·e collaborateur·trice ne correspond aux filtres"
        },
        "exportCollaborators": "Exporter",
        "exportError": "Erreur lors de l'export des collaborateurs·trices",
        "exportSuccess": "{count, plural, one {{count} collaborateur·trice exporté·e} other {{count} collaborateurs·trices exporté·e·s}}",
        "filters": {
          "contractType": "Type de contrat",
          "monitoringType": "Type de suivi"
        },
        "finishHris": "Terminer l'intégration SIRH",
        "groups": {
          "employeeCount": "{count, plural, one {# collaborateur·trice} other {# collaborateurs·trices}}",
          "empty": "Aucun·e collaborateur·trice dans ce groupe"
        },
        "importFile": "Importer des collaborateurs·trices",
        "importHris": "Intégrer mon SIRH",
        "inviteAllEmployees": "Inviter les nouveaux·elles collaborateurs·trices",
        "inviteAllEmployeesModal": {
          "confirmButton": "Envoyer les invitations",
          "content": "En validant, vous adresserez une invitation uniquement <bold>aux collaborateurs·trices n'ayant jamais reçu d'e-mail d'invitation et n'ayant pas encore activé leur compte</bold>.",
          "title": "Inviter des collaborateurs·trices"
        },
        "inviteAllEmployeesSuccessCount": "{count, plural, one {{count} invitation envoyée} other {{count} invitations envoyées}} avec succès",
        "inviteAllEmployeesSuccessModal": {
          "backButton": "Retour à la liste des collaborateurs·trices",
          "content": "{count} invitations envoyées avec succès.",
          "contentNoInvitations": "Aucun·e collaborateur·trice n'est éligible : tous·tes ont déjà reçu une invitation ou ont activé leur compte.",
          "title": "Invitations envoyées",
          "titleNoInvitations": "Aucune invitation envoyée"
        },
        "reinviteAllEmployeesModal": {
          "confirmButton": "Renvoyer les invitations",
          "content": "En validant, vous renverrez une invitation <bold>uniquement aux collaborateurs·trices qui ont déjà reçu un e-mail d'invitation mais n'ont pas encore activé leur compte</bold>.",
          "title": "Ré-inviter des collaborateurs·trices"
        },
        "reinviteAllEmployeesSuccessModal": {
          "backButton": "Retour à la liste des collaborateurs·trices",
          "content": "{count} invitations renvoyées avec succès.",
          "contentNoInvitations": "Aucun·e collaborateur·trice n'est éligible : soit tous·tes ont activé leur compte, soit aucune invitation n'avait encore été envoyée.",
          "title": "Invitations renvoyées",
          "titleNoInvitations": "Aucune invitation renvoyée"
        },
        "reinviteEmployees": "Ré-inviter les comptes non activés",
        "resyncHris": "Synchroniser les données SIRH",
        "tabs": {
          "absences": "Absent·e·s",
          "all": "Tous·tes",
          "deactivated": "Désactivé·e·s"
        },
        "title": "Collaborateurs·trices",
        "updateExistingInfo": "Mettre à jour les informations existantes"
      },
      "updateFile": {
        "fileUpload": {
          "callout": "La mise à jour se fera en correspondance avec l'adresse e-mail du·de la collaborateur·trice.\nLes lignes sans cette information seront ignorées.",
          "description": "Utilisez un fichier pour mettre à jour le plus de données possible et gagner du temps.",
          "dropFile": "ou glisser votre fichier",
          "emptyColumnWarning": "Attention : si vous importez une colonne vide, elle sera considérée comme une demande d'effacer les données précédemment renseignées.\nPar exemple : si vous importez un fichier avec la colonne Date de naissance vide, toutes les dates de naissance renseignées au préalable seront supprimées. Par contre, si votre fichier de mise à jour ne comporte pas de colonne Date de naissance, rien ne sera modifié.",
          "fileFormat": ".CSV",
          "howToStart": "Exportez vos collaborateurs·trices pour mettre à jour le fichier avec les bonnes données.",
          "importButton": "Lancer la mise à jour",
          "title": "Importer un fichier",
          "uploadButton": "Télécharger"
        },
        "preview": {
          "backToEmployees": "Retour à la liste des collaborateurs·trices",
          "updateButton": "Mettre à jour les collaborateurs·trices"
        }
      },
      "waitingForApproval": {
        "description": "Aucune donnée n'a encore été modifiée. Vérifiez les changements avant de lancer la synchronisation.",
        "title": "Votre SIRH est connecté et prêt à être synchronisé."
      }
    },
    "dashboard": {
      "activities": {
        "callout": {
          "activityTypeLabel": {
            "AMT": "une Action en Milieu de Travail programmée",
            "COMPANY_BRANCH_MEETING": "une réunion avec un professionnel de santé programmée",
            "COMPANY_SHEET": "un rendez-vous Fiche Entreprise programmé",
            "HEALTH_SCREENING": "un dépistage programmé",
            "IRP_MEETING": "une réunion des Instances Représentatives du Personnel programmée"
          },
          "description": "Vous avez {activityTypeLabel} le {date, date, full}."
        }
      },
      "calendar": {
        "date": "{date, date, ::EEEE d MMMM}",
        "dateToday": "{date, date, ::EEEE d MMMM} (aujourd'hui)",
        "empty": "Aucune visite n'est programmée pour ce jour.",
        "panelTitle": "Visites du jour",
        "remainingItems": "+ {count, plural, one {# autre} other {# autres}}",
        "title": "Calendrier",
        "viewAll": "Voir toutes les visites"
      },
      "documents": {
        "empty": "Aucun nouveau document n'est disponible.",
        "panelTitle": "Documents",
        "remainingItems": "+ {count, plural, one {# autre} other {# autres}}",
        "title": "Documents"
      },
      "empty": {
        "button": "Continuer l'onboarding",
        "description": "Nous n'avons à date pas assez d'informations concernant les données de vos collaborateurs·trices pour vous proposer l'affichage du tableau de bord."
      },
      "kpis": {
        "actionLabel": "Voir les détails",
        "inactiveAccounts": {
          "badgeLabel": "Relance requise",
          "label": "{count, plural, =0 {Comptes collaborateurs·trices non activés} one {Compte collaborateur·trice non activé} other {Comptes collaborateurs·trices non activés}}",
          "panel": {
            "empty": "Aucun compte en attente d'activation.",
            "invitationSentAt": "Invitation le {date}",
            "reinvite": "Ré-inviter",
            "reinviteAll": "Ré-inviter tous les comptes non activés",
            "reinviteError": "Erreur lors de l'envoi de l'invitation",
            "reinviteSuccess": "Invitation envoyée avec succès",
            "reinvited": "Invité",
            "status": "Relance requise",
            "title": "Comptes collaborateurs·trices non activés"
          }
        },
        "noShows": {
          "badgeLabel": "Non-présentation",
          "label": "{count, plural, =0 {Aucune ces 7 derniers jours} one {Non-présentation ces 7 derniers jours} other {Non-présentations ces 7 derniers jours}}",
          "panel": {
            "empty": "Aucune non-présentation ces 7 derniers jours.",
            "status": "Non-présentation",
            "title": "Non-présentations"
          }
        },
        "priorityActions": {
          "badgeLabel": "Urgent",
          "label": "{count, plural, =0 {Aucune action urgente à traiter} one {Action à traiter en priorité} other {Actions à traiter en priorité}}",
          "panel": {
            "actionsTitle": "Actions :",
            "empty": "Aucune action à traiter en priorité.",
            "missingInformation": {
              "BIRTH_DATE": "Date de naissance",
              "CONTRACT_TYPE": "Type de contrat",
              "JOB_TITLE": "Poste de travail",
              "MEDICAL_DATA": "Données de suivi médical",
              "PROFESSIONAL_RISK": "Risque professionnel"
            },
            "missingInformationTitle": "Informations collaborateurs·trices manquantes :",
            "onboarding": {
              "label": "Onboarding",
              "status": "À finaliser"
            },
            "title": "Actions à traiter en priorité"
          }
        },
        "remainingItems": "{count, plural, one {+ # autre} other {+ # autres}}"
      },
      "medicalImport": {
        "completedCta": "Accéder au matching",
        "completedDescription": "{importedCount, plural, one {# fichier importé} other {# fichiers importés}}, {awaitingReviewCount, plural, one {# attend une validation manuelle} other {# attendent une validation manuelle}}",
        "completedDescriptionAwaitingOnly": "{awaitingReviewCount, plural, one {# fichier attend une validation manuelle} other {# fichiers attendent une validation manuelle}}",
        "completedTitle": "Import des attestations finalisé",
        "runningTitle": "Import des attestations en cours..."
      },
      "title": "Bonjour {name} 👋",
      "visitTracking": {
        "tabs": {
          "currentWeek": {
            "empty": "Aucune visite n'est programmée pour cette semaine.",
            "label": "Cette semaine",
            "panelTitle": "Visites de la semaine",
            "remainingItems": "<strong>+ {count, plural, one {# autre} other {# autres}}</strong> cette semaine"
          },
          "lastWeek": {
            "empty": "Aucune visite n'a eu lieu la semaine passée.",
            "label": "Semaine passée",
            "panelTitle": "Visites de la semaine passée",
            "remainingItems": "<strong>+ {count, plural, one {# autre} other {# autres}}</strong> la semaine passée"
          },
          "viewAll": "Voir toutes les visites"
        },
        "title": "Suivi des visites"
      },
      "visitsToMonitor": {
        "remainingItems": "+ {count, plural, one {# autre} other {# autres}}",
        "tabs": {
          "ghosted": {
            "deadline": "Avant le {date}",
            "label": "Ghost",
            "panelTitle": "Visites Ghost",
            "planVisit": "Planifier la visite"
          },
          "lateVisits": {
            "empty": "Toutes les visites à venir sont à jour.",
            "label": "En retard",
            "panelTitle": "Visites en retard"
          },
          "pendingConfirmation": {
            "empty": "Toutes les visites à venir sont confirmées.",
            "label": "Non-confirmées",
            "panelTitle": "Visites non confirmées",
            "resend": "Relancer",
            "resendError": "Erreur lors de l'envoi de la relance",
            "resendSuccess": "Relance envoyée avec succès",
            "resent": "Relancé",
            "warning": "Les visites planifiées automatiquement et non confirmées seront automatiquement annulées dans un délai dépendant de la date à laquelle la visite a été planifiée."
          },
          "reprises": {
            "confirm": "Confirmer",
            "empty": "Aucune visite de reprise n'est programmée.",
            "label": "Reprises",
            "panelTitle": "Visites de reprise",
            "period": "{startDate, date, shortUtc} → {endDate, date, shortUtc}",
            "returnDate": "Reprise le {date, date, short}",
            "warning": "{count, plural, one {Vous avez # reprise à confirmer.} other {Vous avez # reprises à confirmer.}}"
          }
        },
        "title": "Visites à surveiller",
        "viewAll": "Voir toutes les visites"
      },
      "webinarReplays": {
        "duerp": "Webinaire DUERP - juillet 2026",
        "papripact": "Webinaire PAPRIPACT 2026",
        "title": "Nos derniers webinaires"
      }
    },
    "documents": {
      "add": "Ajouter un document",
      "certificates": {
        "empty": "Aucune attestation n'a encore été partagée.",
        "title": "Attestations"
      },
      "companySheet": {
        "badge": {
          "deleted": "Supprimée",
          "expireIn": "Expire dans {count, plural, one {# jour} other {# jours}}",
          "expired": "Expirée",
          "upToDate": "À jour"
        },
        "companySheetFileName": "Fiche_Entreprise_{date, date, ::y}.pdf",
        "deleteDialog": {
          "cancelButton": "Annuler",
          "confirmButton": "Confirmer la suppression",
          "description": "Cette fiche sera marquée \"Supprimée\" et déplacée dans l'historique.<br />Elle restera accessible et téléchargeable par l'équipe médicale,<br />mais ne sera pas visible par votre adhérent.",
          "error": "Échec de la suppression de la fiche entreprise",
          "success": "La Fiche Entreprise a bien été supprimée",
          "title": "Êtes-vous sûr de vouloir supprimer la fiche entreprise ?"
        },
        "dialog": {
          "button": "Importer",
          "label": "Date de validité",
          "title": "Importer une fiche entreprise",
          "validationDateLabel": "Date de réalisation"
        },
        "download": "Télécharger la fiche",
        "empty": {
          "label": "Aucune fiche entreprise importée"
        },
        "emptyState": "Aucune fiche entreprise n'a encore été partagée.",
        "history": {
          "title": "Historique"
        },
        "importButton": "Importer une fiche entreprise",
        "importButtonList": "Importer une fiche entreprise",
        "title": "Fiche entreprise",
        "upToDate": "À jour",
        "upload": {
          "error": "Échec de l'import de la fiche entreprise",
          "success": "La Fiche entreprise a bien été ajoutée"
        },
        "uploadedAt": "Importé le {date, date, short} à {date, time, short} par {createdBy}",
        "validityDate": "Date de validité : "
      },
      "confirmDelete": {
        "message": "Cette action est irréversible.",
        "title": "Êtes-vous sûr·e de vouloir supprimer ce document ?"
      },
      "duerp": {
        "document": {
          "add": "Ajouter un fichier",
          "confirmDelete": {
            "message": "L'équipe de Sano n'y aura plus accès.<br />Vous pourriez être amené·e à être recontacté·e.",
            "title": "Êtes-vous sûr·e de vouloir supprimer votre DUERP de votre espace adhérent ?"
          },
          "empty": "Aucun DUERP n'a encore été partagé."
        },
        "help": {
          "description": "Une liste d'outils en ligne pour vous aider",
          "openExternalLink": "Ouvrir le lien",
          "title": "Aide au DUERP",
          "tools": {
            "altrex": "Outil d’analyse des mesures de substances chimiques",
            "categories": {
              "chemical": "Risques chimiques",
              "general": "Généralistes"
            },
            "ihmod": "Modélisation de l’exposition aux agents chimiques (Excel)",
            "mixie": "Évaluation des effets des polyexpositions chimiques",
            "oira": "Outils d’évaluation des risques par secteur (TPE/PME)",
            "seirich": "Logiciel d'identification des risques chimiques de l'entreprise"
          }
        },
        "support": {
          "active": "Vous êtes accompagné·e par Sano !",
          "badge": {
            "active": "Accompagné·e",
            "none": "Non accompagné·e"
          },
          "followUp": "Suivre mes échanges",
          "none": "Vous n'êtes pas encore accompagné·e pour votre DUERP.",
          "requestSupport": "Être recontacté·e",
          "title": "Être accompagné·e"
        },
        "title": "DUERP"
      },
      "other": {
        "empty": "Aucun document n'a encore été partagé.",
        "title": "Autres documents"
      },
      "table": {
        "columns": {
          "createdAt": {
            "content": "{date, date, short}",
            "header": "Date d'ajout"
          },
          "createdBy": "Ajouté par",
          "fileName": "Nom du fichier"
        }
      },
      "title": "Documents",
      "upload": {
        "error": "Erreur lors de l'import du document",
        "success": "Document importé avec succès"
      }
    },
    "employeeGroups": {
      "departmentCount": "{count, plural, one {# pôle} other {# pôles}}",
      "noDepartment": "Sans Pôle",
      "noOrganizationUnit": "Sans Division"
    },
    "filters": {
      "applyFilters": "Valider",
      "button": "{count, plural, =0 {Filtres} other {Filtres ({count})}}",
      "title": "Filtres"
    },
    "memberSpace": {
      "activities": {
        "cancel": {
          "confirmButton": "Confirmer la suppression",
          "success": "Le rendez-vous a bien été annulé",
          "title": "Êtes-vous sûr·e de vouloir supprimer ce rendez-vous ?",
          "warning": {
            "description": "Vous ne pouvez pas annuler ce rendez-vous (délais dépassés).\n\nEn cas d’empêchement exceptionnel, merci de contacter directement le service de santé.",
            "title": "Ce rendez-vous ne peut pas être annulé"
          }
        },
        "empty": "Aucun rendez-vous n’a encore été programmé.",
        "tabs": {
          "past": "Passé",
          "upcoming": "À venir"
        }
      },
      "cseReferent": {
        "updateSuccess": "Le·la référent·e CSE a été mis·e à jour"
      },
      "description": "Accédez à toutes les informations de votre entreprise depuis cet espace adhérent.",
      "hrReferent": {
        "updateSuccess": "Le·la référent·e RH a été mis·e à jour"
      },
      "irpSpace": {
        "meetingsTab": {
          "empty": "Aucune réunion n’a encore été programmée.",
          "title": "Réunions"
        },
        "staffRepresentativesTab": {
          "description": "Votre entreprise dispose d’une ou plusieurs instances représentatives du personnel",
          "edit": "Modifier",
          "empty": "Votre entreprise ne dispose d’aucune instance représentative du personnel",
          "selectEmployees": "Sélectionner les collaborateurs·trices",
          "title": "Référent·e·s",
          "updateSuccess": "Les représentant·e·s du personnel ont été mis·e·s à jour"
        }
      },
      "occupationalHealthPhysicianReferent": {
        "empty": "Aucun médecin référent n’a encore été renseigné pour votre entreprise."
      },
      "preferences": {
        "IN_PERSON_CONSULTATION": {
          "active": "Présentiel forcé",
          "description": "Lorsque cette option est activée, les visites médicales de vos collaborateurs·trices seront systématiquement organisées en présentiel.",
          "descriptionBold": "Ce paramètre s'applique uniquement aux consultations planifiées automatiquement.",
          "title": "Forcer les visites en présentiel",
          "warning": {
            "description": "En activant ce paramètre, aucune visite ne sera orientée en téléconsultation, y compris pour les collaborateurs·trices qui auraient pu en bénéficier. Ce choix peut allonger les délais de prise en charge selon les disponibilités de votre SPSTI.",
            "title": "Tous·tes vos collaborateurs·trices sont concerné·e·s"
          }
        },
        "TELECONSULTATION": {
          "active": "TLC activée",
          "description": "Lorsque cette option est activée, les visites médicales de vos collaborateurs·trices éligibles seront automatiquement orientées en téléconsultation.",
          "title": "Forcer la téléconsultation (TLC)",
          "warning": {
            "description": "<p>La TLC s'applique uniquement aux collaborateurs·trices <em>éligibles</em>, c'est-à-dire celles et ceux ne nécessitant pas de <lnk> suivi renforcé </lnk>.</p><p>Les collaborateurs·trices concerné·e·s par un suivi renforcé (travailleurs·euses exposé·e·s à des risques particuliers, femmes enceintes, travailleurs·euses de nuit...) continuent de bénéficier de visites en présentiel.</p>",
            "title": "Collaborateurs·trices concerné·e·s"
          }
        },
        "autoSendInvitations": {
          "title": "Envoi automatique des invitations de création de comptes aux nouveaux·elles collaborateurs·trices"
        },
        "sir": {
          "close": "J'ai compris",
          "message": "<p>Le suivi individuel renforcé (SIR) est une obligation réglementaire pour certaines catégories de travailleurs·euses.<br/><br/> Ces collaborateurs·trices ne sont <strong>pas éligibles à la téléconsultation</strong> et bénéficient systématiquement de visites médicales en présentiel.</p>Sont concerné·e·s notamment : <br/><ul><li>Travailleurs·euses exposé·e·s à des agents chimiques dangereux, CMR, amiante…</li><li>Travailleurs·euses de nuit ou en horaires décalés</li><li>Femmes enceintes, venant d'accoucher ou allaitantes</li><li>Travailleurs·euses de moins de 18 ans</li></ul> <p>La classification est gérée automatiquement par Paladin selon les fiches collaborateurs·trices.</p>",
          "title": "Qu'est-ce que le suivi renforcé ?"
        },
        "title": "Paramètres",
        "toast": {
          "autoSendInvitationsDisabled": "Envoi automatique des invitations désactivé",
          "autoSendInvitationsEnabled": "Envoi automatique des invitations activé",
          "disabled": "Aucun forçage actif",
          "onsiteEnabled": "Présentiel forcé activé",
          "tlcEnabled": "Téléconsultation forcée activée"
        },
        "warningOnlyForAutomaticConsultations": "Ce paramètre s'applique uniquement aux consultations planifiées automatiquement."
      },
      "sections": {
        "ACTIVITIES": "Rendez-vous avec l’équipe {facilityName}",
        "BILLING_DATA": "Données de facturation",
        "COMPANY_INFORMATION": "Informations de l'entreprise",
        "CSE_REFERENT": "Référent·e CSE",
        "DOCUMENTS": "Documents",
        "HRIS_CONNECTION": "Connexion SIRH",
        "HR_REFERENT": "Référent·e·s RH",
        "IRP": "Instances Représentatives du Personnel (IRP)",
        "OCCUPATIONAL_HEALTH_PHYSICIAN": "Médecin référent·e",
        "PARAMETERS": "Paramètres",
        "USER_MANAGEMENT": "Gestion des utilisateurs(rices)"
      },
      "title": "Espace adhérent",
      "userManagement": {
        "callout": "Le rôle définit les accès aux données RH et santé. Seul·e un·e administrateur·trice de l'entité peut le modifier.",
        "confirmDialog": {
          "description": "{name} aura les accès du rôle {role}.\nAssurez-vous que ce niveau d'accès est justifié.",
          "title": "Changement de rôle"
        },
        "deleteDialog": {
          "description": "Cette action est définitive.\n{name} perdra immédiatement l'accès à Paladin RH et à l'ensemble de ses données associées.",
          "title": "Suppression du compte"
        },
        "deleteSuccess": "Le compte de {name} a bien été supprimé.",
        "empty": "Aucun·e utilisateur·trice rattaché·e à cette entité.",
        "invite": {
          "fields": {
            "email": "Email",
            "firstName": "Prénom",
            "lastName": "Nom",
            "role": "Rôle"
          },
          "submit": "Ajouter",
          "success": "Une invitation a été envoyée à {email}.",
          "title": "Ajouter un compte",
          "trigger": "Ajouter un compte"
        },
        "roles": {
          "company_branch_representative_admin": "Admin",
          "company_branch_representative_user": "Utilisateur(rice)"
        },
        "setRoleSuccess": "Le rôle a bien été modifié.",
        "table": {
          "columns": {
            "account": "Compte",
            "role": "Rôle"
          },
          "deleteUser": "Supprimer le compte de {name}",
          "editRole": "Modifier le rôle de {name}",
          "noRole": "Aucun rôle",
          "roleSelectLabel": "Rôle de {name}"
        }
      }
    },
    "noResults": "Aucun résultat.",
    "onboarding": {
      "end": {
        "description": "Vous avez désormais terminé l’ensemble des étapes d’onboarding et pouvez accéder à toutes les fonctionnalités du produit.",
        "goToProductButton": "Démarrer l'expérience Paladin",
        "title": "Félicitations !"
      },
      "layout": {
        "backButton": "Précédent",
        "goToProduct": "Accéder à l'application",
        "nextButton": "Suivant",
        "sidebar": {
          "collaborators": "Collaborateurs·trices",
          "companyInformation": "Profil de l'entreprise",
          "medicalHistory": "Suivi médical",
          "risks": "Risques professionnels"
        }
      },
      "step1CollaboratorsImport": {
        "addCollaborator": {
          "addAnotherCollaborator": "Ajouter un autre collaborateur·trice"
        },
        "description": "Ajoutez vos collaborateurs·trices manuellement,\nvia import en masse ou en connectant votre SIRH.",
        "hris": {
          "filter": {
            "callout": {
              "error": {
                "content": "Certains filtres ne sont pas disponibles, vous pouvez cependant continuer d'importer vos collaborateurs·trices."
              },
              "neutral": {
                "content": "Par défaut, toutes les valeurs seront sélectionnées si vous n'en choisissez aucune."
              }
            },
            "company": {
              "label": "Divisions",
              "placeholder": "Sélectionnez vos divisions…"
            },
            "department": {
              "label": "Départements",
              "placeholder": "Sélectionnez vos départements…"
            },
            "selectAll": "Tout sélectionner",
            "subtitle": "Sélectionnez vos divisions et départements.",
            "title": "Définissez vos sites et équipes."
          }
        },
        "komboDescription": "Les données de votre SIRH sont récupérées via Kombo, notre partenaire d'intégration : il se connecte en lecture seule à la plupart des SIRH du marché, sans que vos identifiants transitent par Paladin.",
        "komboSuccess": "Votre SIRH a bien été configuré.",
        "manualImportButton": "Import manuel",
        "noHris": {
          "addCollaboratorButton": "Ajouter un·e collaborateur·trice",
          "description": "Pas de panique, vous pouvez malgré tout importer un fichier\nou ajouter un·e collaborateur·trice manuellement.",
          "importFileButton": "Importer un fichier",
          "title": "Vous ne trouvez pas votre SIRH ou vous n'en avez pas ?"
        },
        "title": "Ajouter mes collaborateurs·trices"
      },
      "step2MedicalHistoryImport": {
        "attestationsUpload": {
          "fileNotFound": "Fichier introuvable",
          "importInProgress": "Import des attestations en cours, nous vous préviendrons par mail dès qu'il sera terminé.",
          "leaveConfirmation": {
            "cancel": "Rester sur l'étape",
            "confirm": "Quitter quand même",
            "description": "{count, plural, one {# fichier n'a pas encore été envoyé et sera perdu si vous quittez cette étape.} other {# fichiers n'ont pas encore été envoyés et seront perdus si vous quittez cette étape.}}",
            "sendingDescription": "Si vous quittez cette étape maintenant, les fichiers qui n'ont pas encore été déposés seront perdus.",
            "sendingTitle": "L'envoi de vos attestations est en cours",
            "title": "Des fichiers n'ont pas encore été envoyés"
          },
          "sendFailed": "{count, plural, one {# attestation n'a pas pu être envoyée} other {# attestations n'ont pas pu être envoyées}}",
          "sendRejected": "{count, plural, one {# attestation a été refusée : retirez-la pour continuer} other {# attestations ont été refusées : retirez-les pour continuer}}",
          "sendingProgress": "Import des attestations en cours...",
          "title": "Déposer vos attestations médicales",
          "unsupportedFileType": "Le format du fichier n'est pas pris en charge"
        },
        "description": "Importez les documents médicaux existants (ex. attestations de suivi) pour compléter les données, comme la date de la dernière visite.",
        "title": "Ajouter un suivi médical"
      },
      "step3Risks": {
        "add": {
          "success": {
            "description": "À présent, identifiez les risques liés aux différents postes de travail dans votre entreprise afin de mettre en place les mesures nécessaires.",
            "title": "Vos risques ont bien été ajoutés !"
          }
        },
        "description": "Indiquez les risques associés à chaque poste afin de garantir un suivi médical et des actions de prévention adaptés à vos métiers.",
        "link": {
          "success": {
            "description": "Pour finir, ajoutez les documents clés et les informations essentielles de l’entreprise (ex. DUERP, référents internes, etc.).",
            "title": "Vos risques ont bien été associés !"
          }
        },
        "title": "Risques professionnels"
      },
      "step4CompanyProfile": {
        "description": "Ajoutez les documents clés et les informations essentielles de l’entreprise\n(ex. DUERP, référents internes, etc.), ainsi que les principaux·ales interlocuteurs·trices.",
        "referents": {
          "cseReferent": "Référent·e CSE",
          "description": "Définissez les interlocuteurs de chaque sujet.",
          "humanResourcesReferent": "Référent·e RH",
          "title": "Définir les interlocuteurs"
        },
        "staffRepresentatives": {
          "callout": "Les <bold>Instances Représentatives du Personnel (IRP)</bold> sont des groupes de collaborateurs·trices élu·e·s ou désigné·e·s dans les entreprises ayant atteint un certain seuil d’effectif. Il existe plusieurs types d’instances : CSE, CSSCT, délégation syndicale...",
          "description": "Identifiez vos représentant·e·s",
          "title": "Représentant·e·s du personnel"
        },
        "title": "Profil de l'entreprise"
      },
      "welcome": {
        "accountCreated": {
          "description": "Votre compte Paladin a bien été créé.\nVous allez pouvoir dès à présent vous laisser guider à travers nos différentes étapes afin de configurer votre outil.",
          "setupPaladinButton": "Configurer Paladin",
          "title": "Félicitations !"
        },
        "consent": "Consentement",
        "consentEmailTrackingPixel": "J’accepte que Paladin utilise des pixels de suivi pour mesurer l’ouverture de ses e-mails afin d’adapter leur contenu et leur fréquence",
        "consentNotifications": "J’autorise l’envoi d’emails, de SMS ou de notifications liés à l’utilisation du service.",
        "consentPersonalizedExperience": "Je consens à l'utilisation de mes données par Paladin pour bénéficier d'une expérience personnalisée.",
        "consentToPersonalDataProcessing": "J’accepte que Paladin collecte et traite mes données personnelles conformément à la <a>politique de confidentialité</a> <span>*</span>",
        "description": "Bonjour et merci d’avoir choisi Paladin pour vous accompagner dans la prévention et la gestion de la santé de vos collaborateurs·trices. ✨<br/>Afin de vous permettre de configurer au mieux l’outil, laissez-vous guider dans les quelques étapes d’onboarding.<br/><br/><bold>Prévoyez environ 20 minutes au total !</bold>",
        "descriptionCompanyAlreadyOnboarded": "Bonjour et merci d’avoir choisi Paladin pour vous accompagner dans la prévention et la gestion de la santé de vos collaborateurs·trices. ✨<br/>Choisissez votre mot de passe à la prochaine étape et accédez à l’ensemble des fonctionnalités Paladin.",
        "findItInParameters": "Vous pourrez les retrouver dans l'onglet \"Informations légales\" de vos paramètres.",
        "finish": "Terminer",
        "legalInformation": {
          "description": "Merci de saisir les informations relatives à votre entreprise.",
          "title": "Informations légales"
        },
        "readAndAcceptTermsOfService": "J’ai lu et j’accepte les <a>conditions générales d’utilisation et de vente</a> <span>*</span>",
        "startButton": "Commencer",
        "title": "Bienvenue sur Paladin !",
        "tosAndGdprAccepted": "Les conditions générales d'utilisation et de vente ainsi que la politique de confidentialité ont bien été acceptées.",
        "validate": "Valider"
      }
    },
    "parameters": {
      "companyCard": {
        "title": "Informations de l'entreprise"
      },
      "consentCard": {
        "approvedAt": "Approuvé le {date} à {time}",
        "consent": "Consentement",
        "notifications": "Envoi de notifications",
        "personalDataProcessing": "Collecte et traitement des données personnelles",
        "personalizedExperience": "Personnalisation de l’expérience via mes données",
        "readAndApprovedAt": "Lu et approuvé le {date} à {time}",
        "termsOfService": "Conditions générales d’utilisation et de vente"
      },
      "contactCard": {
        "copied": "Adresse copiée dans le presse-papier",
        "failedToCopy": "Échec de la copie dans le presse-papiers",
        "yourRights": "Pour exercer vos droits ou pour toute demande relative à la protection de vos données personnelles, contactez notre délégué à la protection des données :"
      },
      "linkCard": {
        "legalContact": "Contact légal",
        "legalNotice": "Mentions légales",
        "link": "Liens",
        "privacyPolicy": "Politique de confidentialité",
        "termsOfService": "Conditions générales d’utilisation et de vente"
      },
      "personalCard": {
        "title": "Informations personnelles"
      },
      "tabs": {
        "company": "Informations de l'entreprise",
        "legal": "Informations légales",
        "personal": "Informations personnelles"
      },
      "title": "Paramètres"
    },
    "prevention": {
      "description": "Suivez les <bold>actions de prévention</bold> menées auprès de vos collaborateurs·trices et <bold>accédez aux contenus diffusés</bold> par Paladin.<br/><br/>Un espace clair pour <bold>comprendre les enjeux</bold>, <bold>anticiper les risques</bold> et <bold>accompagner vos collaborateurs·trices</bold>."
    },
    "risksDuerp": {
      "addRisk": "Ajouter un risque",
      "assistant": {
        "agentName": "Assistant IA",
        "card": {
          "action": "Commencer",
          "badge": "Recommandé",
          "description": "Questions ciblées, service par service, pour un profil de risques précis à la sortie.",
          "title": "Se laisser guider par l'assistant IA"
        },
        "close": "Fermer l'assistant IA",
        "closedNotice": "Cette conversation est terminée.",
        "collapse": "Réduire l'assistant IA",
        "error": "Impossible de charger l'assistant IA. Veuillez réessayer plus tard.",
        "expand": "Agrandir l'assistant IA",
        "open": "Ouvrir l'assistant IA",
        "restart": "Nouvelle conversation",
        "resume": {
          "description": "Vous avez une conversation en cours avec l'assistant, commencée le {startedAt, date, short}.",
          "resume": "Reprendre",
          "startOver": "Recommencer"
        },
        "start": "Démarrer",
        "startDescription": "L'assistant vous guide service par service pour construire vos unités de travail et vos risques.",
        "startOver": {
          "button": "Recommencer la conversation",
          "confirm": "Recommencer",
          "description": "{count, plural, =0 {L'assistant repartira de zéro. Ce que vous avez déjà dans l'application est conservé.} one {La suggestion de l'assistant que vous n'avez pas validée sera retirée. Ce que vous avez validé est conservé.} other {Les # suggestions de l'assistant que vous n'avez pas validées (unités de travail, risques et rattachements de personnes) seront retirées. Ce que vous avez validé est conservé.}}",
          "title": "Recommencer de zéro ?"
        },
        "title": "Assistant IA Paladin",
        "toolStatus": {
          "prepareRecap": "Je prépare le récapitulatif…",
          "rateRisks": "Je prépare les cotations…",
          "readDocument": "Je lis votre document…",
          "readHeadcount": "Je consulte vos effectifs…",
          "readWorkUnits": "Je consulte vos unités de travail…",
          "saveSuggestions": "J'ajoute mes suggestions dans l'application…",
          "searchRisks": "Je cherche dans le référentiel des risques…"
        },
        "userName": "Vous"
      },
      "duerp": {
        "document": {
          "actionPlan": {
            "empty": "Aucune action d'amélioration n'a été renseignée."
          },
          "cover": {
            "employeeCount": "{count, plural, one {{count, number, ::group-off} salarié} other {{count, number, ::group-off} salariés}}",
            "eyebrow": "Évaluation des risques professionnels",
            "lead": "Ce document recense les risques auxquels les salariés de l'établissement sont exposés, unité de travail par unité de travail, la cotation retenue pour chacun et les actions engagées pour les réduire.",
            "subtitle": "Document unique d'évaluation des risques professionnels"
          },
          "cse": {
            "note": "Le document et son plan d'actions sont mis à la disposition du CSE, des salariés et du service de prévention et de santé au travail. Aucune version antérieure n'est effacée : l'historique complet figure en section 06."
          },
          "draft": "Brouillon — non validé",
          "fields": {
            "address": "Adresse de l'établissement",
            "consultationLocation": "Lieu de consultation du document",
            "consultedAt": "Date de consultation",
            "contractTypeUnstated": "Non renseigné",
            "contractTypes": "Répartition par type de contrat",
            "date": "Date",
            "description": "Description",
            "employeeCount": "Effectif",
            "employer": "Employeur",
            "firstDocumentDate": "Date du premier DUERP",
            "legalName": "Raison sociale",
            "occupationalHealthService": "Service de prévention et de santé au travail",
            "opinion": "Avis rendu",
            "safetyReferent": "Référent santé et sécurité au travail",
            "sexBreakdown": "Répartition femmes / hommes",
            "siret": "N° SIRET",
            "updateReason": "Objet de la mise à jour",
            "version": "Version",
            "writers": "Rédacteurs du document"
          },
          "legend": {
            "high": "Élevé — criticité résiduelle supérieure ou égale à {high, number} : action immédiate",
            "low": "Faible — criticité résiduelle inférieure à {moderate, number} : vigilance normale",
            "moderate": "Modéré — criticité résiduelle de {moderate, number} à moins de {high, number} : action à moyen terme"
          },
          "levels": {
            "high": "Élevé",
            "low": "Faible",
            "moderate": "Modéré"
          },
          "method": {
            "annex": "Annexe",
            "criticality": "La criticité brute est le produit de la gravité et de la fréquence. La criticité résiduelle la divise par le niveau de maîtrise atteint, arrondi au supérieur.",
            "frequency": "Fréquence d'exposition",
            "intro": "Chaque risque est coté selon deux axes, puis pondéré par les moyens de maîtrise déjà en place.",
            "mitigation": "Niveaux de maîtrise",
            "severity": "Gravité",
            "thresholds": "Un risque est considéré comme faible en deçà de {moderate, number}, modéré à partir de {moderate, number} et élevé à partir de {high, number}.",
            "title": "Annexe — méthode d'évaluation"
          },
          "pageNumber": "Page {page, number} / {total, number}",
          "sections": {
            "actionPlan": "Plan d'actions",
            "actors": "Acteurs de la prévention",
            "administrative": "Informations administratives",
            "assessment": "Évaluation des risques",
            "cse": "Consultation du CSE et transmission",
            "document": "Le document",
            "history": "Historique des versions et signatures",
            "identity": "Carte d'identité de l'entreprise",
            "signatures": "Signatures",
            "workUnits": "Unités de travail"
          },
          "sexBreakdown": "{female, number} F · {male, number} H{unknown, plural, =0 {} other { · # non renseigné}}",
          "signature": {
            "date": "Date : ____ / ____ / ________"
          },
          "table": {
            "controlMeasures": "Moyens de maîtrise existants",
            "dangerousSituation": "Situation dangereuse",
            "employeeCount": "Effectif",
            "frequency": "Fréquence",
            "improvementActions": "Actions d'amélioration",
            "initialCriticality": "Criticité brute",
            "mitigation": "Maîtrise",
            "possibleDamages": "Dommages possibles",
            "residualCriticality": "Criticité résiduelle",
            "risk": "Risque",
            "severity": "Gravité",
            "workUnit": "Unité de travail"
          }
        },
        "generate": {
          "completeness": {
            "suggestedRatings": "{count, plural, one {# cotation proposée par l'IA est} other {# cotations proposées par l'IA sont}} à valider dans :",
            "unratedRisks": "{count, plural, one {# risque n'est pas coté} other {# risques ne sont pas cotés}} dans :",
            "workUnitsToValidate": "{count, plural, one {# unité de travail contient} other {# unités de travail contiennent}} des propositions de l'IA à valider :",
            "workUnitsWithoutRisk": "{count, plural, one {# unité de travail ne comporte} other {# unités de travail ne comportent}} aucun risque :"
          },
          "confirmTooltip": "Corrigez les points signalés dans le récapitulatif pour générer le DUERP.",
          "continue": "Continuer le DUERP",
          "documentForm": {
            "consultationLocation": {
              "label": "Lieu de consultation du DUERP",
              "placeholder": "Ex. : salle de pause, 1er étage"
            },
            "contributors": {
              "add": "Ajouter un·e contributeur·trice",
              "empty": "Aucun·e contributeur·trice pour le moment.",
              "label": "Contributeurs·trices",
              "name": "Nom",
              "remove": "Retirer ce·tte contributeur·trice",
              "role": "Rôle",
              "rolePlaceholder": "Ex. : déléguée du personnel"
            },
            "cseConsultationDate": "Date de consultation du CSE",
            "cseOpinion": {
              "label": "Avis du CSE",
              "options": {
                "FAVORABLE": "Favorable",
                "NOT_NEEDED": "Non requis",
                "UNFAVORABLE": "Défavorable"
              }
            },
            "description": "Renseignez les informations de cette version avant de générer votre DUERP.",
            "firstDocumentDate": {
              "hint": "Laissez vide s'il s'agit de votre premier DUERP : la date de sa validation sera retenue.",
              "label": "Date du premier document"
            },
            "healthAndSafetyOfficerName": "Responsable santé et sécurité",
            "settings": {
              "description": "Communes à toutes les versions du DUERP.",
              "title": "Paramètres"
            },
            "title": "Informations du document",
            "updateReason": {
              "hint": "Laissez vide s'il s'agit de votre premier DUERP.",
              "label": "Motif de la mise à jour",
              "options": {
                "ANNUAL_REVIEW": "Mise à jour annuelle",
                "MAJOR_WORKPLACE_CHANGE": "Modification importante des conditions de travail",
                "WORK_ACCIDENT": "Accident du travail"
              },
              "placeholder": "Sélectionner un motif"
            },
            "version": {
              "description": "Propres à la version en préparation.",
              "title": "Cette version"
            },
            "versionLabel": {
              "label": "Libellé de la version",
              "placeholder": "Ex. : V2.0"
            }
          },
          "empty": {
            "addManually": "Ajouter manuellement",
            "description": "Aucune unité de travail ni aucun risque n'ont encore été ajoutés.\nAjoutez au moins une unité de travail et un risque pour générer votre DUERP.",
            "startAiAssistant": "Lancer l'assistant IA"
          },
          "error": "Impossible de charger les données de votre DUERP. Veuillez réessayer plus tard.",
          "excluded": "Cette unité de travail ne figurera pas dans le document : aucun salarié n'y est rattaché.",
          "history": {
            "backToCurrent": "Revenir aux données actuelles",
            "current": "Données actuelles",
            "currentDetail": "Brouillon, non validé",
            "inProgress": "En cours",
            "pdfDescription": "Le document est mis en page à partir des données figées à la validation.",
            "pdfTitle": "DUERP — version {version}",
            "readOnly": "Vous consultez la version {version} validée le {date, date, long}. Cet état est figé : seules les données actuelles peuvent donner lieu à une nouvelle version.",
            "readOnlyUnnamed": "Vous consultez une version validée. Cet état est figé : seules les données actuelles peuvent donner lieu à une nouvelle version.",
            "showPdf": "Voir le PDF",
            "title": "Historique",
            "unreadable": "Non consultable",
            "validated": "Validé",
            "validatedAt": "{date, date, long} à {date, time, short}"
          },
          "noRisk": "Aucun risque n'a été évalué pour cette unité de travail.",
          "overview": "{riskCount, plural, one {# risque réparti} other {# risques répartis}} sur {workUnitCount, plural, one {# unité de travail} other {# unités de travail}}.",
          "preview": {
            "description": "Ce brouillon n'est pas encore validé : relisez-le avant de le valider.",
            "error": "Impossible de générer l'aperçu de votre DUERP. Veuillez réessayer.",
            "title": "Aperçu de votre DUERP"
          },
          "title": "Récapitulatif",
          "uncoveredEmployees": {
            "andOthers": "{count, plural, one {et 1 autre} other {et {count} autres}}",
            "list": {
              "columns": {
                "department": "Pôle",
                "jobTitle": "Poste",
                "name": "Nom"
              },
              "description": "Ces personnes ne sont dans aucune unité de travail. Elles sont classées par poste : un poste entier se rattache d'un coup à une unité.",
              "error": "Impossible de charger la liste. Veuillez réessayer plus tard.",
              "title": "Personnes non couvertes"
            },
            "title": "{count, plural, one {# salarié n'est couvert} other {# salariés ne sont couverts}} par aucune unité de travail :"
          },
          "validate": {
            "confirm": {
              "description": "Elle sera figée : son contenu ne pourra plus être modifié.",
              "title": "Valider la version « {versionLabel} » ?"
            },
            "gaps": {
              "title": "Complétez ces éléments pour valider votre DUERP :",
              "unvalidatedWeightedRisks": "{count, plural, one {# risque à valider} other {# risques à valider}}",
              "unvalidatedWorkUnits": "{count, plural, one {# unité de travail à valider} other {# unités de travail à valider}}"
            },
            "success": "La version « {versionLabel} » de votre DUERP est validée."
          }
        },
        "importExisting": {
          "action": "Importer un DUERP",
          "description": "Repartez d'une base existante et ajustez vos données en fonction de l'évolution de votre entreprise.",
          "reading": "Lecture du document…",
          "title": "Importer un DUERP existant"
        },
        "title": "Générer votre DUERP {year, number, ::group-off}",
        "useCurrentData": {
          "action": "Utiliser mes données actuelles",
          "description": "Vous avez déjà {riskCount, plural, one {# risque validé} other {# risques validés}} et {workUnitCount, plural, one {# unité de travail} other {# unités de travail}}.",
          "descriptionEmpty": "Vous n'avez pas encore de risque validé ni d'unité de travail.",
          "descriptionUnavailable": "Repartez des risques et des unités de travail déjà saisis dans Paladin.",
          "title": "Utiliser mes données actuelles"
        }
      },
      "generateDuerp": "Générer le DUERP",
      "overview": {
        "empty": {
          "action": "Créer une unité de travail",
          "description": "Commencez par regrouper vos collaborateurs·trices en unités de travail, puis déclarez et cotez les risques de chacune.",
          "title": "Aucun risque ni unité de travail n'est encore renseigné."
        },
        "error": "Impossible de charger la vue d'ensemble. Veuillez réessayer plus tard.",
        "matrix": {
          "description": "Chaque case croise une gravité et une fréquence d'exposition. Le score affiché est Gravité × Fréquence ; chaque risque est placé à sa cotation brute la plus élevée, et sa couleur reflète sa cotation après atténuation.",
          "legend": {
            "high": "Score ≥ {high} · priorité 1",
            "low": "Score < {moderate} · priorité 4",
            "moderateLower": "Score ≥ {moderate} et < {moderateUpper} · priorité 3",
            "moderateUpper": "Score ≥ {moderateUpper} et < {high} · priorité 2",
            "title": "Niveaux de criticité",
            "unrated": "Déclarés, pas encore placés dans la matrice"
          },
          "title": "Cartographie des risques"
        },
        "stats": {
          "highRisks": "{count, plural, one {Risque élevé} other {Risques élevés}}",
          "identifiedRisks": "{count, plural, one {Risque identifié} other {Risques identifiés}}",
          "workUnits": "{count, plural, one {Unité de travail} other {Unités de travail}}"
        }
      },
      "risks": {
        "edit": {
          "success": "La cotation du risque a bien été enregistrée.",
          "title": "Gérer le risque"
        },
        "form": {
          "controlMeasures": {
            "collective": {
              "label": "Moyens de prévention collectifs",
              "placeholder": "Aspiration à la source, consignes de rotation des postes..."
            },
            "individual": {
              "label": "Moyens de prévention individuels",
              "placeholder": "Masque FFP3, gants anti-coupure..."
            },
            "title": "Moyens de maîtrise existants"
          },
          "criticality": "Criticité",
          "frequency": "Fréquence",
          "initialRating": {
            "hint": "Le risque tel qu'il se présente, avant application des moyens de maîtrise.",
            "title": "Cotation brute"
          },
          "mitigationFactor": {
            "label": "Moyens de maîtrise en place",
            "placeholder": "Sélectionnez le niveau de maîtrise atteint..."
          },
          "narrative": {
            "dangerousSituation": {
              "label": "Description de la situation dangereuse",
              "placeholder": "Manutention manuelle de fûts de 200 litres sur sol irrégulier..."
            },
            "improvementActions": {
              "label": "Actions d'amélioration",
              "placeholder": "Organisationnelles, techniques et humaines : rotation des postes, chariot élévateur, formation aux gestes et postures..."
            },
            "possibleDamages": {
              "label": "Dommages possibles",
              "placeholder": "Lombalgie, écrasement du pied, troubles musculo-squelettiques..."
            },
            "title": "Description et actions"
          },
          "residualRating": {
            "hint": "Ce qu'il reste du risque une fois les moyens de maîtrise appliqués : la cotation brute divisée par le niveau de maîtrise. Facultatif.",
            "title": "Cotation résiduelle",
            "tooltip": {
              "mitigationFactor": "Moyen de maîtrise",
              "rounded": "Arrondi à l'unité supérieure."
            }
          },
          "severity": "Gravité"
        },
        "select": {
          "action": "Ajouter des risques",
          "alreadyDeclared": "Déjà déclaré",
          "error": "Impossible de charger le référentiel des risques. Veuillez réessayer plus tard.",
          "noMatch": "Aucun risque ne correspond à cette recherche.",
          "noneSelected": "Aucun risque n'a encore été sélectionné.",
          "partial": "{created, plural, one {{created} risque sur {total} ajouté} other {{created} risques sur {total} ajoutés}}",
          "searchPlaceholder": "Rechercher un risque…",
          "selectedTitle": "Risques sélectionnés",
          "submit": "{count, plural, one {Ajouter le risque} other {Ajouter les {count} risques}}",
          "title": "Ajouter des risques"
        },
        "toBeRated": "À coter"
      },
      "tabs": {
        "assistant": "Assistant IA",
        "duerp": "DUERP",
        "overview": "Vue d'ensemble",
        "workUnits": "Unités de travail"
      },
      "title": "Risques & DUERP",
      "workUnits": {
        "addWorkUnit": "Ajouter une unité",
        "aiSuggestion": "Suggestion IA à valider",
        "card": {
          "criticalityRing": "Répartition des risques : {high, plural, one {{high} élevé} other {{high} élevés}}, {moderate, plural, one {{moderate} modéré} other {{moderate} modérés}}, {low, plural, one {{low} faible} other {{low} faibles}}, {unrated} à coter",
          "employeeCount": "{count, plural, one {{count} personne} other {{count} personnes}}",
          "noRisk": "Aucun risque associé",
          "riskCount": "{count, plural, one {{count} risque} other {{count} risques}}",
          "riskToRate": "{count, plural, one {{count} risque à coter} other {{count} risques à coter}}",
          "suggestedRisks": "{count, plural, one {{count} cotation IA à valider} other {{count} cotations IA à valider}}"
        },
        "create": {
          "submit": "Créer une nouvelle unité de travail",
          "success": "L'unité de travail a bien été créée.",
          "title": "Ajouter une unité de travail"
        },
        "delete": {
          "confirm": "Confirmer la suppression",
          "description": "Les risques cotés sur cette unité de travail seront également supprimés de votre DUERP. Cette action est irréversible.",
          "success": "L'unité de travail a bien été supprimée.",
          "title": "Êtes-vous sûr de vouloir supprimer\ncette unité de travail ?"
        },
        "description": "Regroupez vos collaborateurs·trices par conditions d'exposition réelles et cotez les risques associés à ces unités.",
        "detail": {
          "error": "Impossible de charger cette unité de travail. Veuillez réessayer plus tard.",
          "noRelation": "Aucune personne associée à cette unité de travail.",
          "risks": {
            "aiSuggestion": "Suggestion IA à valider",
            "controlMeasures": "Moyens de maîtrise existants :",
            "criticality": {
              "high": "Élevé · {criticality}",
              "important": "Important · {criticality}",
              "low": "Faible · {criticality}",
              "moderate": "Modéré · {criticality}"
            },
            "editRating": "Modifier la cotation",
            "empty": "Aucun risque n'a encore été renseigné.",
            "error": "Impossible de charger les risques de cette unité de travail. Veuillez réessayer plus tard.",
            "initialCriticality": "Brut · {criticality}",
            "manage": "Gérer le risque",
            "manageHint": "Les moyens de maîtrise et les descriptions se modifient depuis la fiche risque.",
            "noControlMeasure": "Aucun moyen de maîtrise renseigné.",
            "noNarrative": "Aucune description renseignée pour ce risque.",
            "notRated": "Non renseigné",
            "rating": "Cotation",
            "remove": {
              "action": "Supprimer le risque",
              "confirm": "Confirmer la suppression",
              "description": "La cotation de ce risque pour cette unité de travail sera supprimée de votre DUERP. Les autres unités ne sont pas affectées. Cette action est irréversible.",
              "success": "Le risque a bien été supprimé de l'unité de travail.",
              "title": "Êtes-vous sûr de vouloir supprimer ce risque\nde l'unité de travail ?"
            },
            "title": "Risques",
            "toggleDetails": "Afficher ou masquer le détail du risque",
            "validate": {
              "action": "Accepter",
              "adjust": "Ajuster",
              "success": "La suggestion a bien été validée."
            }
          },
          "suggestedRelation": "Proposé par l'assistant IA",
          "validate": {
            "action": "Valider l'unité",
            "success": "L'unité de travail a bien été validée."
          }
        },
        "edit": {
          "success": "L'unité de travail a bien été modifiée.",
          "title": "Modifier une unité de travail"
        },
        "empty": "Aucune unité de travail n'a encore été créée.",
        "error": "Impossible de charger les unités de travail. Veuillez réessayer plus tard.",
        "form": {
          "collaboratorsLabel": "Collaborateurs·trices",
          "collaboratorsPlaceholder": "Sélectionnez des collaborateurs·trices...",
          "collaboratorsSearch": "Rechercher une division, un pôle, un poste ou une personne",
          "descriptionLabel": "Description",
          "descriptionLength": "{count}/{max} caractères",
          "descriptionPlaceholder": "Développeurs, product managers et designers en poste sédentaire sur écran. Activité rythmée par les sprints, revues de code et conception collaborative.",
          "nameLabel": "Nom de l'unité de travail",
          "namePlaceholder": "UT1 · Produit & Ingénierie",
          "removeSelection": "Retirer la sélection",
          "selectedCount": "{count, plural, one {{count} sélectionné·e} other {{count} sélectionné·e·s}}",
          "selections": "Collaborateurs·trices sélectionné·e·s"
        },
        "title": "Unités de travail"
      }
    },
    "sidebar": {
      "branchNotOnboarded": "Cet établissement n’est pas encore configuré.",
      "collaborators": "Collaborateurs·trices",
      "dashboard": "Tableau de bord",
      "documents": "Documents",
      "memberSpace": "Espace adhérent",
      "mokaCare": {
        "subtitle": "Moka.care : rappel rapide",
        "title": "Soutien de crise"
      },
      "prevention": "Prévention",
      "risks": {
        "addOrUpdateRisk": "Ajouter/modifier les risques",
        "linkRisk": "Associer des risques",
        "title": "Risques"
      },
      "risksDuerp": "Risques & DUERP",
      "visits": {
        "title": "Visites"
      }
    },
    "visits": {
      "planVisit": {
        "COMPANY_BRANCH": {
          "description": "La visite aura lieu dans les locaux de votre entreprise.",
          "noSlotsAvailable": {
            "description": "N’hésitez pas à consulter les autres créneaux disponibles.",
            "title": "Aucun créneau n’est disponible à cette date au bureau."
          },
          "title": "Au bureau"
        },
        "HEALTH_CENTER": {
          "description": "La visite physique aura lieu au<br/><bold>{address}</bold>",
          "noSlotsAvailable": {
            "description": "N’hésitez pas à consulter les autres créneaux disponibles.",
            "title": "Aucun créneau n’est disponible à cette date au centre."
          },
          "title": "Au centre"
        },
        "TELECONSULTATION": {
          "description": "La consultation devra avoir lieu dans un espace isolé, équipé d’une bonne connexion internet, d’une caméra et d’un micro.",
          "noSlotsAvailable": {
            "description": "N’hésitez pas à consulter les créneaux disponibles en présentiel.",
            "title": {
              "forActivity": "Aucun créneau n’est disponible à cette date à distance.",
              "forAppointment": "Aucun créneau n’est disponible à cette date en téléconsultation."
            }
          },
          "title": {
            "forActivity": "À distance",
            "forAppointment": "Téléconsultation"
          }
        },
        "healthCenterInfo": {
          "description": "Au centre Sano, à deux pas de Saint-Lazare, vos collaborateurs·trices bénéficient d'un bilan complet en présentiel - avec notamment un <bold>dépistage des troubles visuels</bold> grâce à un équipement de dernière génération.<br/><br/> Un moment dédié à leur santé, dans un espace pensé pour les accueillir.",
          "nextButton": "Planifier une visite",
          "title": "Au centre Sano, leur bilan va plus loin."
        },
        "missingExpectedInformation": {
          "BIRTH_DATE": "<bold>Date de naissance</bold>",
          "CONTRACT_TYPE": "<bold>Type de contrat</bold>",
          "JOB_TITLE": "<bold>Poste de travail</bold>",
          "MEDICAL_DATA": "<bold>Date de dernière et/ou prochaine visite</bold> (hors nouveau·elle collaborateur·trice)",
          "PROFESSIONAL_RISK": "<bold>Risque professionnel</bold>",
          "callout": "Informations manquantes pour planifier la visite. <url>Complétez la fiche</url> du·de la collaborateur·trice :<br/><br/>",
          "url": "Compléter la fiche"
        },
        "noAvailableSlots": {
          "description": "De nouveaux créneaux peuvent être proposés prochainement. Nous vous invitons à revenir plus tard.",
          "title": "Aucun créneau n'est disponible actuellement."
        },
        "pickABookingSlot": "Veuillez choisir un créneau",
        "recap": {
          "collaborator": "Nom du·de la collaborateur·trice : ",
          "consultationType": "Type de consultation : ",
          "date": "Date : ",
          "editTitle": "Vous allez modifier une visite pour : ",
          "requestReason": "Motif de la demande : ",
          "time": "Horaire : ",
          "title": "Vous allez planifier une visite pour : ",
          "visitType": "Type de visite : "
        },
        "success": {
          "allowEmployeeToRescheduleAppointment": "Vous avez donné la possibilité au·à la collaborateur·trice de modifier le rendez-vous.",
          "description": "La {visitType} de {collaborator} en {consultationType} le {from, date, short} à {from, time, ::H mm} - {to, time, ::H mm} a bien été prise en compte.",
          "editTitle": "La visite a bien été modifiée !",
          "refuseEmployeeToRescheduleAppointment": "Vous avez refusé la possibilité au·à la collaborateur·trice de modifier le rendez-vous.",
          "title": "La visite a bien été planifiée !"
        },
        "teleconsultation": {
          "description": "La consultation devra avoir lieu dans un espace isolé, équipé d’une bonne connexion internet, d’une caméra et d’un micro.",
          "noSlotsAvailable": {
            "description": "N’hésitez pas à consulter les créneaux disponibles en présentiel.",
            "title": "Aucun créneau n’est disponible à cette date en téléconsultation."
          },
          "title": "Téléconsultation"
        }
      },
      "table": {
        "actions": {
          "bookVisit": "Réserver cette visite",
          "cancelVisit": "Annuler",
          "cancelVisitError": "Erreur lors de l'annulation de la visite",
          "cancelVisitModal": {
            "cancel": "Conserver la visite",
            "confirm": "Annuler la visite",
            "content": "Vous êtes sur le point d'annuler la visite de <bold>{name}</bold> du <bold>{date}</bold> ({type}).",
            "title": "Êtes vous sûr de vouloir annuler cette visite ?"
          },
          "cancelVisitSuccess": "Visite annulée avec succès",
          "editVisit": "Modifier",
          "requestExemption": "Demander une dispense",
          "sendInvitation": "Renvoyer",
          "sendInvitationError": "Erreur lors de l'envoi de l'invitation",
          "sendInvitationSuccess": "Invitation renvoyée avec succès"
        },
        "actionsOnThisVisitAriaLabel": "Actions sur cette visite",
        "allStatuses": "Tous les statuts",
        "allTypes": "Tous les types",
        "backToList": "Retour à la liste des visites",
        "columns": {
          "certificate": "Attestation",
          "datetime": {
            "cell": "Avant le",
            "header": "Date et horaire"
          },
          "name": "Collaborateur·trice",
          "status": "Statut",
          "type": "Type de visite"
        },
        "editVisit": "Modifier une visite",
        "empty": {
          "all": "Aucune visite n'a encore été programmée",
          "description": "Nous n'avons à date pas assez d'informations concernant les données de vos collaborateurs·trices pour vous proposer l'affichage des visites.",
          "exemptions": "Aucune dispense en cours",
          "filters": "Aucune visite ne correspond aux filtres",
          "past": "Aucune visite passée",
          "toBook": "Aucune visite à planifier"
        },
        "exportCsvHeaders": {
          "consultationType": "Mode de visite",
          "date": "Date",
          "department": "Pôle",
          "employeeFirstName": "Prénom",
          "employeeLastName": "Nom",
          "organizationUnit": "Division",
          "practitionerFirstName": "Prénom du pro de santé",
          "practitionerLastName": "Nom du pro de santé",
          "status": "Statut",
          "time": "Heure",
          "type": "Type de visite"
        },
        "exportSuccess": "{count, plural, one {{count} visite exportée} other {{count} visites exportées}}",
        "exportVisits": "Exporter",
        "filters": {
          "removeFilter": "Retirer le filtre {label}",
          "reset": "Réinitialiser",
          "title": "Statut"
        },
        "ghosted": "Ghost",
        "groups": {
          "empty": "Aucune visite dans ce groupe",
          "visitCount": "{count, plural, one {# visite} other {# visites}}"
        },
        "planVisit": "Planifier une visite",
        "requestExemptionSheet": {
          "commentLabel": "Justification de la similitude de poste et des risques",
          "commentPlaceholder": "Décrivez en quoi le poste actuel est identique à celui exercé chez le précédent employeur : intitulé, missions, nature et niveau des risques d'exposition (bruit, vibrations, produits chimiques, postures, etc.)",
          "documentsLabel": "Joignez les documents justifiant la demande de dispense (dernier avis d'aptitude, etc...)",
          "eligibility": {
            "conditions": [
              "Le·la collaborateur·trice est appelé·e à occuper un emploi identique, présentant des risques d'exposition équivalents à ceux du dernier poste exercé.",
              "Aucune mesure particulière concernant le poste de travail (aménagement, adaptation ou transformation) et aucun avis d'inaptitude n'ont été émis au cours des deux dernières années.",
              "Le ou la médecin du travail est en possession du dernier avis d'aptitude du·de la travailleur·euse. (À fournir ci-dessous)."
            ],
            "intro": "Cette demande sera transmise au·à la médecin du travail référent·e, qui seul·e peut l'accepter ou la refuser. La dispense ne peut être accordée que si les trois conditions suivantes sont réunies :",
            "title": "Conditions de recevabilité de la dispense"
          },
          "lastCheckupDateLabel": "Date de la dernière visite médicale",
          "lastCheckupDatePlaceholder": "JJ/MM/AAAA",
          "submit": "Envoyer la demande",
          "success": "Demande de dispense envoyée avec succès",
          "title": "Demander une dispense",
          "uploadError": "Une erreur est survenue lors de l'envoi des documents"
        },
        "search": "Rechercher un·e collaborateur·trice...",
        "status": {
          "BOOKED": "En attente de confirmation",
          "CANCELLED": "Annulée",
          "CONDITIONS_NOT_MET": "Conditions non réunies",
          "CONFIRMED": "Confirmée",
          "EXEMPTED": "Dispensé·e",
          "EXEMPTION_REQUESTED": "Dispense demandée",
          "FINISHED": "Effectuée",
          "NO_SHOW_EMPLOYEE": "Non présentation",
          "ORIENTATION_ERROR": "Erreur d'orientation",
          "PROVISIONAL": "En attente du retour du·de la collaborateur·trice",
          "TO_BOOK": "Planification en cours",
          "TO_BOOK_LATE": "En retard",
          "UPCOMING_PLANNING": "Planification à venir"
        },
        "statusDescription": {
          "BOOKED": "Visite à venir n'ayant pas été confirmée par le ou la collaborateur·trice",
          "CANCELLED": "Visite annulée",
          "CONDITIONS_NOT_MET": "La visite n'a pas pu être réalisée car les conditions n'étaient pas réunies",
          "CONFIRMED": "Visite à venir confirmée par le ou la collaborateur·trice",
          "EXEMPTED": "Dispense de visite accordée par le médecin du travail",
          "EXEMPTION_REQUESTED": "Demande de dispense en attente de la décision du médecin du travail",
          "FINISHED": "Visite effectuée et clôturée",
          "NO_SHOW_EMPLOYEE": "Le ou la collaborateur·trice ne s'est pas présenté·e à son rendez-vous",
          "ORIENTATION_ERROR": "La visite n'a pas pu être réalisée à cause d'une erreur d'orientation",
          "PROVISIONAL": "Visite de reprise provisoire : le retour du·de la collaborateur·trice et le rendez-vous ne sont pas encore confirmés",
          "TO_BOOK": "En attente du choix du créneau de la part du·de la collaborateur·trice",
          "UPCOMING_PLANNING": "La planification de cette visite débutera à l'approche de l'échéance"
        },
        "statusFilter": {
          "APPOINTMENT_TO_SCHEDULE": "Planification en cours",
          "CANCELLED": "Annulé",
          "CONFIRMED": "Confirmé",
          "EXEMPTED": "Dispensé·e",
          "EXEMPTION_REQUESTED": "Dispense demandée",
          "FINISHED": "Effectué",
          "GHOSTED": "Ghost",
          "LATE_APPOINTMENT_TO_SCHEDULE": "En retard",
          "NO_SHOW": "Non présentation",
          "UPCOMING_PLANNING": "Planification à venir",
          "WAITING_FOR_CONFIRMATION": "En attente de confirmation"
        },
        "tabs": {
          "all": "Toutes les visites",
          "exempted": "Dispenses",
          "past": "Passées",
          "toBook": "À planifier"
        },
        "testData": {
          "action": "Données de test",
          "appointmentEnd": "Fin du rendez-vous",
          "appointmentEndHint": "Le créneau du praticien est recalé sur ces dates.",
          "appointmentNone": "Aucun rendez-vous n'est encore réservé pour cette visite.",
          "appointmentStart": "Début du rendez-vous",
          "appointmentStartHint": "Rapprocher cette date déclenche l'annulation automatique si le rendez-vous n'est pas confirmé. La fin est décalée d'autant.",
          "deadline": "Deadline de la visite",
          "deadlineHint": "Pilote la fenêtre de prise en charge, le nombre de jokers et tous les délais.",
          "forecast": {
            "cadence": "Soit {days, plural, one {# jour} other {# jours}} après l'invitation, le temps que les relances soient envoyées.",
            "due": "Cette date est passée : la réservation partira dès le prochain passage du robot.",
            "earliestAppointmentAt": "Premier créneau réservable le",
            "forceBookAt": "Réservation forcée le",
            "jokers": "Jokers d'annulation alloués",
            "jokersScope": "Estimation sur la fenêtre de deadline. Après une visite ghostée, le job décrémente le cycle précédent à la place : la valeur réelle apparaît une fois le job passé.",
            "noInvitation": "Sans date d'invitation, aucune réservation forcée n'est planifiée. Le robot enverra l'invitation à son prochain passage, puis comptera le délai à partir de cette date.",
            "title": "Ce que fera le robot",
            "windowDelayed": "Les relances arrivent à leur terme avant que la deadline n'entre dans la fenêtre de 3 mois : c'est cette fenêtre qui fixe la date."
          },
          "invitationSentAt": "Date d'envoi de l'invitation",
          "invitationSentAtHint": "Déclenche la réservation automatique une fois le délai écoulé. Vider le champ pour repasser en « jamais invitée ».",
          "jokers": "Jokers d'annulation restants",
          "jokersHint": "Lecture seule. Recalculé automatiquement par le job : vider la date d'invitation pour repartir d'une allocation neuve.",
          "jokersNotAllocated": "Pas encore alloués",
          "jokersReset": "Réinitialiser",
          "jokersResetHint": "Seront réattribués par le job à la prochaine invitation, une fois l'enregistrement fait.",
          "title": "Données de test de la visite",
          "updateSuccess": "Données de test mises à jour pour {name}",
          "warning": "Écriture directe des dates de planification, sans vérification de cohérence. Disponible uniquement en local et sur dev."
        },
        "testPlanification": {
          "bookReturnVisits": "Réservation visites de reprise",
          "cleanupBookAppointmentTasks": "Suppression + mise à jour",
          "cleanupProvisionalVisits": "Suppression visites de reprise auto",
          "handleReadyForBookingTasks": "Invitations + réservations",
          "pending": "En cours...",
          "scheduleMandatoryAppointments": "Planification automatique",
          "title": "Test planification des visites"
        },
        "title": "Visites"
      }
    }
  },
  "components": {
    "agentChat": {
      "attachDocument": "Joindre un document (PDF)",
      "documentUploadError": "Le document n'a pas pu être téléversé.",
      "importDuringTurnError": "L'assistant est encore en train de répondre. Réimportez votre DUERP une fois sa réponse terminée.",
      "messagePlaceholder": "Message",
      "send": "Envoyer"
    },
    "datePicker": {
      "openCalendar": "Ouvrir le calendrier",
      "placeholder": "Sélectionner une date"
    },
    "dateTimePicker": {
      "clear": "Effacer",
      "openPicker": "Ouvrir le sélecteur de date et d'heure",
      "panelLabel": "Choisir une date et une heure",
      "placeholder": "Sélectionner une date et une heure"
    },
    "documentUploadDialog": {
      "complete": "Téléchargement terminé",
      "cta": "Ajouter",
      "dropzone": {
        "dragText": "ou glissez votre fichier",
        "uploadText": "Cliquez pour télécharger"
      },
      "title": "Ajouter un document",
      "uploadErrors": {
        "fileInvalidType": "Le format du fichier n'est pas supporté",
        "fileRejected": "Le fichier n'a pas pu être ajouté",
        "fileTooLarge": "Le fichier est trop gros"
      },
      "uploading": "Téléchargement en cours..."
    },
    "eventCard": {
      "eventType": {
        "conference": "Conférence",
        "webinar": "Webinaire"
      },
      "register": "S'inscrire",
      "watchReplay": "Regarder le replay : {title}"
    },
    "mokacarePartnershipCard": {
      "description": "Identifiez rapidement les risques psychosociaux et obtenez des actions concrètes pour améliorer le bien-être de vos équipes.",
      "openLink": "Ouvrir la page Moka Care (nouvel onglet)",
      "title": "⚡️ Flash audits"
    },
    "multiComboboxField": {
      "selections": "Sélections"
    },
    "numberField": {
      "decrement": "Diminuer",
      "increment": "Augmenter",
      "roleDescription": "Champ numérique"
    },
    "timePicker": {
      "clear": "Effacer",
      "hour": "Heure",
      "minute": "Min.",
      "openPicker": "Ouvrir le sélecteur d'heure",
      "panelLabel": "Choisir une heure",
      "placeholder": "Sélectionner une heure"
    }
  },
  "domain": {
    "abilityComments": {
      "label": "Commentaires hors mesures individuelles"
    },
    "absenceSlotType": {
      "label": "Type d'absence",
      "labels": {
        "LEAVE": "Congés",
        "OTHER": "Autre"
      },
      "notValid": "Le type d'absence n'est pas valide"
    },
    "absenceType": {
      "endDateAfterContractEnd": "La date de fin ne peut pas être après la fin du contrat",
      "endDateBeforeToday": "La date de fin ne peut pas être avant aujourd'hui",
      "endDateMustBeAfterStartDate": "La date de fin doit être après la date de début",
      "label": "Motif",
      "labels": {
        "LONG_LEAVE": "Congé longue durée",
        "MATERNITY": "Congé maternité",
        "NON_PROFESSIONAL_ACCIDENT": "Accident non professionnel",
        "NON_PROFESSIONAL_DISEASE": "Maladie non professionnelle",
        "PARTNER_BIRTH_LEAVE": "Congé de naissance",
        "PARTNER_PARENTAL_LEAVE": "Congé parental",
        "PROFESSIONAL_ACCIDENT": "Accident du travail",
        "PROFESSIONAL_DISEASE": "Maladie professionnelle",
        "SABBATICAL": "Congé sabbatique",
        "SECONDMENT": "Détachement"
      },
      "returnVisitCallout": {
        "notRequired": "Ce type d’absence ne nécessite pas de visite de reprise.",
        "required": "Une visite de reprise sera planifiée automatiquement dans les 8 jours suivant la date de reprise théorique du·de la collaborateur·trice.",
        "soonBooked": "Une visite de reprise sera bientôt programmée."
      },
      "startDateBeforeContractStart": "La date de début ne peut pas être avant le début du contrat",
      "withArticle": {
        "LONG_LEAVE": "un congé longue durée",
        "MATERNITY": "un congé maternité",
        "NON_PROFESSIONAL_ACCIDENT": "un accident non professionnel",
        "NON_PROFESSIONAL_DISEASE": "une maladie non professionnelle",
        "PARTNER_BIRTH_LEAVE": "un congé de naissance",
        "PARTNER_PARENTAL_LEAVE": "un congé parental",
        "PROFESSIONAL_ACCIDENT": "un accident du travail",
        "PROFESSIONAL_DISEASE": "une maladie professionnelle",
        "SABBATICAL": "un congé sabbatique",
        "SECONDMENT": "un détachement"
      }
    },
    "absenceTypeCategory": {
      "labels": {
        "ADMINISTRATIVE": "Absence administrative",
        "MATERNITY": "Absence maternité",
        "NON_PROFESSIONAL": "Absence maladie non liée à un risque professionnel",
        "PROFESSIONAL": "Absence maladie liée à un risque professionnel"
      }
    },
    "absent": "Absent·e",
    "accommodationRecommendation": {
      "label": "Description de l'aménagement"
    },
    "activityLocation": {
      "labels": {
        "COMPANY_BRANCH": "Dans les bureaux",
        "HEALTH_CENTER": "Centre de santé {name}",
        "HOME": "À distance"
      }
    },
    "activityType": {
      "companyBranchIdRequired": "Vous devez sélectionner un adhérent pour ce type d'activité",
      "companyBranchRepresentativeIdRequired": "Vous devez sélectionner un représentant pour ce type d'activité",
      "irpThemes": {
        "labels": {
          "ANNUAL_REPORT": "Rapport annuel",
          "DISABILITY": "Handicap",
          "DUERP_PAPRIPACT": "DUERP / PAPRIPACT",
          "PREVENTION_ACTIONS": "Actions de prévention à mettre en place",
          "SPSTI_PRESENTATION": "Présentation du SPSTI",
          "TMS": "TMS",
          "WORK_ORGANIZATION_RPS": "Organisation / conditions / charge de travail (RPS)"
        }
      },
      "label": "Type d'activité",
      "labels": {
        "AMT": "AMT",
        "COMPANY_BRANCH_MEETING": "Réunion adhérent",
        "COMPANY_SHEET": "Fiche entreprise",
        "HEALTH_SCREENING": "Dépistage",
        "INTERNAL_MEETING": "Réunion interne",
        "IRP_MEETING": "Réunion IRP"
      },
      "labelsForCompanyBranch": {
        "AMT": "Action en Milieu de Travail",
        "COMPANY_BRANCH_MEETING": "Réunion avec un médecin",
        "COMPANY_SHEET": "Fiche Entreprise",
        "HEALTH_SCREENING": "Dépistage",
        "IRP_MEETING": "Réunion des Instances Représentatives du Personnel"
      },
      "notValid": "Le type d'activité n'est pas valide",
      "subtype": {
        "label": "Sous-type",
        "labels": {
          "AWARENESS_ACTION_DISABILITY": "Action de sensibilisation - Handicap",
          "AWARENESS_ACTION_ERGO": "Action de sensibilisation - Ergo",
          "AWARENESS_ACTION_RPS": "Action de sensibilisation - RPS",
          "AWARENESS_ACTION_TMS": "Action de sensibilisation - TMS",
          "CARDIO_SCREENING": "Dépistage cardio",
          "CSE_PARTICIPATION": "Participation CSE",
          "CSSCT": "CSSCT",
          "DERMATO_SCREENING": "Dépistage dermato",
          "DOCTOR_INTRO_CALL": "Call d'intro médecin",
          "DUERP_AWARENESS": "Sensibilisation DUERP",
          "DUERP_REVIEW_AND_ADVICE": "Relecture et conseils DUERP",
          "LIAISON_MEETING": "Réunion de liaison",
          "OTHER": "Autre",
          "PAPRIPACT": "PAPRIPACT",
          "RECOMMENDATION_FOLLOW_UP": "Suivi de reco",
          "RPS_DIAGNOSIS": "Diagnostic - en matière de RPS",
          "TMS_DIAGNOSIS": "Diagnostic - en matière de TMS",
          "WORKSTATION_STUDY": "Étude de poste"
        },
        "notValid": "Le sous-type d'activité n'est pas valide"
      }
    },
    "additionalNotes": {
      "label": "Notes additionnelles"
    },
    "address": {
      "city": {
        "label": "Ville"
      },
      "formatted": "{line}\n{postalCode} {city}",
      "label": "Adresse du siège social",
      "line": {
        "label": "Adresse",
        "placeholder": "ex. 85 Rue Saint-Maur"
      },
      "personnal": {
        "label": "Adresse"
      },
      "placeholder": "ex. 85 RUE SAINT-MAUR",
      "postalCode": {
        "label": "Code postal"
      }
    },
    "alcohol": {
      "label": "Alcool",
      "placeholder": ""
    },
    "alcoholAmount": {
      "label": "Quantité d'alcool"
    },
    "alcoholAmountFrequency": {
      "label": "Fréquence de consommation d'alcool"
    },
    "alcoholConsumption": {
      "label": "Alcool",
      "labels": {
        "HISTORY": "Antécédent",
        "NO": "Non",
        "YES": "Oui"
      },
      "unit": "{alcoholConsumption} ({alcoholAmount, number} verre(s) / {alcoholAmountFrequency})"
    },
    "alcoholTypes": {
      "addOne": "Ajouter un type",
      "label": "Type de alcool",
      "placeholder": ""
    },
    "allergies": {
      "addOne": "Ajouter une allergie",
      "label": "Allergies",
      "placeholder": "ex. Allergie aux pollens"
    },
    "appointmentState": {
      "labels": {
        "CANCELLED": "Annulée",
        "CONDITIONS_NOT_MET": "Conditions non réunies",
        "FINISHED": "Terminée",
        "INVALID": "Rendez-vous manqué",
        "LATE_EMPLOYEE": "Collaborateur·trice en retard",
        "LATE_MEDICAL_STAFF": "Médecin en retard",
        "NO_SHOW_EMPLOYEE": "Collaborateur·trice absent·e",
        "NO_SHOW_MEDICAL_STAFF": "Médecin absent·e",
        "ONGOING": "En cours",
        "ORIENTATION_ERROR": "Erreur d'orientation",
        "PENDING_SUBMISSION": "Brouillon",
        "PROVISIONAL": "En attente du retour du·de la collaborateur·trice",
        "TO_BOOK": "Planification en cours",
        "UPCOMING": "À venir",
        "UPCOMING_PLANNING": "Planification à venir",
        "WAITING_MEDICAL_STAFF": "Médecin en retard"
      }
    },
    "assessmentAdditionalInformation": {
      "label": "Informations additionnelles",
      "placeholder": ""
    },
    "assessmentOfMentalHealth": {
      "label": "Evaluation d'état mental",
      "placeholder": ""
    },
    "assessmentOfMusculoskeletalSystem": {
      "label": "Evaluation de l'appareil locomoteur",
      "placeholder": ""
    },
    "assessmentOfRecentSymptoms": {
      "label": "Evaluation des symptômes récents",
      "placeholder": ""
    },
    "birthDate": {
      "label": "Date de naissance",
      "placeholder": "ex. 03/11/1987"
    },
    "birthFirstName": {
      "label": "Prénom de naissance",
      "placeholder": "ex. Jean"
    },
    "birthLastName": {
      "label": "Nom de naissance",
      "placeholder": "ex. Jean"
    },
    "birthLocationCode": {
      "label": "Lieu de naissance",
      "loading": "Chargement…",
      "noResult": "Aucune commune trouvée",
      "placeholder": "ex. Paris 12"
    },
    "birthdate": {
      "label": "Date de naissance",
      "placeholder": "ex. 03/11/1987"
    },
    "birthday": {
      "label": "Date de naissance",
      "placeholder": "ex. 03/11/1987"
    },
    "bloodPressure": {
      "label": "Tension artérielle",
      "placeholder": "Tension artérielle en mmHg",
      "unit": "{systolicBloodPressure, number} / {diastolicBloodPressure, number} mmHg"
    },
    "bloodSugarLevel": {
      "label": "Glycémie",
      "placeholder": "Glycémie en g/L",
      "unit": "{bloodSugarLevel, number} g/L"
    },
    "bmi": {
      "label": "IMC",
      "value": "{value, number, ::.##} kg/m²"
    },
    "bodyMeasurements": {
      "label": "Poids et taille"
    },
    "bookingSlotTypePicker": {
      "label": "Type de consultation"
    },
    "checkupFormField": {
      "abilityComments": {
        "label": "Commentaires hors mesures individuelles",
        "placeholder": "Entrez ici les commentaires hors mesures individuelles..."
      },
      "accommodationRecommendation": {
        "label": "Description de l'aménagement",
        "placeholder": "Entrez ici la description de l'aménagement..."
      },
      "additionalNotes": {
        "label": "Notes",
        "placeholder": "Entrer ici les notes...",
        "title": "Notes additionnelles"
      },
      "alcohol": {
        "consumption": "Consommation",
        "frequency": "Fréquence",
        "frequencyValue": "{value, number, integer} fois / {period}",
        "title": "Alcool"
      },
      "appointmentContext": {
        "assessmentAdditionalInformation": "Informations additionnelles",
        "assessmentOfMentalHealth": "État mental",
        "assessmentOfMusculoskeletalSystem": "Appareil locomoteur",
        "assessmentOfRecentSymptoms": "Symptômes récents",
        "title": "Contexte de la visite"
      },
      "clinicalExamNotes": {
        "label": "Commentaires",
        "placeholder": "Entrez ici les commentaires…",
        "title": "Commentaires de l'examen clinique"
      },
      "consumption": "Consommation",
      "diet": {
        "frequencyValue": "{value, number, integer} repas / jour",
        "numberOfMealsPerDay": "Nombre de repas par jour",
        "title": "Alimentation"
      },
      "drug": {
        "add": "Ajouter une drogue",
        "consumption": "Consommation",
        "frequency": "Fréquence",
        "frequencyValue": "{value, number, integer} fois / {period}",
        "title": "Drogue",
        "type": "Type"
      },
      "drugTreatments": {
        "add": "Ajouter un médicament",
        "label": "Médicaments",
        "placeholder": "Entrer le nom du médicament"
      },
      "eatingHabits": {
        "placeholder": "Habitudes alimentaires...",
        "title": "Alimentation"
      },
      "examDeviceIcd11": {
        "placeholder": "Rechercher un examen CIM-11..."
      },
      "familyComposition": {
        "label": "Composition familiale",
        "placeholder": "ex. Célibataire, sans enfant"
      },
      "farVision": {
        "label": "Vision de loin",
        "leftEye": "Oeil gauche",
        "rightEye": "Oeil droit",
        "shortLabel": "Vue (VL)",
        "value": "OD : {rightEye, number, ::.##} / OG : {leftEye, number, ::.##}"
      },
      "internalConclusion": {
        "label": "Conclusion interne",
        "placeholder": "Entrez ici la conclusion interne..."
      },
      "jobDescription": {
        "label": "Description du poste de travail",
        "placeholder": "Missions, tâches, responsabilités, etc."
      },
      "nearVision": {
        "label": "Vision de près",
        "leftEye": "Oeil gauche",
        "rightEye": "Oeil droit",
        "shortLabel": "Vue (VP)",
        "value": "OD : {rightEye, number, ::.##} / OG : {leftEye, number, ::.##}"
      },
      "paramedicalFollowUp": {
        "label": "Suivi paramédical / rééducation",
        "placeholder": "ex. Rééducation orthopédique, kinésithérapie..."
      },
      "pathologiesIcd11": {
        "placeholder": "Rechercher une pathologie CIM-11..."
      },
      "personnalMedicalBackground": {
        "label": "Autre",
        "placeholder": "Autres antécédents médicaux"
      },
      "physicalActivity": {
        "add": "Ajouter une activité physique",
        "frequencyValue": "{value, number, integer} fois / {period}",
        "placeholder": "ex. Course à pied, natation...",
        "title": "Activité physique"
      },
      "psychosocialContext": {
        "label": "Contexte psychosocial",
        "placeholder": "Entrer ici le contexte psychosocial"
      },
      "reclassificationIndications": {
        "label": "Conclusions et indications relatives au reclassement",
        "placeholder": "Entrez ici les conclusions et indications relatives au reclassement..."
      },
      "sleep": {
        "duration": "Heures de sommeil / nuit",
        "durationValue": "{value, number, integer} heures / nuit",
        "quality": "Qualité du sommeil",
        "title": "Sommeil"
      },
      "specificWorkingConditions": {
        "add": "Ajouter une condition",
        "label": "Conditions spécifiques de travail",
        "placeholder": "ex. Travail de nuit"
      },
      "surgeries": {
        "label": "Opérations",
        "placeholder": "ex. Chirurgies, hospitalisations..."
      },
      "tobacco": {
        "consumption": "Consommation",
        "frequency": "Paquet(s) / année",
        "frequencyValue": "{value, number, integer} paquet(s) / année",
        "title": "Tabac"
      },
      "vaccineStatus": {
        "label": "Statut vaccinal",
        "options": {
          "notUpToDate": "Non à jour",
          "unknown": "Ne sait pas",
          "upToDate": "À jour"
        }
      },
      "workingHours": {
        "label": "Horaires de travail",
        "placeholder": "ex. 8h-17h"
      }
    },
    "city": {
      "label": "Ville",
      "placeholder": "ex. Paris"
    },
    "clinicalExamNotes": {
      "label": "Commentaires de l'examen clinique",
      "placeholder": "Entrez ici les commentaires…"
    },
    "clinicalExamObservations": {
      "label": "Observations cliniques générales",
      "placeholder": ""
    },
    "collaborator": {
      "label": "Collaborateur·trice"
    },
    "companyBranch": {
      "label": "Adhérent"
    },
    "consentToShareDisabilityInformation": {
      "label": "Le·la collaborateur·trice accepte que le handicap (RQTH/invalidité) soit communiqué à son employeur·euse, dans le respect des règles de confidentialité en santé au travail.",
      "labelShort": "Consentement à partager à l'employeur·euse",
      "labels": {
        "NO": "Non",
        "YES": "Oui"
      }
    },
    "consultationType": {
      "appointment": {
        "IN_PERSON_CONSULTATION": "Physique",
        "TELECONSULTATION": "Téléconsultation"
      },
      "hints": {
        "IN_PERSON_CONSULTATION": "La visite physique aura lieu au <span>{address}</span>",
        "TELECONSULTATION": "La téléconsultation devra avoir lieu dans un lieu isolé, avec une bonne connexion internet, une caméra et un micro."
      },
      "label": "Type de consultation",
      "labels": {
        "IN_PERSON_CONSULTATION": "Consultation physique",
        "TELECONSULTATION": "Téléconsultation"
      },
      "notValid": "Le type de consultation n'est pas valide",
      "slotNotValid": "Le type de créneau n'est pas valide",
      "unavailable": "Ce type de consultation ne peut être réalisé à distance."
    },
    "contractEndDate": {
      "label": "Date de fin du contrat",
      "placeholder": "ex. 23/01/2020"
    },
    "contractStartDate": {
      "label": "Date de début du contrat",
      "placeholder": "ex. 03/11/1987"
    },
    "contractType": {
      "label": "Type de contrat",
      "label_plural": "Types de contrat",
      "labels": {
        "APPRENTICE": "Contrat d'apprentissage",
        "CDD": "CDD",
        "CDI": "CDI",
        "CIVIL_SERVANT": "Fonctionnaire",
        "OTHER": "Autre",
        "PART_TIME": "Contrat de professionnalisation",
        "SELF_EMPLOYED_EXECUTIVE": "Dirigeant·e non salarié·e",
        "TEMPORARY_WORK_CONTRACT": "Contrat d'intérim",
        "TRAINEE": "Stagiaire",
        "UNKNOWN": "Non renseigné"
      },
      "notValid": "Le type de contrat n'est pas valide",
      "placeholder": "ex. CDI"
    },
    "dataUpToDate": {
      "label": "À jour"
    },
    "date": {
      "mustBeAfter": "La date doit être après {date, date, shortUtc}",
      "mustBeBefore": "La date doit être avant {date, date, shortUtc}",
      "mustBeTodayOrFuture": "La date doit être aujourd'hui ou dans le futur",
      "notValid": "La date n'est pas valide"
    },
    "dateRange": {
      "from": "Du",
      "to": "au"
    },
    "department": {
      "emptyResult": "Aucun pôle trouvé",
      "label": "Pôle",
      "nLabel": "{count, plural, one {{count} pôle} other {{count} pôles}}",
      "placeholder": "ex. Qualité"
    },
    "diastolicBloodPressure": {
      "label": "Tension artérielle diastolique",
      "placeholder": "Tension artérielle diastolique"
    },
    "diet": {
      "label": "Alimentation",
      "labels": {
        "FAIRLY_BALANCED": "Plutôt équilibrée",
        "FAIRLY_UNBALANCED": "Plutôt déséquilibrée",
        "HEALTHY": "Saine",
        "UNBALANCED": "Déséquilibrée"
      }
    },
    "disability": {
      "label": "Handicap"
    },
    "disabledWorker": {
      "label": "Reconnaissance de la Qualité de Travailleur Handicapé",
      "placeholder": ""
    },
    "disabledWorkerUntil": {
      "label": "Date de fin de reconnaissance",
      "placeholder": ""
    },
    "doctorReferral": {
      "labels": {
        "COMPLEX_PATHOLOGY": "Pathologies complexes nécessitant un avis médical",
        "CONFLICTS_WITH_WORKSTATION_DESIGN": "Conflits liés à l'aménagement du poste de travail",
        "SERIOUS_SYMPTOMS_OR_MEDICAL_EMERGENCY": "Symptômes graves ou urgence médicale",
        "SUSPICION_OF_UNFITNESS_FOR_WORK": "Suspicion d'inaptitude au poste",
        "WISH_TO_CONSULT_A_DOCTOR": "Le·la collaborateur·trice souhaite consulter le médecin du travail"
      }
    },
    "document": {
      "documentType": {
        "labels": {
          "ABILITY_CERTIFICATE": "Avis d'aptitude",
          "ACCOMMODATION_CERTIFICATE": "Proposition d'aménagement",
          "ADDITIONAL_EXAM_RESULT": "Résultats d'examens complémentaires",
          "APPOINTMENT_EXEMPTION_REQUEST": "Demande de dispense de visite",
          "APPOINTMENT_MODIFICATION_REQUEST": "Demande de modification de visite",
          "CHECKUP_CERTIFICATE": "Attestation de suivi",
          "CHECKUP_DOCUMENTS": "Document de téléconsultation",
          "COLLABORATORS_IMPORT": "Import de collaborateurs·trices",
          "COLLABORATORS_UPDATE": "Mise à jour de collaborateurs·trices",
          "COMPANY_SHEET": "Fiche d'entreprise",
          "CONFIDENTIAL_EMPLOYEE_DOCUMENT": "Document confidentiel collaborateur·trice",
          "CONSENT": "Consentement",
          "DMST": "DMST",
          "DRIVING_RISKY_VEHICLES_ABILITY_CERTIFICATE": "Non-contre-indication pour la conduite d’engins à risque",
          "DUERP": "DUERP",
          "EXTERNAL_REFERRAL_LETTER": "Lettre d'adressage extérieure",
          "IDENTITY_DOCUMENT": "Document d'identité",
          "IMPORTANT_ELECTRICAL_RISKS_ABILITY_CERTIFICATE": "Non-contre-indication pour les opérations électriques à risque important",
          "INABILITY_CERTIFICATE": "Avis d'inaptitude",
          "JOB_ASSESSMENT": "Étude de poste",
          "MEDICAL_INFORMATIONS_IMPORT": "Import de données médicales",
          "MEDICAL_OR_HOSPITALIZATION_REPORT": "Compte-rendu médical ou d'hospitalisation",
          "MULTIDISCIPLINARY_TEAM_REFERRAL_LETTER": "Lettre d'adressage par l'équipe pluridisciplinaire",
          "OTHER": "Autre document",
          "PDP": "PDP",
          "PRERETURN_LETTER": "Courrier de pré-reprise",
          "PRESCRIPTION": "Ordonnance",
          "RQTH_OR_INVALIDITY": "RQTH ou invalidité",
          "SICK_LEAVE": "Arrêt de travail",
          "TEMPORARY_INABILITY_CERTIFICATE": "Inaptitude temporaire"
        }
      }
    },
    "drug": {
      "label": "Drogue",
      "placeholder": ""
    },
    "drugConsumption": {
      "details": "{type} - {amount, number} fois / {period}",
      "label": "Drogue",
      "labels": {
        "NO": "Non",
        "YES": "Oui"
      },
      "unit": "{drugConsumption}\n\n{drugDetails}"
    },
    "drugFrequency": {
      "label": "Fréquence",
      "placeholder": ""
    },
    "drugTreatments": {
      "addOne": "Ajouter un médicament",
      "label": "Médicaments",
      "placeholder": ""
    },
    "drugType": {
      "labels": {
        "CANNABIS": "Cannabis",
        "COCAINE": "Cocaïne",
        "HEROIN": "Héroïne",
        "KETAMINE": "Kétamine",
        "LSD": "LSD",
        "MDMA": "MDMA",
        "NITROUS_OXIDE": "Protoxyde d'azote"
      }
    },
    "drugTypes": {
      "addOne": "Ajouter un type",
      "label": "Type de drogue",
      "placeholder": ""
    },
    "duerp": {
      "document": {
        "uploaded": "Importé le {date, date, long} \npar {createdBy}"
      },
      "event": {
        "ENDED_SUPPORT": "Accompagnement terminé",
        "LAUNCHED_SUPPORT": "Lancement d'un accompagnement",
        "REMOVED_DOCUMENT": "Suppression d'un fichier",
        "UPDATED_SUPPORT": "Modification d'un accompagnement",
        "UPLOADED_DOCUMENT": "Import d'un fichier"
      },
      "support": {
        "assignment": "Assigné à {name}",
        "noneAssigned": "Non assigné",
        "reassignment": "Réassigné à {name}"
      }
    },
    "duerpSupportPractitioner": {
      "assigned": "Par {firstName} {lastName}",
      "label": "Professionnel·le assigné·e",
      "noneAssigned": "Aucune personne assignée"
    },
    "duerpSupportType": {
      "for": "Pour : ",
      "label": "Type d'accompagnement",
      "options": {
        "RISK_ASSESSMENT_SUPPORT": "Évaluation des risques",
        "WRITING_SUPPORT": "Rédaction"
      }
    },
    "eatingHabits": {
      "label": "Habitudes alimentaires",
      "placeholder": ""
    },
    "email": {
      "label": "Email",
      "notValid": "Cet email n'est pas valide",
      "placeholder": "ex. jean@dupont.fr"
    },
    "employeePicker": {
      "label": "Collaborateur·trice"
    },
    "empty": "Non renseigné",
    "enterprise": {
      "label": "Entreprise",
      "placeholder": "ex. Sano"
    },
    "examDeviceSystem": {
      "abdominal": {
        "clinicalExamNotes": {
          "label": "Examen clinique abdominal"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies abdominales"
        }
      },
      "cardiovascular": {
        "clinicalExamNotes": {
          "label": "Examen clinique cardiovasculaire"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies cardiovasculaires"
        }
      },
      "dermatological": {
        "clinicalExamNotes": {
          "label": "Examen clinique dermatologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies dermatologiques"
        }
      },
      "ent": {
        "clinicalExamNotes": {
          "label": "Examen clinique ORL"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies ORL"
        }
      },
      "gastrointestinal": {
        "clinicalExamNotes": {
          "label": "Examen clinique gastro-intestinal"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies gastro-intestinales"
        }
      },
      "gynecological": {
        "clinicalExamNotes": {
          "label": "Examen clinique gynécologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies gynécologiques"
        }
      },
      "metabolicEndocrinological": {
        "clinicalExamNotes": {
          "label": "Examen clinique métabolique endocrinologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies métaboliques endocrinologiques"
        }
      },
      "neurological": {
        "clinicalExamNotes": {
          "label": "Examen clinique neurologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies neurologiques"
        }
      },
      "ophthalmological": {
        "clinicalExamNotes": {
          "label": "Examen clinique ophtalmologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies ophtalmologique"
        }
      },
      "orthopedicRheumatological": {
        "clinicalExamNotes": {
          "label": "Examen clinique orthopédique rhumatologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies orthopédiques rhumatologique"
        }
      },
      "psychiatry": {
        "clinicalExamNotes": {
          "label": "Examen clinique psychiatrique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies psychiatriques"
        }
      },
      "respiratory": {
        "clinicalExamNotes": {
          "label": "Examen clinique respiratoire"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies respiratoires"
        }
      },
      "uroNephrological": {
        "clinicalExamNotes": {
          "label": "Examen clinique uro-néphrologique"
        },
        "pathologiesIcd11Codes": {
          "label": "Pathologies uro-néphrologiques"
        }
      }
    },
    "familyComposition": {
      "label": "Composition familiale",
      "placeholder": ""
    },
    "familyName": {
      "label": "Nom d'usage",
      "placeholder": "ex. Dupont"
    },
    "farVision": {
      "label": "Vision de loin",
      "value": {
        "leftEye": "OG : {leftEye, number, ::.##}",
        "rightEye": "OD : {rightEye, number, ::.##}"
      }
    },
    "farVisionLeftEye": {
      "label": "Vision de loin gauche"
    },
    "farVisionRightEye": {
      "label": "Vision de loin droite"
    },
    "firstName": {
      "label": "Prénom",
      "placeholder": "ex. Jean"
    },
    "followUpDeadline": {
      "label": "Date de prochaine visite"
    },
    "followUpPractitionerId": {
      "label": "Professionnel de santé"
    },
    "followUpVisitType": {
      "label": "Type de visite"
    },
    "frequency": {
      "label": "Fréquence",
      "labels": {
        "EVERY_DAY": "Tous les jours",
        "FEW_TIMES_A_DAY": "Quelques fois par jour",
        "FEW_TIMES_A_WEEK": "Quelques fois par semaine",
        "OCCASIONALLY": "Occasionnellement"
      },
      "notValid": "La fréquence n'est pas valide",
      "placeholder": "Quelques fois par semaine"
    },
    "fullName": {
      "label": "Nom complet",
      "placeholder": "ex. Jean Dupont"
    },
    "healthCenterEmployeePicker": {
      "atLeastOne": "Vous devez ajouter au moins un professionnel de santé",
      "label": "Professionnel de santé",
      "search": "Ajouter des professionnels"
    },
    "heartRate": {
      "label": "Fréquence cardiaque",
      "placeholder": "Fréquence cardiaque en bpm",
      "unit": "{heartRate, number} bpm"
    },
    "height": {
      "label": "Taille",
      "placeholder": "Taille en cm",
      "unit": "{height, number} cm"
    },
    "internalConclusion": {
      "label": "Conclusion interne"
    },
    "invalidity": {
      "label": "Invalidité",
      "notDeclared": "Non déclarée",
      "placeholder": ""
    },
    "invalidityCategory": {
      "label": "Invalidité",
      "labels": {
        "FIRST_CATEGORY": "Catégorie 1",
        "NONE": "Aucune",
        "SECOND_CATEGORY": "Catégorie 2",
        "THIRD_CATEGORY": "Catégorie 3"
      },
      "notValid": "La catégorie d'invalidité n'est pas valide",
      "placeholder": "ex. Catégorie 1"
    },
    "isNewEmployee": {
      "label": "Aucun historique médecine et prévention au travail",
      "tooltip": "Lorsque cette case est cochée, le système lancera la planification d'une visite initiale pour le·la collaborateur·trice"
    },
    "jobDescription": {
      "label": "Description du poste de travail"
    },
    "jobTitle": {
      "emptyResult": "Aucun poste de travail trouvé",
      "label": "Poste de travail",
      "placeholder": "ex. Ingénieur qualité"
    },
    "lastCheckupDate": {
      "label": "Date de dernière visite périodique",
      "placeholder": "ex. 03/11/1987"
    },
    "lastCheckupDateAtOnboarding": {
      "label": "Date de dernière visite périodique",
      "placeholder": "ex. 03/11/1987"
    },
    "lastName": {
      "label": "Nom",
      "placeholder": "ex. Dupont"
    },
    "legalForm": {
      "emptyResult": "Aucune structure juridique trouvée",
      "label": "Structure juridique",
      "notValid": "La structure juridique n'est pas valide",
      "placeholder": "ex. Société par actions simplifiée",
      "search": "Rechercher une structure juridique"
    },
    "legalName": {
      "label": "Dénomination légale",
      "placeholder": "ex. Mon entreprise"
    },
    "lifestyleItemFrequency": {
      "labels": {
        "DAILY": "jour",
        "MONTHLY": "mois",
        "WEEKLY": "semaine",
        "YEARLY": "année"
      }
    },
    "line": {
      "label": "Adresse"
    },
    "medicalComplementaryInformation": {
      "label": "Evaluation complémentaire du médecin",
      "placeholder": ""
    },
    "medicalExaminationDatePicker": {
      "label": "Date de visite"
    },
    "medicalRecordConclusion": {
      "doctorOnly": "Réservée au médecin : réorientez le salarié vers un médecin pour la délivrer",
      "label": "Conclusion de la visite",
      "labels": {
        "ABILITY": "Aptitude",
        "ABILITY_WITH_ACCOMODATION_OR_RESTRICTION": "Proposition d'aménagement",
        "DRIVING_RISKY_VEHICLES_ABILITY": "Absence de contre-indication pour la conduite d’engins à risque",
        "FOLLOW_UP_CERTIFICATE": "Attestation de suivi",
        "IMPORTANT_ELECTRICAL_RISKS_ABILITY": "Absence de contre-indication pour les opérations électriques à risque important",
        "INABILITY": "Inaptitude",
        "TEMPORARY_INABILITY": "Aucun document"
      },
      "notValid": "La conclusion n'est pas valide"
    },
    "medicalRecordConclusionDocuments": {
      "label": "Types de documents à générer"
    },
    "medicalRecordConclusions": {
      "ABILITY": {
        "label": "Document(s) de fin de visite"
      },
      "ABILITY_WITH_ACCOMODATION_OR_RESTRICTION": {
        "label": "Document(s) de fin de visite"
      },
      "DRIVING_RISKY_VEHICLES_ABILITY": {
        "label": "Document(s) de fin de visite"
      },
      "FOLLOW_UP_CERTIFICATE": {
        "label": "Document(s) de fin de visite"
      },
      "IMPORTANT_ELECTRICAL_RISKS_ABILITY": {
        "label": "Document(s) de fin de visite"
      },
      "INABILITY": {
        "label": "Document(s) de fin de visite"
      },
      "TEMPORARY_INABILITY": {
        "label": "Document(s) de fin de visite"
      }
    },
    "medicalRecordDoctorReferral": {
      "label": "Réorientation vers un médecin",
      "placeholder": ""
    },
    "medicalRecordNextVisit": {
      "label": "Date de prochaine visite périodique",
      "placeholder": ""
    },
    "medicalRecordNoteType": {
      "label": "Type de note",
      "labels": {
        "EXTERNAL_EXCHANGE": "Échange extérieur",
        "INTERNAL_NOTE": "Note interne",
        "STAFF_REVIEW": "Revue staff"
      },
      "notValid": "Le type de note n'est pas valide",
      "placeholder": "Sélectionner un type"
    },
    "medicalRecordRecommendations": {
      "label": "Recommandations et suite à donner",
      "placeholder": ""
    },
    "meetingType": {
      "label": "Type de réunion",
      "labels": {
        "IN_PERSON_MEETING": "En présentiel",
        "REMOTE_MEETING": "En visio"
      },
      "notValid": "Le type de réunion n'est pas valide"
    },
    "memberBranchPicker": {
      "label": "Adhérent"
    },
    "message": {
      "label": "Messages"
    },
    "missingInformation": {
      "label": "Informations manquantes"
    },
    "missions": {
      "label": "Missions et tâches",
      "placeholder": "Contenu"
    },
    "monitoringType": {
      "badges": {
        "ADAPTED_INDIVIDUAL": "SIA",
        "REINFORCED_INDIVIDUAL": "SIR",
        "SIMPLE_INDIVIDUAL": "SIS"
      },
      "label": "Type de suivi",
      "label_plural": "Types de suivi",
      "labels": {
        "ADAPTED_INDIVIDUAL": "Suivi individuel adapté",
        "REINFORCED_INDIVIDUAL": "Suivi individuel renforcé",
        "SIMPLE_INDIVIDUAL": "Suivi individuel simple",
        "UNKNOWN": "Non renseigné"
      },
      "notValid": "Le type de suivi n'est pas valide",
      "placeholder": "ex. Suivi individuel simple"
    },
    "nafCode": {
      "emptyResult": "Aucun code NAF trouvé",
      "label": "Code NAF",
      "notValid": "Le code NAF n'est pas valide",
      "placeholder": "ex. 6201Z • Programmation informatique",
      "search": "Rechercher un code NAF"
    },
    "nearVision": {
      "label": "Vision de près",
      "value": {
        "leftEye": "OG : {leftEye, number, ::.##}",
        "rightEye": "OD : {rightEye, number, ::.##}"
      }
    },
    "nearVisionLeftEye": {
      "label": "Vision de près gauche"
    },
    "nearVisionRightEye": {
      "label": "Vision de près droite"
    },
    "nextMedicalVisitDateAtOnboarding": {
      "label": "Date de prochaine visite périodique",
      "placeholder": "ex. 03/11/1987"
    },
    "nextPeriodicCheckup": {
      "label": "Date de prochaine visite périodique",
      "placeholder": ""
    },
    "noHistory": {
      "description": "Sélectionner un autre champ pour afficher son historique.",
      "label": "Pas d'historique disponible"
    },
    "number": {
      "notValid": "La valeur n'est pas valide"
    },
    "numberOfMealsPerDay": {
      "label": "Nombre de repas par jour",
      "unit": "{value, number, integer} repas / jour"
    },
    "nursingVisitAct": {
      "labels": {
        "BLOOD_PRESSURE_CHECK": "Prise de tension",
        "BLOOD_SUGAR_CHECK": "Glycémie capillaire",
        "EMERGENCY_PROTOCOL_CARE": "Soin selon protocole d'urgence",
        "INJECTION": "Injection",
        "MEDICATION_ADMINISTRATION": "Administration de médicament",
        "OTHER_ACT": "Autre acte",
        "SUTURE_REMOVAL": "Ablation de fils",
        "TEMPERATURE_CHECK": "Prise de température",
        "WOUND_DRESSING": "Pansement"
      }
    },
    "nursingVisitActSupervisionLevel": {
      "labels": {
        "EMERGENCY_PROTOCOL": "Protocole d'urgence",
        "NONE": "Sans encadrement",
        "PRESCRIPTION": "Sur ordonnance"
      }
    },
    "nursingVisitNature": {
      "labels": {
        "CARE": "Soin",
        "INTERVIEW": "Entretien"
      }
    },
    "nursingVisitOrientation": {
      "labels": {
        "BACK_HOME": "Retour au domicile",
        "BACK_TO_WORK": "Retour au poste",
        "EMERGENCY_SERVICES": "Urgences",
        "GENERAL_PRACTITIONER": "Médecin traitant",
        "REFUSAL_AFTER_INFORMATION": "Refus après information",
        "SPECIALIST": "Spécialiste"
      }
    },
    "nursingVisitReason": {
      "labels": {
        "ALLERGIC_REACTION": "Réaction allergique",
        "BURN": "Brûlure",
        "CHEST_PAIN": "Douleur thoracique",
        "DIGESTIVE_DISORDER": "Trouble digestif",
        "FOLLOW_UP_CARE": "Soin de suivi",
        "HEADACHE": "Céphalée",
        "HEALTH_ADVICE": "Conseil santé",
        "MALAISE": "Malaise",
        "MUSCULOSKELETAL_PAIN": "Douleur musculo-squelettique",
        "OTHER_CARE": "Autre soin",
        "OTHER_INTERVIEW": "Autre entretien",
        "PSYCHOLOGICAL_DISTRESS": "Détresse psychologique",
        "WORK_DISTRESS": "Souffrance au travail",
        "WOUND": "Plaie"
      }
    },
    "occupationalHealthService": {
      "label": "Service médical"
    },
    "organizationUnit": {
      "emptyResult": "Aucune division trouvée",
      "label": "Division",
      "nLabel": "{count, plural, one {{count} division} other {{count} divisions}}",
      "placeholder": "ex. Direction générale"
    },
    "paramedicalFollowUp": {
      "label": "Suivi paramédical / rééducation",
      "placeholder": ""
    },
    "parent1MedicalBackground": {
      "label": "Parent 1",
      "placeholder": "ex. Diabète, hypertension..."
    },
    "parent2MedicalBackground": {
      "label": "Parent 2",
      "placeholder": "ex. Diabète, hypertension..."
    },
    "pathologiesIcd11Codes": {
      "label": "Pathologies"
    },
    "pcsCode": {
      "emptyResult": "Aucune profession INSEE trouvée",
      "fullList": "Liste complète",
      "label": "Profession INSEE",
      "notValid": "La profession INSEE n'est pas valide",
      "placeholder": "ex. Ingénieurs / Ingénieures et cadres de production",
      "search": "Rechercher une profession INSEE",
      "suggestions": "Suggestions"
    },
    "pdp": {
      "actions": {
        "assignedPractitionerIds": {
          "label": "Personne(s) assigné·e·s",
          "placeholder": "Sélectionnez des membres de l’équipe"
        },
        "deadline": {
          "label": "Échéance",
          "placeholder": "jj/mm/aaaa"
        },
        "description": {
          "label": "Description",
          "placeholder": "Décrivez l’action à réaliser..."
        },
        "status": {
          "label": "Statut",
          "labels": {
            "COMPLETED": "Terminé",
            "IN_PROGRESS": "En cours",
            "PENDING": "À faire"
          },
          "notValid": "Le statut de l'action n'est pas valide",
          "placeholder": "À faire"
        },
        "title": {
          "label": "Titre",
          "placeholder": "Ex : Consultation avec un psychologue"
        },
        "type": {
          "label": "Type d'action",
          "labels": {
            "CAP_EMPLOI_LIAISON": "Lien Cap Emploi",
            "CONTACT": "Prise de contact",
            "EMPLOYER_HR_CONTACT": "Contact employeur / RH",
            "ERGONOMIC_WORKSTATION_STUDY": "Étude de poste ergonomique",
            "OTHER": "Autre (préciser en description)",
            "REFERRAL_TO_PRIMARY_CARE_PHYSICIAN": "Orientation vers médecin traitant",
            "REFERRAL_TO_SPECIALIST": "Orientation vers spécialiste",
            "RQTH": "RQTH",
            "SKILLS_ASSESSMENT_OR_RETRAINING": "Bilan de compétences / Reconversion",
            "SOCIAL_ASSISTANCE_REFERRAL": "Orientation assistance sociale",
            "SOCIAL_INSURANCE_CONTACT": "Contact CPAM / MDPH / CRAMIF",
            "THERAPEUTIC_PART_TIME": "Mi-temps thérapeutique",
            "WORKSTATION_ADAPTATION": "Aménagement de poste"
          },
          "notValid": "Le type de l'action n'est pas valide",
          "placeholder": "Sélectionnez un type d'action"
        }
      },
      "completionReason": {
        "label": "Motif de clôture",
        "placeholder": "Veuillez préciser le motif de la clôture (ex: objectifs atteints, retour au travail réussi, etc...)"
      },
      "history": {
        "changes": {
          "deadline": "Échéance :",
          "description": "Description :",
          "title": "Titre :",
          "type": "Type :"
        },
        "event": {
          "ACTION_CREATED": "Création d'une action : {action}",
          "ACTION_DELETED": "Suppression d'une action : {action}",
          "ACTION_STATUS_CHANGED": "Changement de statut de l'action : {action}",
          "ACTION_UPDATED": "Modification d'une action : {action}",
          "DOCUMENT_DELETED": "Suppression de document : {document}",
          "DOCUMENT_UPLOADED": "Ajout de document : {document}",
          "ORIENTATION_REASON_CATEGORY_UPDATED": "Modification du type de signalement",
          "ORIENTATION_REASON_UPDATED": "Modification du motif d'orientation",
          "PDP_ACCEPTED": "Dossier PDP accepté",
          "PDP_COMPLETED": "Dossier PDP clôturé",
          "PDP_CREATED": "Création dossier PDP",
          "PDP_INTERRUPTED": "Dossier PDP interrompu",
          "PDP_REFUSED": "Dossier PDP refusé",
          "PRACTITIONER_ASSIGNED": "Action \"{action}\" assignée à {practitioner}",
          "PRACTITIONER_UNASSIGNED": "Action \"{action}\" désassignée à {practitioner}"
        }
      },
      "interruptionReason": {
        "label": "Motif d'interruption",
        "placeholder": "Veuillez préciser le motif de l’interruption du dossier..."
      },
      "isRqthRequestAssociated": {
        "label": "Une demande de reconnaissance RQTH a-t-elle ou va-t-elle être effectuée ?"
      },
      "orientationReason": {
        "label": "Motif de l'orientation",
        "placeholder": "Ajoutez ici les éléments utiles à la cellule PDP..."
      },
      "orientationReasonCategory": {
        "label": "Type de signalement",
        "labels": {
          "MEDICAL": "Médical",
          "OTHER": "Autre",
          "SOCIAL": "Social"
        },
        "notValid": "Le type de signalement n'est pas valide",
        "placeholder": "Sélectionnez un type de signalement"
      },
      "outcome": {
        "label": "Issue du dossier",
        "labels": {
          "DISMISSAL_EXCLUDING_UNFITNESS": "Licenciement (hors inaptitude)",
          "INITIAL_POSITION_RETENTION": "Maintien au poste initial",
          "JOB_RETENTION_AT_OTHER_POSITION": "Maintien à un autre poste dans l'entreprise",
          "OUTPLACEMENT": "Reclassement externe",
          "UNFITNESS_FOR_WORK": "Inaptitude"
        },
        "notValid": "L'issue du dossier n'est pas valide"
      },
      "refusalReason": {
        "label": "Motif de refus",
        "placeholder": "Ajoutez ici le motif de refus du·de la collaborateur·trice..."
      },
      "reportingSource": {
        "label": "Source du signalement",
        "labels": {
          "EMPLOYEE": "La personne elle-même",
          "EMPLOYER": "Employeur",
          "MEDICAL_OFFICER": "Médecin conseil",
          "OCCUPATIONAL_PHYSICIAN": "Médecin du travail",
          "PRIMARY_CARE_PHYSICIAN": "Médecin traitant",
          "STAFF_REPRESENTATIVE": "Représentant·e·s du personnel"
        },
        "notValid": "Le type de source de signalement n'est pas valide",
        "placeholder": "Sélectionnez la source du signalement..."
      }
    },
    "periods": {
      "addPeriod": "Ajouter une plage",
      "applyToOtherPeriods": "Appliquer ces horaires du lundi au vendredi",
      "from": "Horaire de",
      "mustBeAtLeastAfter": "Doit être au moins {minutes, number} minutes après l'heure de début",
      "mustBeInBookingSlot": "Doit être après l'heure de début et avant l'heure de fin du créneau de réservation",
      "notValid": "L'heure n'est pas valide (format HH:mm)",
      "to": "à"
    },
    "personalEmail": {
      "label": "Email personnel"
    },
    "personnalMedicalBackground": {
      "label": "Antécédents médicaux personnels",
      "placeholder": ""
    },
    "phoneNumber": {
      "fixedOrMobileOnly": "Seul un numéro de téléphone fixe, mobile ou VoIP est accepté",
      "label": "Numéro de téléphone",
      "mobileOnly": "Seul un numéro de téléphone mobile est accepté",
      "notValid": "Ce numéro de téléphone n'est pas valide.",
      "placeholder": "ex. +33 6 50 00 00 01"
    },
    "physicalActivity": {
      "addOne": "Ajouter une activité",
      "label": "Pratique sportive",
      "placeholder": ""
    },
    "physicalActivityAmount": {
      "label": "Activité physique",
      "unit": "{value, number, integer} fois / {period}"
    },
    "physicalActivityAmountFrequency": {
      "label": "Fréquence de l'activité physique"
    },
    "physicalActivityFrequency": {
      "label": "Fréquence",
      "placeholder": ""
    },
    "postalCode": {
      "label": "Code postal",
      "placeholder": "ex. 75015"
    },
    "practitionerRoles": {
      "labels": {
        "ADMIN_STAFF": "Admin",
        "MEDICAL_STAFF": "Personnel médical",
        "OCCUPATIONAL_HEALTH_PHYSICIAN": "Médecin référent·e"
      }
    },
    "previousMedicalOps": {
      "label": "Chirurgies / Hospitalisations passées",
      "placeholder": ""
    },
    "professionalEmail": {
      "label": "Email professionnel"
    },
    "professionalMedicalBackground": {
      "label": "Antécédents médicaux professionnels",
      "placeholder": "ex. Accidents du travail, maladies professionnelles...",
      "shortLabel": "Antécédents"
    },
    "psychosocialContext": {
      "label": "Contexte psychosocial",
      "placeholder": ""
    },
    "qualification": {
      "label": "Qualification",
      "labels": {
        "DOCTOR": "Docteur·e",
        "NURSE": "Infirmier·ère"
      },
      "placeholder": "ex. Médecin",
      "short": {
        "DOCTOR": "Dr.",
        "NURSE": "Inf."
      }
    },
    "reclassificationIndications": {
      "label": "Conclusions et indications relatives au reclassement"
    },
    "recognitionEndDate": {
      "label": "Date de fin de reconnaissance",
      "placeholder": ""
    },
    "recognitionOfDisabledWorkerStatus": {
      "label": "RQTH",
      "placeholder": ""
    },
    "recognitionStartDate": {
      "label": "Date de début de reconnaissance",
      "placeholder": ""
    },
    "requestReason": {
      "label": "Motif de la demande",
      "maxLength": "Le motif de la demande ne peut pas dépasser {max, number} caractères.",
      "minLength": "Le motif de la demande doit contenir au moins {min, number} caractères.",
      "placeholder": "Renseignez le motif de la demande"
    },
    "returnDate": {
      "infos": "Une visite de reprise doit être planifiée dans les 8 jours à compter de la date de reprise.",
      "label": "Date de reprise",
      "placeholder": "ex. 03/11/1987"
    },
    "risks": {
      "addOne": "Ajouter un risque",
      "categories": {
        "labels": {
          "BIOLOGICAL_RISKS": "Risques biologiques",
          "CHEMICAL_RISKS": "Risques chimiques",
          "ENVIRONMENTAL_RISKS": "Risques de chute ou liés à l'environnement",
          "ERGONOMIC_AND_TMS_RISKS": "Risques ergonomiques et TMS",
          "FIRE_AND_EXPLOSION_RISKS": "Risques incendie / explosion / Seveso",
          "OTHER_SPECIFIC_RISKS": "Autres risques spécifiques",
          "PHYSICAL_RISKS": "Risques physiques",
          "WORK_ORGANIZATION_RISKS": "Risques liés à l'organisation du travail"
        }
      },
      "criticality": {
        "labels": {
          "critical": "Critique",
          "high": "Élevé",
          "important": "Important",
          "low": "Faible",
          "moderate": "Modéré"
        }
      },
      "frequency": {
        "labels": {
          "16": "Une fois par jour",
          "2": "Une fois par an",
          "4": "Une fois par mois",
          "8": "Une fois par semaine",
          "daily": "Une fois par jour",
          "monthly": "Une fois par mois",
          "weekly": "Une fois par semaine",
          "yearly": "Une fois par an"
        }
      },
      "label": "Risques professionnels",
      "mitigationFactor": {
        "labels": {
          "collectiveOrIntrinsic": "EPC ou prévention intrinsèque — protections collectives, ou danger supprimé ou réduit à la source",
          "individualEquipment": "EPI — équipements de protection individuelle",
          "instructions": "Consignes",
          "none": "Aucune mesure"
        }
      },
      "nonModifiable": {
        "cantBeModified": "Ce risque ne peut pas être modifié car il est associé {attachedTo} du·de la collaborateur·trice",
        "department": "au pôle",
        "jobTitle": "au poste de travail",
        "organization-unit": "à la division"
      },
      "risks": {
        "description": {
          "allergens_or_animal_or_plant_work": "Certains métiers exposent à des allergènes naturels ou des piqûres, entraînant des réactions parfois sévères.",
          "asbestos": "Inhaler des fibres d’amiante peut entraîner des maladies graves comme l’asbestose ou des cancers pulmonaires, parfois des années après l’exposition.",
          "atypical_hours": "Ces rythmes perturbés peuvent affecter l’équilibre vie pro/vie perso et accroître la charge mentale.",
          "biological_products_manipulation": "Les soins, prélèvements ou analyses impliquent des risques en cas de coupure, de projection ou de contact avec du sang ou des fluides.",
          "burn": "Une exposition à des surfaces chaudes (plaques de cuisson, four...), à des flammes nues (gaz, flambages...) ou du travail en ambiance thermique chaude (fourneaux, vapeur...) peut entraîner des brûlures.",
          "cmr_substances": "Certains produits chimiques sont Cancérogènes, Mutagènes ou Reprotoxiques, et nécessitent des précautions renforcées pour éviter toute exposition.",
          "constrained_postures": "Répéter les mêmes gestes ou maintenir une posture fixe fatigue les muscles et les articulations, source fréquente de TMS.",
          "cut": "Manipuler des couteaux, lames de hachoirs, éplucheuses ou autres équipements tranchants lors de préparation d’aliments, de nettoyage ou de manipulations, peut entraîner des coupures aux mains, aux avant-bras ou aux doigts.",
          "driving_risky_vehicles": "Grues à tour, grues mobiles, grues auxiliaires de chargement, chariots automoteurs de manutention, plates-formes élévatrices mobiles, et engins de chantier télécommandés ou à conducteur porté (sauf tracteurs agricoles).",
          "electrical_risks": "Concerne les consignations, essais, mesurages, vérifications, manoeuvres ou opérations sur des installations photovoltaïques.",
          "epidemic_risk": "Les épidémies peuvent accroître les risques d’infection sur le lieu de travail, nécessitant des protocoles renforcés et une vigilance accrue.",
          "explosion_risk": "En présence de poussières, vapeurs ou gaz inflammables, une simple étincelle peut déclencher une explosion aux conséquences graves.",
          "explosive_atmospheres": "Dans certaines zones, un simple mélange air/vapeur/gaz/poussière peut exploser si une source d’ignition est présente.",
          "extreme_temperatures": "Travailler dans des environnements très chauds, très froids ou exposés aux intempéries peut affecter la santé physique et la concentration.",
          "flammable_substances_manipulation": "",
          "high_altitude_work": "Intervenir sur un toit, un échafaudage ou une échelle sans protection peut entraîner des chutes graves ou mortelles.",
          "hyperbaric_risks": "Les travaux sous pression nécessitent des procédures spécifiques pour éviter les accidents de décompression ou les malaises graves.",
          "important_electrical_risks": "Travaux, interventions au voisinage ou nettoyages proches ou directement sur des pièces sous tension, qui présentent un risque électrique important.",
          "infectious_agents": "Certains secteurs exposent à des virus, bactéries ou parasites pouvant entraîner des infections, parfois graves ou contagieuses.",
          "intense_heat": "Travailler par fortes chaleurs, en extérieur ou dans un local mal ventilé, expose à la déshydratation, aux malaises et aux coups de chaleur, surtout lors d’efforts physiques.",
          "ionizing_radiation": "Présents dans certains environnements médicaux ou industriels, ils peuvent altérer les cellules du corps et augmenter le risque de cancer.",
          "isolated_work": "Travailler seul, sans possibilité d’alerte rapide, augmente les risques en cas d’incident ou d’urgence médicale.",
          "lead": "Une exposition prolongée au plomb peut provoquer des troubles neurologiques, digestifs ou hématologiques, en particulier chez les femmes enceintes.",
          "manual_handling_of_loads": "Porter ou déplacer des charges lourdes ou mal adaptées peut provoquer des douleurs dorsales, des hernies ou des accidents.",
          "night_work": "Le décalage des rythmes biologiques peut entraîner fatigue, troubles du sommeil, voire des problèmes métaboliques ou cardiovasculaires.",
          "noise": "Une exposition répétée ou prolongée à un niveau sonore élevé peut engendrer des troubles auditifs irréversibles (acouphènes, surdité), mais aussi du stress ou de la fatigue.",
          "non_ionizing_radiation": "Émanant d’équipements comme les lampes UV, les lasers ou les antennes, ils peuvent nuire à la peau, aux yeux ou au système nerveux.",
          "other_chemical_products": "L’exposition à des solvants, détergents ou colles peut provoquer des brûlures, allergies ou intoxications en cas de contact ou d’inhalation",
          "psychosocial_risks": "Stress chronique, surcharge, conflits ou harcèlement peuvent entraîner souffrance psychique, démotivation ou arrêts de travail.",
          "remote_work": "Travailler à distance de façon régulière peut isoler, brouiller la frontière entre vie pro et vie perso et s’exercer sur un poste mal aménagé à domicile.",
          "road_risk": "Les déplacements professionnels ou les livraisons exposent à des accidents de la route, parfois graves, souvent sous-estimés.",
          "screen_work": "Une posture prolongée, un mauvais éclairage ou un poste mal ajusté peuvent provoquer maux de dos, fatigue visuelle et troubles musculo-squelettiques.",
          "slippery_surface": "Sols glissants, encombrés ou mal entretenus peuvent provoquer des chutes, souvent responsables d’accidents du travail.",
          "vibration": "L’usage régulier d’outils vibrants (perforateurs, ponceuses…) peut provoquer des douleurs articulaires, des troubles circulatoires ou des TMS.",
          "wood": "Le sciage ou le ponçage de certaines essences de bois génère des poussières pouvant être irritantes pour les voies respiratoires, voire cancérogènes."
        },
        "labels": {
          "allergens_or_animal_or_plant_work": "Allergènes / Travaux en contact avec animaux ou végétaux",
          "asbestos": "Amiante",
          "atypical_hours": "Horaires atypiques / Astreintes",
          "biological_products_manipulation": "Manipulation de produits biologiques",
          "burn": "Brûlure",
          "cmr_substances": "Substances CMR",
          "constrained_postures": "Postures contraignantes / Gestes répétitifs",
          "cut": "Coupure",
          "driving_risky_vehicles": "Conduite d'engins à risque",
          "electrical_risks": "Opérations électriques à risque réduit",
          "epidemic_risk": "Risque épidémique / COVID-19",
          "explosion_risk": "Risque d'explosion (ATEX)",
          "explosive_atmospheres": "Atmosphères explosives (ATEX)",
          "extreme_temperatures": "Températures extrêmes / intempéries",
          "flammable_substances_manipulation": "Manipulation de substances inflammables",
          "high_altitude_work": "Travail en hauteur",
          "hyperbaric_risks": "Hyperbares (plongée, caissons)",
          "important_electrical_risks": "Opérations électriques à risque important",
          "infectious_agents": "Agents infectieux",
          "intense_heat": "Chaleur intense",
          "ionizing_radiation": "Rayonnements ionisants",
          "isolated_work": "Travail isolé",
          "lead": "Plomb",
          "manual_handling_of_loads": "Manutention manuelle de charges",
          "night_work": "Travail de nuit / Travail posté",
          "noise": "Bruit",
          "non_ionizing_radiation": "Rayonnements non ionisants",
          "other_chemical_products": "Autres produits chimiques",
          "psychosocial_risks": "Risques psychosociaux (RPS)",
          "remote_work": "Télétravail",
          "road_risk": "Risque routier / Conduite professionnelle",
          "screen_work": "Travail sur écran",
          "slippery_surface": "Chute de plain-pied / Glissade",
          "vibration": "Vibrations",
          "wood": "Bois"
        }
      },
      "search": "Rechercher un risque",
      "severity": {
        "labels": {
          "16": "Accident ou maladie pouvant être mortel",
          "2": "Accident bénin, sans arrêt de travail",
          "4": "Accident ou maladie avec arrêt de travail",
          "8": "Accident ou maladie laissant des séquelles",
          "afterEffects": "Accident ou maladie laissant des séquelles",
          "benign": "Accident bénin, sans arrêt de travail",
          "fatal": "Accident ou maladie pouvant être mortel",
          "sickLeave": "Accident ou maladie avec arrêt de travail"
        }
      }
    },
    "sex": {
      "gender": {
        "label": "Parité",
        "labels": {
          "FEMALE": "{count, plural, one {Femme} other {Femmes}}",
          "MALE": "{count, plural, one {Homme} other {Hommes}}",
          "UNKNOWN": "Non Communiqué"
        }
      },
      "label": "Sexe",
      "labels": {
        "FEMALE": "Féminin",
        "MALE": "Masculin",
        "UNKNOWN": "Non Communiqué"
      },
      "notValid": "Doit être Masculin ou Féminin",
      "placeholder": "ex. Masculin"
    },
    "siret": {
      "label": "SIRET",
      "notValid": "Le SIRET n'est pas valide",
      "placeholder": "ex. 923 033 179 00013"
    },
    "sleep": {
      "label": "Sommeil"
    },
    "sleepDuration": {
      "label": "Durée",
      "unit": "{value, number, integer} heures / nuit"
    },
    "sleepQuality": {
      "label": "Qualité du sommeil",
      "labels": {
        "MODERATELY_RESTORATIVE": "Moyennement réparateur",
        "RESTORATIVE": "Réparateur",
        "SLEEP_DISORDER": "Troubles du sommeil"
      }
    },
    "slotActivityType": {
      "label": "Type d'activité",
      "labels": {
        "THIRD_TIME": "Tiers-temps",
        "VISIT": "Visites"
      },
      "notValid": "Le type d'activité n'est pas valide"
    },
    "slotLocation": {
      "companyBranchIdRequired": "Vous devez sélectionner un adhérent lorsque le lieu est chez l'adhérent",
      "label": "Lieu",
      "labels": {
        "COMPANY_BRANCH": "Chez l'adhérent",
        "HEALTH_CENTER": "Au centre",
        "HOME": "À distance"
      },
      "notValid": "Le lieu n'est pas valide"
    },
    "socialReason": {
      "label": "Raison sociale",
      "placeholder": "ex. Mon entreprise"
    },
    "socioProfessionalCategory": {
      "label": "Catégorie socioprofessionnelle",
      "labels": {
        "AGRICULTEUR_EXPLOITANT": "Agriculteur exploitant",
        "ARTISAN_COMMERCANT_CHEF_D_ENTREPRISE": "Artisan, commerçant, chef d'entreprise",
        "CADRE": "Cadre ou profession intellectuelle supérieure",
        "EMPLOYE": "Employé",
        "OUVRIER": "Ouvrier",
        "PROFESSION_INTERMEDIAIRE": "Profession intermédiaire"
      },
      "notValid": "La catégorie socioprofessionnelle n'est pas valide",
      "placeholder": "ex. Cadre"
    },
    "specificWorkingConditions": {
      "label": "Conditions spécifiques de travail"
    },
    "startDate": {
      "label": "Date de début du contrat",
      "placeholder": "ex. 14/05/2025"
    },
    "surgeries": {
      "label": "Opérations"
    },
    "systolicBloodPressure": {
      "label": "Tension artérielle systolique",
      "placeholder": "Tension artérielle systolique"
    },
    "tobacco": {
      "label": "Tabagisme",
      "placeholder": ""
    },
    "tobaccoConsumption": {
      "label": "Tabac",
      "labels": {
        "NO": "Non",
        "YES": "Oui"
      },
      "unit": "{tobaccoConsumption} ({tobaccoPacksPerYear, number} paquet(s) / année)"
    },
    "tobaccoFrequency": {
      "label": "Fréquence",
      "placeholder": ""
    },
    "tobaccoPacksPerYear": {
      "label": "Paquet(s) / année",
      "unit": "{value, number} paquet(s) / année"
    },
    "tobaccoTypes": {
      "addOne": "Ajouter un type",
      "label": "Type de tabac",
      "placeholder": ""
    },
    "transportMode": {
      "label": "Mode(s) de transport",
      "placeholder": "ex. Voiture, vélo..."
    },
    "transportTime": {
      "label": "Temps de transport",
      "placeholder": "ex. 30 minutes, 1 heure..."
    },
    "vaccineMonitoring": {
      "addOne": "Ajouter un vaccin",
      "expiredAt": "Valide jusqu'au",
      "injectedAt": "Injecté le",
      "label": "Suivi vaccinal",
      "name": "Nom",
      "placeholder": "",
      "status": "Statut"
    },
    "vaccineRecommendations": {
      "label": "Recommandations vaccinales",
      "placeholder": ""
    },
    "vaccineStatus": {
      "label": "Suivi vaccinal",
      "labels": {
        "NOT_UP_TO_DATE": "À renouveler",
        "UNKNOWN": "Ne sait pas",
        "UP_TO_DATE": "À jour"
      },
      "notValid": "Le statut vaccinal n'est pas valide"
    },
    "vaccines": {
      "label": "Vaccins",
      "placeholder": "ex. Vaccin contre la grippe..."
    },
    "vatNumber": {
      "label": "Numéro de TVA",
      "placeholder": "ex. FR 123 456 789 01"
    },
    "vision": {
      "label": "Vision"
    },
    "visitContext": {
      "label": "Contexte de la visite",
      "placeholder": ""
    },
    "visitType": {
      "label": "Type de visite"
    },
    "visitTypePicker": {
      "alreadyBookedWarning": "Il semble qu’une visite du même type soit déjà planifiée. Merci de vérifier afin d’éviter un doublon.",
      "label": "Type de visite",
      "labels": {
        "APTITUDE_EXAM": "Examen médical d'aptitude",
        "APTITUDE_EXAM_INITIAL": "Examen d'embauche (EMA initial)",
        "APTITUDE_EXAM_PERIODIC": "Examen périodique (EMA périodique)",
        "CONFIDENTIAL_VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice (confidentiel)",
        "FOLLOWUP_VISIT": "Visite à la demande d'un membre de l'équipe pluridisciplinaire",
        "INTERMEDIATE_VISIT": "Visite médicale intermédiaire",
        "MID_CAREER_VISIT": "Visite de mi-carrière",
        "NON_CONFIDENTIAL_PRERETURN_VISIT": "Visite de pré-reprise",
        "POST_PROFESSIONAL_VISIT": "Visite post-exposition ou post-professionnelle",
        "PRERETURN_VISIT": "Visite de pré-reprise (confidentielle)",
        "PRERETURN_VISIT_ANY_CONFIDENTIALITY": "Visite de pré-reprise (confidentialité au choix)",
        "RETURN_VISIT": "Visite de reprise",
        "VIP": "Visite d'information et de prévention",
        "VIP_INITIAL": "Visite d'embauche (VIP initiale)",
        "VIP_PERIODIC": "Visite périodique (VIP périodique)",
        "VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice",
        "VISIT_REQUESTED_BY_MB": "Visite à la demande de l'employeur",
        "VISIT_REQUESTED_BY_MB_OR_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice ou de l'employeur·euse"
      },
      "notValid": "Le type de visite n'est pas valide",
      "shortLabels": {
        "APTITUDE_EXAM": "EMA",
        "APTITUDE_EXAM_INITIAL": "EMA initial",
        "APTITUDE_EXAM_PERIODIC": "EMA périodique",
        "CONFIDENTIAL_VISIT_REQUESTED_BY_EMPLOYEE": "Visite confidentielle",
        "FOLLOWUP_VISIT": "Visite de suivi",
        "INTERMEDIATE_VISIT": "Visite intermédiaire",
        "MID_CAREER_VISIT": "Visite de mi-carrière",
        "NON_CONFIDENTIAL_PRERETURN_VISIT": "Visite de pré-reprise",
        "POST_PROFESSIONAL_VISIT": "Visite post-professionnelle",
        "PRERETURN_VISIT": "Visite de pré-reprise",
        "RETURN_VISIT": "Visite de reprise",
        "VIP": "VIP",
        "VIP_INITIAL": "Visite d'embauche",
        "VIP_PERIODIC": "Visite périodique",
        "VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande",
        "VISIT_REQUESTED_BY_MB": "Visite à la demande",
        "VISIT_REQUESTED_BY_MB_OR_EMPLOYEE": "Visite à la demande"
      }
    },
    "weight": {
      "label": "Poids",
      "placeholder": "Poids en kg",
      "unit": "{weight, number} kg"
    },
    "workAccidents": {
      "addOne": "Ajouter un accident",
      "afterEffect": "Séquelles",
      "circumstances": "Circonstances",
      "date": "Date",
      "label": "Accidents du travail",
      "placeholder": ""
    },
    "workEnvironmentSatisfaction": {
      "label": "Satisfaction",
      "placeholder": ""
    },
    "workMode": {
      "label": "Mode de travail",
      "labels": {
        "HYBRID": "Hybride",
        "IN_PERSON": "Physique",
        "REMOTE": "À distance"
      },
      "notValid": "Le mode de travail n'est pas valide",
      "placeholder": "ex. Hybride"
    },
    "workRelatedStress": {
      "label": "Stress",
      "placeholder": ""
    },
    "workingHours": {
      "label": "Horaires de travail"
    },
    "workstation": {
      "emptyResult": "Aucun poste de travail trouvé",
      "label": "Poste de travail",
      "nLabel": "{count, plural, one {{count} poste} other {{count} postes}} de travail",
      "placeholder": "ex. Ingénieur qualité"
    }
  },
  "employee": {
    "dmstExport": {
      "download": {
        "cta": "Télécharger",
        "sharedBy": "Partagé par votre équipe médicale",
        "sharedOn": "DMST exporté le {date, date, short}",
        "title": "Mon DMST"
      },
      "request": {
        "availableAfterFirstConsultation": "Ce service sera disponible après votre première consultation avec votre centre de santé et de prévention au travail SANO.",
        "confidentialityNotice": "Vos données de santé et votre pièce d'identité restent confidentielles et ne sont accessibles qu'à votre équipe médicale.",
        "cta": "Demander mon DMST",
        "description": "Le <b>DMST</b> (Dossier Médical en Santé au Travail) regroupe l'ensemble de vos consultations et documents de santé au travail.",
        "identityDocument": {
          "hint": "En cours de validité : carte d'identité, passeport ou titre de séjour.\nElle permet à votre médecin de vérifier votre identité avant de partager votre dossier médical.",
          "label": "Télécharger votre pièce d'identité"
        },
        "process": "Votre demande sera transmise à votre médecin du travail, qui préparera puis partagera votre dossier complet au format PDF. Vous serez notifié·e dès qu'il sera disponible.",
        "submit": "Envoyer la demande",
        "success": "Votre demande d'export a bien été envoyée.",
        "title": "Demander l'export de mon DMST",
        "uploadError": "Erreur lors de l'envoi du fichier. Veuillez réessayer.",
        "uploading": "Envoi en cours"
      },
      "status": {
        "description": "Votre médecin du travail prépare votre dossier. Vous serez notifié·e dès qu'il sera disponible dans vos documents.",
        "shared": {
          "description": "Vous pouvez le retrouver dans vos documents.",
          "dismiss": "Fermer",
          "title": "Votre DMST vous a été partagé."
        },
        "steps": {
          "inProgress": "En cours de traitement",
          "requested": "Demande envoyée",
          "shared": "DMST partagé"
        },
        "title": "Votre demande d'export du DMST est en cours."
      }
    },
    "documents": {
      "cards": {
        "createdAt": "Date :",
        "createdBy": "Ajouté par :",
        "documentType": "Type de document :"
      },
      "empty": {
        "description": "Aucun document n'a encore été partagé.",
        "title": "Aucun document"
      },
      "table": {
        "columns": {
          "createdAt": {
            "content": "{date, date, short}",
            "header": "Date d'ajout"
          },
          "createdBy": {
            "header": "Ajouté par"
          },
          "documentType": {
            "header": "Type de document",
            "labels": {
              "ABILITY_CERTIFICATE": "Avis d'aptitude",
              "ACCOMMODATION_CERTIFICATE": "Proposition d'aménagement",
              "ADDITIONAL_EXAM_RESULT": "Résultats d'examens complémentaires",
              "APPOINTMENT_EXEMPTION_REQUEST": "Demande de dispense de visite",
              "APPOINTMENT_MODIFICATION_REQUEST": "Demande de modification de visite",
              "CHECKUP_CERTIFICATE": "Attestation de suivi",
              "CHECKUP_DOCUMENTS": "Document de téléconsultation",
              "COLLABORATORS_IMPORT": "Import de collaborateurs·trices",
              "COLLABORATORS_UPDATE": "Mise à jour de collaborateurs·trices",
              "COMPANY_SHEET": "Fiche d'entreprise",
              "CONFIDENTIAL_EMPLOYEE_DOCUMENT": "Document confidentiel collaborateur·trice",
              "CONSENT": "Consentement",
              "DMST": "DMST",
              "DRIVING_RISKY_VEHICLES_ABILITY_CERTIFICATE": "Non-contre-indication pour la conduite d’engins à risque",
              "DUERP": "DUERP",
              "EXTERNAL_REFERRAL_LETTER": "Lettre d'adressage extérieure",
              "IDENTITY_DOCUMENT": "Document d'identité",
              "IMPORTANT_ELECTRICAL_RISKS_ABILITY_CERTIFICATE": "Non-contre-indication pour les opérations électriques à risque important",
              "INABILITY_CERTIFICATE": "Avis d'inaptitude",
              "JOB_ASSESSMENT": "Étude de poste",
              "MEDICAL_INFORMATIONS_IMPORT": "Import de données médicales",
              "MEDICAL_OR_HOSPITALIZATION_REPORT": "Compte-rendu médical ou d'hospitalisation",
              "MULTIDISCIPLINARY_TEAM_REFERRAL_LETTER": "Lettre d'adressage par l'équipe pluridisciplinaire",
              "OTHER": "Autre document",
              "PDP": "PDP",
              "PRERETURN_LETTER": "Courrier de pré-reprise",
              "PRESCRIPTION": "Ordonnance",
              "RQTH_OR_INVALIDITY": "RQTH ou invalidité",
              "SICK_LEAVE": "Arrêt de travail",
              "TEMPORARY_INABILITY_CERTIFICATE": "Inaptitude temporaire"
            }
          },
          "fileName": {
            "header": "Nom du fichier"
          }
        }
      },
      "title": "Documents"
    },
    "irpSpace": {
      "documents": {
        "companySheet": {
          "title": "Fiche entreprise"
        },
        "duerp": {
          "empty": "Aucun DUERP n'a encore été ajouté.",
          "title": "DUERP"
        },
        "title": "Documents"
      },
      "information": {
        "description": "Votre entreprise dispose d'une ou plusieurs instances représentatives du personnel.",
        "title": "Informations"
      },
      "risks": {
        "description": "Retrouvez ici l’ensemble des risques professionnels identifiés dans l’entreprise pour faciliter le suivi et les actions de prévention.",
        "emptyState": "Aucun risque professionnel n'a encore été ajouté.",
        "title": "Risques"
      }
    },
    "onboarding": {
      "consents": {
        "consentDialog": {
          "consentEmailTrackingPixel": {
            "label": "J’accepte que Paladin utilise des pixels de suivi pour mesurer l’ouverture de ses e-mails afin d’adapter leur contenu et leur fréquence"
          },
          "consentNotifications": {
            "label": "J’autorise Paladin à m’envoyer des emails et des SMS de notification en lien avec le service"
          },
          "consentPersonalizedExperience": {
            "label": "J’autorise Paladin à utiliser mes données anonymisées pour améliorer l’application et le service"
          },
          "consentToPersonalDataProcessing": {
            "label": "J’accepte que Paladin collecte et traite mes données personnelles conformément à la",
            "urlLabel": " politique de confidentialité "
          },
          "nextButton": "Suivant",
          "readAndAcceptTermsOfService": {
            "label": "J’ai lu et j’accepte les",
            "urlLabel": " conditions générales d’utilisation "
          }
        },
        "nextButton": "J'accepte",
        "pdp": {
          "description": "S’ils le jugent nécessaire, les professionnels de santé peuvent vous proposer un <strong>accompagnement spécifique à votre situation</strong>.\n\nCela peut impliquer l’intervention de cellules spécialisées, qui auront alors besoin d’accéder à votre dossier médical.",
          "knowMore": "En savoir plus",
          "refuseCheckbox": "Je refuse tout accompagnement spécifique",
          "title": "Accompagnement spécifique"
        },
        "previousButton": "Précédent",
        "refuseButton": "Continuer",
        "teleconsultation": {
          "description": "En fonction de votre profil et de vos besoins, les professionnels de santé pourront être amenés à vous proposer de la téléconsultation et/ou télésoin.\n\nEn continuant, vous consentez à ce que vos prises en charge puissent se dérouler en téléconsultation et/ou télésoin, si le service le juge approprié.",
          "knowMore": "En savoir plus",
          "refuseCheckbox": "Je souhaite uniquement bénéficier de consultations en présentiel",
          "title": "Téléconsultation"
        }
      },
      "layout": {
        "sidebar": {
          "bookVisit": "Prise de rendez-vous",
          "consents": "Consentements",
          "personalInformation": "Informations personnelles"
        }
      },
      "personalInformation": {
        "callout": "Merci de vérifier l’exactitude des informations. Si une mise à jour est nécessaire, notifiez votre service RH.",
        "nextButton": "Valider",
        "previousButton": "Précédent",
        "title": "Informations personnelles"
      },
      "signUp": {
        "description": "Créez votre compte pour accéder à votre espace de santé au travail.",
        "startButton": "Commencer",
        "title": "Bienvenue sur Paladin !"
      },
      "success": {
        "bookVisitDescription": "Une visite de médecine du travail doit avoir lieu dans les 3 prochains mois.\nPour finaliser votre suivi, vous pouvez prendre rendez-vous dès maintenant, cela ne prend que quelques instants.",
        "bookVisitTitle": "Planifier dès à présent votre prochaine visite obligatoire",
        "chooseSlotButton": "Choisir un créneau",
        "description": "Vous pouvez dès maintenant accéder à votre espace Paladin pour consulter vos rendez-vous, documents et échanges en toute sécurité.",
        "goToProductButton": "Accéder à mon espace",
        "planLaterButton": "Planifier plus tard",
        "title": "Vos informations ont bien été enregistrées"
      },
      "welcome": {
        "description": "Paladin centralise votre suivi : consultez vos visites, échangez avec votre service de santé et accédez à vos documents en toute sécurité.",
        "nextButton": "Suivant",
        "title": "Bienvenue sur votre espace de santé au travail"
      }
    },
    "phoneRequired": {
      "description1": "Pour garantir le bon déroulement de certaines interactions, notamment lors d'une téléconsultation, votre numéro de téléphone est désormais nécessaire pour utiliser votre espace Paladin.",
      "description2": "Il pourra être utilisé par votre service de santé au travail pour vous contacter rapidement en cas de besoin.",
      "description3": "Votre numéro reste confidentiel et utilisé uniquement dans le cadre de votre suivi.",
      "submitButton": "Valider",
      "successDescription": "Votre numéro de téléphone a bien été ajouté à votre profil.",
      "successTitle": "Merci !",
      "supportLink": "Contactez notre support",
      "supportQuestion": "Un problème ?",
      "title": "Votre numéro de téléphone est désormais requis"
    },
    "prevention": {
      "description": "Recevez des contenus de prévention adaptés et <bold>découvrez les bons réflexes</bold> pour <bold>préserver votre santé</bold>.<br/><br/>Un espace pensé pour vous <bold>informer</bold>, vous <bold>accompagner</bold> et vous <bold>aider à rester en forme</bold> au travail."
    },
    "profile": {
      "address": "Adresse",
      "birthDate": "Date de naissance",
      "birthLastName": "Nom de naissance",
      "birthLocationCode": "Lieu de naissance",
      "contract": {
        "department": "Pôle",
        "organizationUnit": "Division",
        "startDate": "Depuis le",
        "type": "Contrat"
      },
      "firstName": "Prénom",
      "header": {
        "bornAt": "Né·e le {date, date, short} ({age, number} ans)",
        "bornAt_female": "Née le {date, date, short} ({age, number} ans)",
        "bornAt_male": "Né le {date, date, short} ({age, number} ans)",
        "workAt": "{jobTitle} chez {company}"
      },
      "lastName": "Nom",
      "personalEmail": "Email personnel",
      "personalInformation": {
        "callout": "Pour toute mise à jour, contactez directement votre service RH.",
        "title": "Informations personnelles"
      },
      "phoneNumber": "Numéro de téléphone",
      "professionalEmail": "Email professionnel",
      "sex": "Sexe",
      "treatingPhysicianFullName": "Médecin traitant",
      "treatingPhysicianFullNamePlaceholder": "Nom complet du médecin traitant"
    },
    "sidebar": {
      "contact": "Contact",
      "dmstTransfer": {
        "subtitle": "Demander le transfert de mon DMST",
        "title": "Récupérer mon historique DMST"
      },
      "documents": "Documents",
      "irpSpace": {
        "documents": "Documents",
        "information": "Informations",
        "risks": "Risques professionnels",
        "title": "Espace IRP"
      },
      "parameters": "Paramètres",
      "prevention": "Prévention",
      "profile": "Profil",
      "roadmap": "Roadmap Paladin",
      "visits": "Visites"
    },
    "teleconsultationTunnel": {
      "backToVisitsButton": "Retour aux visites",
      "cannotWait": {
        "apologies": "Merci de votre compréhension,<br />L'équipe médicale Sano",
        "backToVisits": "Revenir à mon espace",
        "description": "En raison d’une indisponibilité de votre professionnel·le de santé, votre consultation n’a pu avoir lieu.",
        "description2": "Vous allez être contacté·e d’ici peu pour choisir un nouveau créneau de consultation.",
        "title": "Toutes nos excuses"
      },
      "globalPopin": {
        "recovery": {
          "callout": "Votre téléconsultation n’est pas terminée. Veuillez retourner dans la salle de consultation.",
          "cta": "Retourner dans la salle de consultation"
        },
        "startingSoon": {
          "callout": "Afin de faciliter le bon déroulement de la consultation, ayez avec vous votre pièce d’identité et votre téléphone portable.",
          "cta": "Rejoindre la salle de consultation",
          "description": "Nous vous conseillons de rejoindre la salle dès {time, time, ::H mm}."
        },
        "summary": "<bold>{visitType}</bold> • Aujourd'hui à {time, time, ::H mm}"
      },
      "joinLinkLabel": "Rejoindre la téléconsultation",
      "layout": {
        "stepper": {
          "step1": "Autorisations",
          "step2": "Caméra",
          "step3": "Microphone",
          "step4": "Hauts-parleurs",
          "step5": "Connexion"
        }
      },
      "linkBroken": {
        "backToVisits": "Revenir à mon espace",
        "description": "Il semblerait que le lien utilisé pour accéder à cette télé-consultation soit incorrect ou ait expiré.",
        "hint": "Le lien devrait être correct ? <a>Contactez le support</a>",
        "title": "Oups !\nCe lien ne fonctionne pas…"
      },
      "lobby": {
        "documents": {
          "delete": {
            "message": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible.",
            "title": "Supprimer le document"
          },
          "empty": {
            "description": "Aucun document n'a encore été partagé.",
            "title": "Aucun document"
          },
          "title": "Documents"
        },
        "ended": {
          "description": "Vos documents seront accessibles dans votre espace Paladin.",
          "primaryCta": "Retour à mon espace",
          "recoveryCta": "Revenir à la télé-consultation",
          "recoveryHint": "Mauvaise manip’ ?",
          "title": "Cette consultation est terminée"
        },
        "live": {
          "connectionLost": {
            "message": "La connexion a été perdue. Tentative de reconnexion…",
            "reload": "Recharger la page"
          },
          "description": "Vous pouvez maintenant poursuivre votre consultation dans la salle.",
          "deviceControls": {
            "audioInput": "Microphone",
            "audioOutput": "Haut-parleurs",
            "noSelectedDevice": "Aucun périphérique sélectionné",
            "selectAudioDevice": "Sélectionner les appareils audio",
            "selectVideoDevice": "Sélectionner la caméra",
            "toggleCamera": "Activer/Désactiver la caméra",
            "toggleMic": "Activer/Désactiver le microphone",
            "videoInput": "Caméra"
          },
          "leave": "Quitter la consultation",
          "qualityIssue": {
            "audio": "Votre micro ne fonctionne pas. Le professionnel de santé va vous contacter au {phoneNumber}.<br />Vous pouvez quitter la consultation.",
            "network": "Votre connexion semble instable. La qualité audio ou vidéo peut être dégradée.",
            "video": "Votre caméra ne fonctionne pas. Le professionnel de santé va vous contacter au {phoneNumber}.<br />Vous pouvez quitter la consultation."
          },
          "title": "Votre professionnel de santé est connecté, la consultation est en cours"
        },
        "panel": {
          "chat": "Chat",
          "documents": "Documents"
        }
      },
      "mobileUnsupported": {
        "backToVisits": "Retour aux visites",
        "description": "Afin d’assurer une consultation dans de bonnes conditions (sécurité, confidentialité, qualité des échanges), merci de vous connecter depuis un ordinateur.",
        "title": "La téléconsultation n’est pas disponible sur mobile."
      },
      "nextButton": "Suivant",
      "prelude": {
        "step0": {
          "consentError": "Votre consentement est requis pour accéder à la téléconsultation.",
          "consentLabel": "Je souhaite uniquement bénéficier de consultations en présentiel",
          "description": "En cliquant sur <strong>“J’accepte”</strong>, vous consentez à réaliser votre consultation en téléconsultation et à l’utilisation de vos données de santé dans ce cadre, conformément à la réglementation en vigueur.",
          "next": "J'accepte",
          "title": "Téléconsultation"
        },
        "step1": {
          "description": "Afin de garantir le bon déroulement de votre téléconsultation, nous avons besoin de votre <strong>numéro de téléphone</strong>.<br /><br />Il permettra au professionnel de santé ou à l’équipe support de vous <strong>contacter rapidement</strong> en cas de difficulté technique lors de la consultation (connexion interrompue, problème audio ou vidéo).",
          "next": "Valider",
          "title": "Ajouter votre n° de téléphone"
        },
        "step2": {
          "description": "Il vous faut votre <strong>pièce d’identité</strong> et votre <strong>téléphone portable</strong> à portée de main pour dérouler la consultation.",
          "title": "Avez-vous tout ce qu’il vous faut ?"
        },
        "step3": {
          "description": "Afin de garantir la qualité et la confidentialité de votre téléconsultation, merci de vous installer <strong>seul·e</strong>, dans <strong>un espace isolé et calme</strong>, dans lequel vous ne serez <strong>pas dérangé·e</strong>.",
          "title": "Installez-vous dans un endroit adapté."
        }
      },
      "previousButton": "Précédent",
      "steps": {
        "help": {
          "camera": {
            "description": "Il semble que votre caméra ne fonctionne pas correctement.<br />Dans la plupart des cas, ce type de problème peut être résolu rapidement.",
            "title": "Aucune caméra ne fonctionne"
          },
          "cta": "Contactez le support",
          "microphone": {
            "description": "Il semble que votre micro ne fonctionne pas correctement.<br />Dans la plupart des cas, ce type de problème peut être résolu rapidement.",
            "title": "Aucun micro ne fonctionne"
          },
          "speakers": {
            "description": "Il semble que vos haut-parleurs ne fonctionnent pas correctement.<br />Dans la plupart des cas, ce type de problème peut être résolu rapidement.",
            "title": "Aucun haut-parleur ne fonctionne"
          },
          "supportHint": "Consultez <a>notre article d’aide</a> dédié pour résoudre le problème en quelques étapes."
        },
        "step1": {
          "callout": "Vous n’avez pas autorisé l’accès au micro et à la caméra, veuillez accepter pour accéder à la téléconsultation.",
          "description": "Pour bénéficier de la téléconsultation,<br />vous devez autoriser l'accès au micro et à la caméra à l'étape suivante.",
          "next": "Continuer",
          "retryPermissions": "Réessayer",
          "title": "Autorisations"
        },
        "step2": {
          "description": "Assurez-vous d’être bien visible à l’image. Si celle-ci est trop sombre, vous pouvez allumer la lumière ou vous rapprocher d’une fenêtre.",
          "next": "Ma caméra fonctionne",
          "title": "Vérification de la caméra",
          "videoDeviceLabel": "Sélectionner la caméra"
        },
        "step3": {
          "audioInputDeviceLabel": "Sélectionner le microphone",
          "description": "Dites quelque chose à voix haute pour voir si la jauge devient orange. Vous pouvez par exemple dire : \"Je teste le son\".",
          "next": "Mon micro fonctionne",
          "title": "Vérification du microphone"
        },
        "step4": {
          "audioOutputDeviceLabel": "Sélectionner les haut-parleurs",
          "description": "Cliquez sur le bouton afin de tester les haut-parleurs. Vous devez entendre une notification sonore.",
          "next": "Mes haut-parleurs fonctionnent",
          "test": "Cliquez ici",
          "title": "Vérification des haut-parleurs"
        },
        "step5": {
          "description": "Pour garantir une consultation fluide et confortable, nous vérifions que votre connexion Internet est de bonne qualité.",
          "good": "La connexion est excellente",
          "hint": "En cas de coupure, le professionnel de santé pourra vous appeler en numéro masqué au <bold>{phoneNumber}</bold>.",
          "next": "Démarrer la consultation",
          "testing": "Test en cours...",
          "title": "Vérification de la connexion",
          "unstable": "La connexion est instable"
        }
      },
      "tooEarly": {
        "backToVisits": "Revenir à mon espace",
        "description": "Vous pourrez la rejoindre à partir d'une heure avant le début du rendez-vous.",
        "hint": "Votre rendez-vous : {appointmentDateTime}",
        "title": "La téléconsultation n'est pas encore ouverte"
      },
      "tooLate": {
        "backToVisits": "Revenir à mon espace",
        "description": "Votre retard ne permet malheureusement pas au·à la professionnel·le de santé de réaliser la consultation dans de bonnes conditions médicales.",
        "hint": "Vous recevrez un email prochainement pour planifier un nouveau rendez-vous, sinon, veuillez vous rapprocher de votre équipe RH.",
        "title": "Oups ! Trop tard…"
      },
      "waitingRoom": {
        "description": "Vous serez notifié·e lorsque le professionnel de santé rejoindra la consultation vidéo. Merci de rester connecté·e et de garder cette fenêtre ouverte.",
        "documentChoice": {
          "description": "Votre pièce d’identité est utilisée <strong>uniquement pour vérifier votre identité</strong> au moment de la consultation. Elle n’est <strong>ni conservée ni archivée</strong> après la fin de l’échange, et ne sera <strong>en aucun cas réutilisée</strong>.",
          "title": "Télécharger un document",
          "uploadDocuments": "Un document",
          "uploadId": "Une pièce d’identité"
        },
        "idAlreadyUploaded": "Pièce d'identité téléchargée",
        "leaveRoom": "Quitter la salle de consultation",
        "practitionerLate": {
          "cannotWait": "Je ne peux pas attendre",
          "description": "Votre professionnel ne devrait plus tarder. Désolés pour ce contretemps.",
          "leaveHint": "Si vous décidez de quitter la visite, nous vous recontacterons pour reprogrammer un rendez-vous.",
          "summary": "<bold>{visitType}</bold> • Aujourd'hui à {time, time, ::H mm}",
          "title": "Votre professionnel·le de santé a du retard",
          "wait": "Attendre"
        },
        "sendMessage": "Envoyer un message",
        "shareDocuments": "Partager des documents",
        "uploadDocumentsTitle": "Télécharger un document",
        "uploadId": "Télécharger ma pièce d'identité",
        "uploadIdTitle": "Télécharger une pièce d’identité",
        "waitingForPractitioner": "En attente de {practitionerName}"
      }
    },
    "visits": {
      "absence": {
        "confirmReturn": {
          "action": "Confirmer ma reprise",
          "dialog": {
            "description": "Vous êtes sur le point de confirmer votre reprise du travail.",
            "title": "Confirmer ma reprise",
            "withReturnVisit": "Vous êtes sur le point de confirmer votre reprise du travail. Votre visite de reprise sera réservée, vous recevrez le détail par e-mail."
          },
          "success": "Votre reprise a bien été confirmée."
        },
        "description": "Vos visites sont suspendues pendant cette période et reprendront automatiquement à votre retour.",
        "returned": {
          "description": "Confirmez votre reprise pour réactiver vos visites.",
          "expired": "Votre reprise n'a pas encore été confirmée. Rapprochez-vous de votre service RH.",
          "pending": "Vous pourrez confirmer votre reprise dès demain pour réactiver vos visites.",
          "title": "Votre absence s'est terminée le <b>{endDate, date, shortUtc}</b>."
        },
        "title": "{absenceType, select, LONG_LEAVE {Vous êtes actuellement en congé longue durée} MATERNITY {Vous êtes actuellement en congé maternité} NON_PROFESSIONAL_ACCIDENT {Vous êtes actuellement en arrêt pour accident non professionnel} NON_PROFESSIONAL_DISEASE {Vous êtes actuellement en arrêt maladie non professionnelle} PARTNER_BIRTH_LEAVE {Vous êtes actuellement en congé de naissance} PARTNER_PARENTAL_LEAVE {Vous êtes actuellement en congé parental} PROFESSIONAL_ACCIDENT {Vous êtes actuellement en arrêt pour accident du travail} PROFESSIONAL_DISEASE {Vous êtes actuellement en arrêt pour maladie professionnelle} SABBATICAL {Vous êtes actuellement en congé sabbatique} SECONDMENT {Vous êtes actuellement en détachement} other {Vous êtes actuellement en absence}} du <b>{startDate, date, shortUtc}</b> au <b>{endDate, date, shortUtc}</b>."
      },
      "bookVisit": {
        "backToVisits": "Retour",
        "button": "Planifier une visite",
        "error": {
          "unauthorizedVisitType": "Type de visite invalide"
        },
        "healthCenterInfo": {
          "description": "Au centre Sano, à deux pas de Saint-Lazare, venez bénéficier d'un bilan complet en présentiel - avec notamment un <bold>dépistage des troubles visuels</bold> grâce à un équipement de dernière génération.<br/><br/> Un moment dédié à votre santé, dans un espace pensé pour vous accueillir.",
          "nextButton": "Planifier une visite",
          "title": "Au centre Sano, votre bilan va plus loin."
        },
        "membershipNotStarted": "Vous pourrez prendre rendez-vous à partir du {date}, date d'adhésion de votre entreprise",
        "missingExpectedInformation": {
          "birthDate": "<bold>Date de naissance</bold>",
          "callout": "Informations manquantes pour planifier la visite. Contactez votre service RH pour compléter vos informations :<br />",
          "calloutAddBirthdate": " (à renseigner dans <url>votre profil</url>)",
          "checkupDates": "<bold>Date de dernière et/ou prochaine visite</bold> (hors nouveau·elle collaborateur·trice)",
          "jobTitle": "<bold>Poste de travail</bold>",
          "risk": "<bold>Risque professionnel</bold>",
          "url": "votre profil"
        },
        "recap": {
          "consultationType": {
            "COMPANY_BRANCH": "Au bureau",
            "HEALTH_CENTER": "Au centre",
            "TELECONSULTATION": "Téléconsultation",
            "forActivity": {
              "COMPANY_BRANCH": "Au bureau",
              "HEALTH_CENTER": "Au centre",
              "TELECONSULTATION": "À distance"
            },
            "title": "Type de consultation : "
          },
          "date": "Date : ",
          "requestReason": "Motif de la demande : ",
          "time": "Horaire : ",
          "title": "Vous allez planifier une visite :",
          "visibleByHr": "Je consens à ce que mon employeur soit informé de l'organisation de cette visite.",
          "visitType": {
            "APTITUDE_EXAM": "Examen médical d'aptitude",
            "APTITUDE_EXAM_INITIAL": "Examen d'embauche (EMA initial)",
            "APTITUDE_EXAM_PERIODIC": "Examen périodique (EMA périodique)",
            "CONFIDENTIAL_VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice (confidentiel)",
            "FOLLOWUP_VISIT": "Visite à la demande d'un membre de l'équipe pluridisciplinaire",
            "INTERMEDIATE_VISIT": "Visite médicale intermédiaire",
            "MID_CAREER_VISIT": "Visite de mi-carrière",
            "NON_CONFIDENTIAL_PRERETURN_VISIT": "Visite de pré-reprise (non confidentielle)",
            "POST_PROFESSIONAL_VISIT": "Visite post-exposition ou post-professionnelle",
            "PRERETURN_VISIT": "Visite de pré-reprise (confidentielle)",
            "RETURN_VISIT": "Visite de reprise",
            "VIP": "Visite d'information et de prévention",
            "VIP_INITIAL": "Visite d'embauche (VIP initiale)",
            "VIP_PERIODIC": "Visite périodique (VIP périodique)",
            "VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice",
            "VISIT_REQUESTED_BY_MB": "Visite à la demande de l'employeur",
            "VISIT_REQUESTED_BY_MB_OR_EMPLOYEE": "Visite à la demande",
            "title": "Type de visite : "
          }
        },
        "success": {
          "title": "Votre visite a bien été planifiée !"
        },
        "visitWarning": {
          "callout": {
            "regularVisits": "Si vous souhaitez réserver une visite d'embauche ou toute autre visite périodique, retrouvez-les dans vos \"<a>Visites à venir</a>\", où elles apparaissent automatiquement quelques mois avant leur échéance."
          },
          "title": "Vous êtes sur le point de réserver une visite à votre demande.",
          "understood": "J'ai compris"
        }
      },
      "consultationType": {
        "labels": {
          "IN_PERSON_CONSULTATION": "Présentiel",
          "TELECONSULTATION": "Téléconsultation"
        }
      },
      "past": {
        "documents": {
          "seeInMySpace": "Voir les documents dans mon espace",
          "title": "Documents reçus"
        },
        "empty": {
          "title": "Vous n’avez pas encore passé de visite."
        },
        "outcomeReason": {
          "CONDITIONS_NOT_MET": {
            "description": "Cette visite n'a pas pu se terminer dans les conditions requises.<br/>Elle n'est pas enregistrée dans votre suivi médical et devra être reprogramée.",
            "title": "Conditions non réunies"
          },
          "ORIENTATION_ERROR": {
            "description": "Cette visite n'a pas pu avoir lieu.<br/>Le type de consultation prévu ne correspondait pas à votre situation.<br/>Elle n'est pas enregistrée dans votre suivi médical.",
            "title": "Erreur d'orientation"
          }
        },
        "title": "Visites passées"
      },
      "practitioner": {
        "qualification": {
          "labels": {
            "DOCTOR": "Médecin du travail",
            "NURSE": "Infirmier·ère"
          },
          "short": {
            "DOCTOR": "Dr.",
            "NURSE": "Inf."
          }
        }
      },
      "prereturnVisit": {
        "cta": "Planifier ma visite",
        "description": "À votre initiative, cette visite vous permet de préparer votre retour avec votre médecin du travail :\n aménagement de poste, reprise progressive, orientation si besoin.\n Aucun accord préalable de votre employeur n'est nécessaire.",
        "title": "Vous pouvez demander une visite de pré-reprise"
      },
      "referringPhysician": {
        "label": "Votre médecin référent·e :"
      },
      "title": "Visites",
      "type": {
        "labels": {
          "APTITUDE_EXAM": "Examen médical d'aptitude",
          "APTITUDE_EXAM_INITIAL": "Examen d'embauche (EMA initial)",
          "APTITUDE_EXAM_PERIODIC": "Examen périodique (EMA périodique)",
          "CONFIDENTIAL_VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice (confidentiel)",
          "FOLLOWUP_VISIT": "Visite à la demande d'un membre de l'équipe pluridisciplinaire",
          "INTERMEDIATE_VISIT": "Visite médicale intermédiaire",
          "MID_CAREER_VISIT": "Visite de mi-carrière",
          "NON_CONFIDENTIAL_PRERETURN_VISIT": "Visite de pré-reprise (non confidentielle)",
          "POST_PROFESSIONAL_VISIT": "Visite post-exposition ou post-professionnelle",
          "PRERETURN_VISIT": "Visite de pré-reprise (confidentielle)",
          "RETURN_VISIT": "Visite de reprise",
          "VIP": "Visite d'information et de prévention",
          "VIP_INITIAL": "Visite d'embauche (VIP initiale)",
          "VIP_PERIODIC": "Visite périodique (VIP périodique)",
          "VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice",
          "VISIT_REQUESTED_BY_MB": "Visite à la demande de l'employeur",
          "VISIT_REQUESTED_BY_MB_OR_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice ou de l'employeur·euse"
        }
      },
      "upcoming": {
        "cancelVisit": {
          "button": "Annuler",
          "modal": {
            "cancel": "Annuler",
            "confirm": "Confirmer l'annulation",
            "description": "Cette action annule définitivement votre rendez-vous avec le service de santé au travail.",
            "success": {
              "description": "Vous pouvez à tout moment planifier une nouvelle visite depuis votre espace. En cas de besoin, contactez votre service de santé au travail.",
              "title": "Votre visite a bien été annulée."
            },
            "title": "Êtes-vous sûr de vouloir annuler cette visite ?"
          },
          "warning": {
            "title": "Cette visite ne peut pas être annulée"
          }
        },
        "confirmVisit": {
          "badge": "Confirmée",
          "button": "Confirmer",
          "modal": {
            "cancel": "Annuler",
            "confirm": "Confirmer la visite",
            "success": {
              "addToCalendar": "Ajouter à mon agenda",
              "description": "Vous allez recevoir un e-mail de confirmation avec tous les détails utiles.",
              "title": "Votre visite est confirmée !"
            },
            "title": "Confirmez votre visite"
          }
        },
        "empty": {
          "title": "Aucune visite n’a encore été programmée."
        },
        "planVisitInfo": {
          "addToCalendar": "Ajouter à mon agenda",
          "companyBranch": {
            "address": "{line} - {postalCode} {city}",
            "name": "Dans les locaux de {name}",
            "seeOnMap": "Voir sur la carte"
          },
          "goToVisit": "Se rendre à la consultation",
          "occupationalHealthFacility": {
            "address": "{line} - {postalCode} {city}",
            "name": "Centre de santé {name}",
            "seeOnMap": "Voir sur la carte"
          },
          "teleconsultation": "Le lien de connexion vous sera partagé 1 heure avant la télé-consultation.",
          "teleconsultationConsentRefusedCallout": {
            "modificationImpossible": "Vous avez refusé d'être reçu·e en téléconsultation, mais votre rendez-vous ne peut pas/plus être décalé. <supportLink>Cliquez ici</supportLink> pour contacter le support, ou changez d’avis via vos <parametersLink>paramètres</parametersLink>.",
            "updateTlcVisit": "Vous avez refusé d'être reçu·e en téléconsultation, mais votre rendez-vous est actuellement prévu en téléconsultation. <updateLink>Cliquez ici</updateLink> pour le modifier, ou changez d’avis via vos <parametersLink>paramètres</parametersLink>."
          }
        },
        "requestExemption": {
          "badge": "Dispense demandée",
          "button": "Demander une dispense",
          "sheet": {
            "commentPlaceholder": "Décrivez en quoi votre poste actuel est identique à celui que vous occupiez chez votre précédent employeur : intitulé, missions, nature et niveau des risques d'exposition (bruit, vibrations, produits chimiques, postures, etc.)",
            "eligibilityConditions": [
              "Vous êtes appelé(e) à occuper un emploi identique, présentant des risques d'exposition équivalents à ceux du dernier poste exercé.",
              "Aucune mesure particulière concernant le poste de travail (aménagement, adaptation ou transformation) et aucun avis d'inaptitude n'ont été émis au cours des deux dernières années.",
              "Le ou la médecin du travail est en possession de votre dernier avis d'aptitude. (À fournir ci-dessous)."
            ],
            "lastCheckupDateLabel": "Date de votre dernière visite médicale"
          }
        },
        "rescheduleVisit": {
          "button": "Déplacer",
          "modalTitle": "Déplacer la visite",
          "success": {
            "title": "Votre visite a bien été modifiée !"
          },
          "warning": {
            "contactButton": "Contacter",
            "description": "Vous ne pouvez pas modifier ce rendez-vous (délais dépassés ou date rendue obligatoire par votre entreprise).\n\nEn cas d’empêchement exceptionnel, merci de contacter directement le service de santé et/ou votre service RH.",
            "title": "Cette visite ne peut pas être modifiée"
          }
        },
        "title": "Visites à venir",
        "upcomingVisitToBook": {
          "bookButton": "Choisir un créneau",
          "description": "Sans action de votre part avant le {date, date, long}, Paladin planifiera automatiquement la visite sur un créneau adapté.",
          "title": "Vous devez choisir un créneau"
        }
      }
    }
  },
  "errors": {
    "ABSENCE_SLOT_START_TOO_SOON": "L'absence ne peut pas commencer dans moins de 2 mois",
    "ACTIVITY_START_DATE_IN_THE_PAST": "La date et l'horaire de début de l'activité tiers-temps doivent être ultérieurs à la date et à l'heure courantes",
    "APPOINTMENT_ALREADY_BOOKED_BY_COLLABORATOR": "Cette visite a déjà été planifiée",
    "APPOINTMENT_INTERVAL_NOT_IN_BOOKING_SLOT_INTERVAL": "Le rendez-vous doit commencer après le début du créneau de réservation, et finir avant la fin du créneau de réservation",
    "APPOINTMENT_OUTSIDE_OF_BOOKING_SLOT_INTERVAL": "Erreur : certaines visites sont en dehors du nouveau créneau de rendez-vous",
    "APPOINTMENT_START_DATE_IN_THE_PAST": "La date et l'horaire de début de visite doivent être ultérieurs à la date et à l'heure courantes",
    "APPOINTMENT_WITHOUT_DOCUMENTS": "Aucun document n'est disponible pour cette visite",
    "BOOKING_SLOT_CANT_DELETE_IF_APPOINTMENT": "Impossible de supprimer un créneau de rendez-vous si des RDV sont réservés",
    "BOOKING_SLOT_CANT_UPDATE_TYPE_IF_APPOINTMENT": "Impossible de modifier le type de rendez-vous si des RDV sont réservés",
    "BOOKING_SLOT_NO_LONGER_AVAILABLE": "Le créneau de rendez-vous n'est plus disponible",
    "CANT_CREATE_CHECKUP_FOR_NO_SHOW_APPOINTMENT": "Impossible de finaliser un examen pour lequel le·la collaborateur·trice ne s'est pas présenté·e",
    "CHECKUP_ALREADY_EXISTS_FOR_APPOINTMENT": "Un examen existe déjà pour ce rendez-vous",
    "COMPANY_BRANCH_ALREADY_EXISTS": "Un compte adhérent existe déjà pour ce SIRET",
    "CONFLICTING_ABSENCE_SLOT": "Le créneau chevauche une absence du professionnel de santé",
    "CONFLICTING_ACTIVITY": "Une activité tiers-temps est déjà planifiée pour cette date et heure",
    "CONFLICTING_APPOINTMENT": "Un rendez-vous existe déjà pour cette date et heure",
    "CONFLICTING_BOOKING_SLOT_OF_ANOTHER_TYPE": "Un créneau de réservation d'un autre type est en conflit avec ces créneaux",
    "DEFAULT_SERVER_ERROR": "Une erreur s'est produite",
    "DMST_EXPORT_CONTENTS_CHANGED": "Le contenu de l'export a changé pendant sa préparation. Relancez le partage pour envoyer la version à jour.",
    "DOWNLOAD_LINK_EXPIRED": "Le lien de téléchargement du document a expiré",
    "EMAIL_NOT_AVAILABLE": "L'adresse email est déjà utilisée",
    "FIELD_LOCKED_BY_HRIS": "Ce champ est alimenté par votre SIRH et ne peut pas être modifié dans Paladin",
    "INTEGRATION_GENERIC_ERROR": "Une erreur est survenue lors de la connexion à l'API",
    "INTEGRATION_NOT_FOUND": "Pas d'intégration trouvée",
    "JOB_TITLE_REQUIRED_FOR_ABSENCE_DECLARATION": "Renseignez le poste de travail du·de la collaborateur·trice avant de déclarer une absence.",
    "MEDICAL_ATTESTATION_NOT_READABLE": "Nous n'avons pas pu lire la date de visite sur ce document",
    "MEMBERSHIP_NOT_STARTED": "Votre entreprise n'est pas encore adhérente, la prise de rendez-vous n'est pas encore ouverte",
    "MISSING_EXPECTED_INFO_FOR_BOOKING": "Impossible de créer le rendez-vous. Informations manquantes du·de la collaborateur·trice : {missingInfos}. Complétez sa fiche, puis réessayez.",
    "NO_MATCHING_BOOKING_SLOT_FOR_UPDATED_APPOINTMENT": "Aucun créneau de rendez-vous n'est disponible pour le rendez-vous mis à jour",
    "PERMISSIONS_FAILED": "Vous n'avez pas les droits nécessaires pour effectuer cette action",
    "PHONE_NUMBER_REQUIRED": "Le numéro de téléphone est requis",
    "REPRESENTATIVE_IS_ALREADY_A_PATIENT": "Cette adresse email appartient déjà à un·e collaborateur·trice",
    "RISK_NOT_ASSOCIATED_TO_MEMBER_BRANCH": "Le risque n’est pas associé à l’entreprise de ce·tte collaborateur·trice",
    "RISK_NOT_FOUND": "Risque non trouvé",
    "VALIDATION_FAILED": "Les données saisies ne sont pas valides",
    "VISIT_BOOKING_SLOT_NOT_ALLOWED_FOR_NON_MEDICAL_STAFF": "Seuls les professionnels de santé (médecins, IDEST) peuvent avoir des créneaux de rendez-vous pour des visites",
    "WEIGHTED_RISK_ALREADY_DECLARED": "Ce risque est déjà déclaré pour cet établissement",
    "WEIGHTED_RISK_WORK_UNIT_NOT_FOUND": "Une des unités de travail sélectionnées n'existe plus, rechargez la page",
    "WORK_UNIT_LIMIT_REACHED": "La limite d'unités de travail a été atteinte",
    "WORK_UNIT_NAME_ALREADY_EXISTS": "Une unité de travail porte déjà ce nom",
    "WORK_UNIT_RELATION_TARGET_NOT_FOUND": "Un des éléments sélectionnés n'existe plus, rechargez la page",
    "accessDenied": {
      "backHome": "Revenir à l'accueil",
      "description": "Votre profil ne donne pas accès à cette page. Si vous pensez en avoir besoin, contactez votre administrateur.",
      "title": "Accès refusé"
    },
    "documentImport": "Erreur lors de l'import du document",
    "invalidAppointment": {
      "contactSupport": "Pour résoudre rapidement cette situation et ne pas manquer votre visite médicale, contactez notre ",
      "description": "Nous sommes désolés, mais il semble que le lien utilisé pour accéder à votre rendez-vous médical en téléconsultation soit incorrect ou ait expiré.",
      "reassurance": "Nous sommes là pour vous aider à reprendre votre rendez-vous au plus vite.",
      "supportDescription": "support technique.",
      "supportEmail": "support@paladin.fr",
      "supportPhone": "01 23 45 67 89 (du lundi au vendredi, 8h30 à 18h)",
      "team": "L'équipe Paladin",
      "thanks": "Merci de votre compréhension,",
      "title": "Oups !\nVotre lien ne fonctionne pas."
    },
    "missingExpectedInfo": {
      "birthDate": "date de naissance",
      "checkupDates": "date de dernière et/ou prochaine visite",
      "contractType": "type de contrat",
      "jobTitle": "poste de travail",
      "risk": "risque professionnel"
    },
    "noAccountAssociatedToThisSSOUser": "Il n'y a pas de compte associé à votre compte SSO",
    "noMultidisciplinaryTeam": "Votre équipe pluridisciplinaire n'est pas encore configurée. Veuillez contacter un administrateur."
  },
  "filters": {
    "dataIsUpToDate": "Informations manquantes"
  },
  "healthCenter": {
    "appointment": {
      "checkupDocuments": {
        "dialogs": {
          "conclusion": {
            "content": "N’oubliez pas de scanner {count, plural, one {le document une fois signé, et de le} other {les documents une fois signés, et de les}} charger dans le DMST.",
            "description": "Vous pouvez maintenant fermer cette fenêtre et terminer la visite.",
            "title": "{count, plural, one {Charger le document dans le DMST} other {Charger les documents dans le DMST}}"
          },
          "documentsDownload": {
            "description": "Téléchargez {count, plural, one {le document en vue de l’} other {Téléchargez les documents en vue de les }} imprimer pour signature.",
            "title": "Téléchargement {count, plural, one {du document} other {des documents}}"
          },
          "signatureType": {
            "description": "Veuillez sélectionner le mode de signature adapté.",
            "electronic": {
              "description": "La personne va recevoir un code SMS pour signer",
              "title": "Signature électronique (recommandé)"
            },
            "errorMessages": {
              "phoneNumberRequired": "Le numéro de téléphone du·de la collaborateur·trice est requis pour la signature électronique.",
              "yousignIsDown": "Yousign est indisponible pour le moment, veuillez utiliser la signature sur papier."
            },
            "title": "Type de signature",
            "wetInk": {
              "description": "Imprimez et faites signer le document",
              "title": "Signature papier"
            }
          },
          "signing": {
            "description": "Veuillez suivre les indications pour apposer votre signature ainsi que celle du·de la collaborateur·trice.",
            "success": "Documents signés et transmis au·à la collaborateur·trice et à l’adhérent. Vous pouvez les retrouver dans le DMST.",
            "title": "{count, plural, one {Document} other {Documents}} à signer"
          }
        }
      },
      "stickyHeader": {
        "reorientationFromAppointment": {
          "badge": "à la demande de {qualification, select, DOCTOR {Dr. } NURSE {Inf. } other {}}{firstName} {lastName}",
          "info": "Durant la visite du {start, date, short} à {start, time, ::H mm} ({type})"
        },
        "status": "Consultation en cours",
        "title": "{type} : {start, time, ::H mm} - {end, time, ::H mm}"
      },
      "success": "Examen médical sauvegardé avec succès",
      "tab": {
        "conclusion": {
          "card": {
            "appointmentFollowUp": {
              "conditionsNotMetContent": {
                "callout": "La visite n'a pas pu se dérouler dans les conditions requises et ne sera pas enregistrée dans le DMST."
              },
              "doctorFollowUpContent": {
                "callout": {
                  "forDoctor": "Le médecin souhaite revoir le·la collaborateur·trice.",
                  "forNurse": "La visite nécessite une visite complémentaire avec un médecin."
                },
                "form": {
                  "appointmentBooked": "{appointmentType} - réservation faite pour le {date, date, short} à {date, time, ::H mm}.",
                  "appointmentBookedSuccess": "Visite réservée",
                  "book": "Réserver directement",
                  "bookSubmit": "Réserver la visite",
                  "bookingTitle": "Choisissez un créneau",
                  "deadline": {
                    "label": "Au plus tard le",
                    "plannedInvitationCallout": "Une invitation à réserver la visite sera envoyée {monthsBefore} mois avant cette date",
                    "returnDateCallout": "Date de retour : {returnDate, date, long}"
                  },
                  "forceInPersonConsultation": {
                    "label": "Forcer le présentiel pour cette visite"
                  },
                  "newBookingInvitationPlanned": "Une invitation à réserver la visite sera envoyée le {monthsBeforeDeadline, date, long}.",
                  "newBookingInvitationSent": "Une nouvelle invitation a été envoyée au·à la collaborateur·trice",
                  "planInvitation": "Planifier l'invitation",
                  "plannedInvitationSuccess": "Invitation planifiée",
                  "practitioner": {
                    "label": "Avec"
                  },
                  "returnVisitCallout": "S'il n'y a aucun créneau disponible avant le {deadline, date, long}, clôturez la visite et contactez le support.",
                  "submit": "Envoyer une invitation",
                  "success": "Invitation envoyée",
                  "visitType": {
                    "label": "Type de visite",
                    "nextMandatoryVisitRecalculationCallout": "La date de prochaine visite obligatoire sera recalculée en fonction de cette nouvelle visite."
                  }
                }
              },
              "followUpTypes": {
                "CONDITIONS_NOT_MET": "Conditions non réunies",
                "DOCTOR_FOLLOW_UP": {
                  "forDoctor": "Visite à la demande du médecin",
                  "forNurse": "Réorientation vers le médecin"
                },
                "NONE": "Aucune suite particulière",
                "NO_SHOW_EMPLOYEE": "Collaborateur·trice absent·e",
                "ORIENTATION_ERROR": "Erreur d'orientation"
              },
              "noFollowUpContent": {
                "callout": "La visite ne nécessite aucun suivi particulier."
              },
              "noShowEmployeeContent": {
                "callout": "Le·la collaborateur·trice ne s'est pas présenté·e à la visite et il·elle recevra un e-mail de notification. La visite ne sera pas enregistrée dans le DMST."
              },
              "orientationErrorContent": {
                "callout": "La visite ne correspondait pas à la situation du·de la collaborateur·trice et ne sera pas enregistrée dans le DMST."
              },
              "title": "Suite de la visite"
            },
            "doctorReferralWithoutDelay": "Réorientation vers le médecin du travail sans délai",
            "documents": "Document(s) de fin de visite",
            "medicalRecordNextVisit": {
              "label": "Date de prochaine visite",
              "title": "Prochaine visite médicale obligatoire"
            },
            "otherActions": "Autres actions",
            "title": "Conclusion de l'examen"
          },
          "finishAppointmentCta": "Sauvegarder et clôturer la visite",
          "finishAppointmentDialog": {
            "confirmButtonText": "Clôturer la visite",
            "description": "Vous êtes sur le point de terminer la consultation. Les données saisies vont être sauvegardées dans le DMST.",
            "missingSignatureRequestId": "La signature électronique n'a pas été complétée. Veuillez terminer la signature avant de clôturer la visite.",
            "missingSignatureType": "Veuillez générer et signer les documents sélectionnés avant de clôturer la visite.",
            "noDocumentsWarning": "Aucun document n'a été généré.",
            "title": "Clôturer la visite"
          },
          "finishAppointmentDoctorFollowUpPending": "Envoyez l'invitation ou réservez un créneau pour la réorientation vers le médecin avant de clôturer la visite.",
          "generateDocumentsCta": "Générer et signer les documents",
          "title": "Conclusion"
        },
        "context": {
          "card": {
            "currentEmployment": {
              "title": "Poste de travail"
            },
            "risks": {
              "title": "Risques identifiés"
            },
            "socialAndFamilialSituation": {
              "title": "Situation socio-familiale"
            },
            "transport": {
              "title": "Conditions de transport"
            }
          },
          "title": "Contexte"
        },
        "health": {
          "card": {
            "currentPathologies": {
              "title": "Pathologies actuelles"
            },
            "familyMedicalBackground": {
              "title": "Antécédents familiaux"
            },
            "lifestyle": {
              "title": "Hygiène de vie"
            },
            "medicalHistory": {
              "title": "Antécédents médico-chirurgicaux"
            },
            "notes": {
              "title": "Notes"
            },
            "vaccineStatus": {
              "title": "Statut vaccinal"
            },
            "vitals": {
              "title": "Paramètres vitaux"
            }
          },
          "title": "Santé"
        },
        "identity": {
          "card": {
            "contact": {
              "submit": "Enregistrer les coordonnées",
              "success": "Les coordonées ont bien été mises à jour.",
              "title": "Coordonnées"
            },
            "identity": {
              "callout": "Merci de valider l’identité du·de la collaborateur·trice au début de la consultation.",
              "submit": "Valider l’identité",
              "success": "L’identité a bien été validée.",
              "title": "Informations d’identité"
            }
          },
          "title": "Identité"
        },
        "pdp": {
          "title": "PDP"
        },
        "professionalMonitoring": {
          "card": {
            "disability": {
              "declared": "Déclaré",
              "title": "Handicap",
              "undeclared": "Non déclaré"
            },
            "professionalMedicalBackground": {
              "title": "Antécédents médicaux professionnels"
            }
          },
          "title": "Suivi professionnel"
        }
      },
      "teleconsultation": {
        "chat": {
          "title": "Messages"
        },
        "documents": {
          "title": "Documents"
        },
        "history": {
          "empty": {
            "description": "Sélectionner un champ pour afficher son historique.",
            "title": "Aucun champ sélectionné"
          },
          "inputBlock": {
            "appointmentCompleted": "Effectuée",
            "appointmentOngoing": "Consultation en cours"
          },
          "title": "Historique"
        },
        "status": {
          "connected": "Collaborateur·trice connecté·e",
          "invalid": "Rendez-vous manqué",
          "noShow": "Collaborateur·trice absent·e",
          "waiting": "Collaborateur·trice en attente"
        },
        "videoCall": {
          "deviceSelection": {
            "audioInput": "Microphone",
            "speakers": "Enceintes",
            "videoInput": "Webcam"
          },
          "start": "Lancer la téléconsultation"
        }
      }
    },
    "companies": {
      "create": "Nouveau compte adhérent",
      "createForm": {
        "estimatedEmployeeCount": "Effectif estimé",
        "estimatedEmployeeCountPlaceholder": "ex. 42",
        "hrAccountsCallout": "Au moins un compte Admin est requis pour la création du compte adhérent.",
        "hrAccountsIntro": "Créer un compte RH pour cet adhérent :",
        "isAppointmentsSchedulingActive": "Activer la planification automatique des rendez-vous.",
        "job": "Fonction",
        "legalName": "Raison sociale",
        "membershipCallout": "La planification automatique des 1ers rendez-vous et l'accès à l'espace prévention pour les collaborateurs·trices sont activés à cette date. En amont, le compte adhérent est déjà utilisable pour l'ajout d'effectifs et le setup des risques.",
        "membershipStartDate": "Date d'adhésion",
        "multiDisciplinaryTeamId": "Équipe pluridisciplinaire",
        "multiDisciplinaryTeamPlaceholder": "Aucune",
        "nafCode": "Code APE / NAF",
        "opsReferent": "Référent·e Ops",
        "representatives": {
          "add": "Créer un compte RH",
          "atLeastOneAdmin": "Au moins un représentant doit être administrateur",
          "columns": {
            "actions": "Actions",
            "identity": "Compte"
          },
          "duplicateEmails": "Chaque représentant doit avoir un email différent",
          "remove": "Retirer ce représentant",
          "role": "Rôle"
        },
        "sections": {
          "company": "Informations adhérent",
          "hrAccounts": "Compte(s) RH",
          "membershipStartDate": "Date d'adhésion",
          "team": "Équipe pluridisciplinaire & suivi"
        },
        "submit": "Créer le compte adhérent",
        "success": "Le compte adhérent {legalName} a été créé",
        "team": "Équipe de {doctorName}",
        "teamWithoutDoctor": "Équipe sans médecin du travail",
        "title": "Nouveau compte adhérent"
      },
      "created": {
        "createAnother": "Créer un autre compte",
        "immediateActions": {
          "collaborators": "Invitation des collaborateurs·trices",
          "employees": "Ajout de l'effectif (Import ou SIRH)",
          "hrAccounts": "Invitation des comptes RH",
          "risks": "Setup des risques",
          "title": "Disponible dès maintenant"
        },
        "membershipActions": {
          "automaticScheduling": "Planification automatique des visites",
          "manualBooking": "Prise de RDV manuelle par les collaborateurs·trices",
          "manualScheduling": "Planification manuelle des visites et AMT",
          "preventionSpace": "Accès à l'espace prévention",
          "title": "Débloqué au {date, date, shortUtc}",
          "titleWithoutDate": "Débloqué à l'adhésion"
        },
        "membershipStarted": "{legalName} a rejoint Sano le {date, date, longUtc}.",
        "membershipUpcoming": "{legalName} rejoindra Sano le {date, date, longUtc}.",
        "representativesInvited": "{count, plural, one {# compte RH a été invité} other {# comptes RH ont été invités}} par email.",
        "title": "Le compte adhérent {legalName} a bien été créé",
        "viewCompany": "Voir la fiche adhérent"
      },
      "metrics": {
        "companies": "{count, plural, one {{count} adhérent} other {{count} adhérents}}",
        "employees": "{count, plural, one {{count} collaborateur·trice suivi·e} other {{count} collaborateurs·trices suivi·e·s}}"
      },
      "search": {
        "label": "Rechercher un adhérent",
        "placeholder": "Rechercher…"
      },
      "table": {
        "columns": {
          "city": "Localisation",
          "createdAt": {
            "content": "{date, date, short}",
            "header": "Date d'ajout"
          },
          "nafCodeId": "Code APE/NAF",
          "name": {
            "employees": "{count, plural, one {{count} collaborateur·trice suivi·e} other {{count} collaborateurs·trices suivi·e·s}}",
            "header": "Adhérents"
          },
          "occupationalHealthPhysicianReferent": "Suivi par",
          "siret": "SIRET"
        }
      },
      "title": "Adhérents"
    },
    "company": {
      "adminManagement": {
        "accountStatus": {
          "active": "Actif",
          "header": "Statut du compte",
          "invitationSent": "Invitation envoyée le {date, date, short}",
          "invitationSentShort": "Invitation le {date, date, short}",
          "notInvited": "Non invité"
        },
        "actions": {
          "deactivate": "Désactiver",
          "deactivateModal": {
            "confirm": "Désactiver",
            "content": "Êtes-vous sûr·e de vouloir désactiver {name} ? Cette action est irréversible. Le·la collaborateur·trice ne sera plus visible dans l'application et ne pourra plus planifier de visites.",
            "title": "Désactiver le·la collaborateur·trice"
          },
          "employeeDeactivatedSuccessfully": "Collaborateur·trice désactivé·e avec succès",
          "header": "Actions"
        },
        "appointmentsScheduling": {
          "active": "Active",
          "atTime": "le {dateTime, date, short} à {dateTime, time, short}",
          "byUser": " par {firstName} {lastName}",
          "disable": "Désactiver",
          "enable": "Activer",
          "error": {
            "maxAppointmentsToForceBookThreshold": "Ce nombre doit être supérieur à 0"
          },
          "inactive": "Inactive",
          "largeVolumeRulesDisabledWarning": "Ce paramètre n'est pas utilisé car le feature flag 'appointments-scheduling-large-volume-rules' est désactivé.",
          "maxAppointmentsToForceBookThreshold": "Nombre de visites max à force-book par jour :",
          "status": "Statut :",
          "statusField": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "title": "Planification automatique des visites",
          "updateSuccess": {
            "disabled": "Planification automatique désactivée",
            "enabled": "Planification automatique activée",
            "preferences": "Les paramètres de planification automatique ont été mis à jour"
          }
        },
        "cancelAppointmentSuccess": "Le rendez-vous a été annulé",
        "companyBranch": "Adhérent :",
        "consultationTypeSettings": {
          "canUpdatePreference": "Permettre à l'adhérent de modifier son type de consultation préféré",
          "canUpdatePreferenceField": {
            "allowed": "L'adhérent peut modifier son type de consultation préféré",
            "blocked": "L'adhérent ne peut pas modifier son type de consultation préféré"
          },
          "title": "Type de consultation préféré",
          "updateSuccess": {
            "allowed": "L'adhérent peut maintenant modifier son type de consultation préféré",
            "blocked": "L'adhérent ne peut plus modifier son type de consultation préféré",
            "newValue": "Le type de consultation préféré a été mis à jour"
          }
        },
        "deleteBookTask": "Supprimer la tâche",
        "deleteBookTaskModal": {
          "cancel": "Annuler",
          "confirm": "Supprimer",
          "content": "Cette action est définitive. Le·la collaborateur·trice ne verra plus cette échéance à planifier.",
          "title": "Supprimer la tâche de planification ?"
        },
        "deleteBookTaskSuccess": "La tâche a été supprimée",
        "exportCheckupCertificates": {
          "button": "Exporter les attestations de visite",
          "empty": "Aucune attestation de visite à exporter pour cet adhérent.",
          "success": "{count, plural, one {{count} attestation de visite exportée} other {{count} attestations de visite exportées}}",
          "tooMany": "Trop d'attestations à exporter pour cet adhérent. Vous pouvez contacter l'équipe tech."
        },
        "inactive": "Désactivé·e",
        "information": "Information du compte",
        "inviteAllEmployees": "Inviter tous·tes les collaborateurs·trices",
        "inviteAllEmployeesSuccessCount": "{count, plural, one {{count} invitation envoyée} other {{count} invitations envoyées}} avec succès",
        "lastCheckupDate": "Date de dernière visite :",
        "membership": {
          "error": {
            "startDateRequired": "La date d'adhésion est obligatoire"
          },
          "startDate": "Date d'adhésion",
          "title": "Adhésion",
          "updateSuccess": "La date d'adhésion a été mise à jour"
        },
        "reinviteAllEmployees": "Ré-inviter tous·tes les collaborateurs·trices",
        "resendOneInvitation": "Renvoyer une invitation",
        "sendOneInvitation": "Envoyer une invitation",
        "sendOneInvitationError": "Erreur lors de l'envoi de l'invitation",
        "sendOneInvitationSuccess": "Invitation envoyée avec succès",
        "status": "Statut :",
        "switchCompanyBranch": "Changer",
        "switchCompanyBranchCancel": "Annuler",
        "switchCompanyBranchConfirm": "Changer",
        "switchCompanyBranchModal": {
          "cancel": "Annuler",
          "confirm": "Confirmer",
          "content": "Cette action va transférer le·la collaborateur·trice, ses visites, ses documents et ses informations d'organisation vers l'adhérent {companyBranch}. Souhaitez-vous continuer ?",
          "title": "Changer le·la collaborateur·trice d'adhérent ?"
        },
        "switchCompanyBranchSuccess": "Le·la collaborateur·trice a été transféré·e vers le nouvel adhérent",
        "tabs": {
          "accountManagement": "Gestion des comptes",
          "appointmentsScheduling": "Planification des visites",
          "informations": "Informations"
        },
        "title": "Admin",
        "visitsTableTitle": "Visites et visites à planifier"
      },
      "companyEmployees": {
        "empty": "Aucun·e collaborateur·trice chez cet adhérent",
        "title": "Collaborateurs·trices"
      },
      "companySheets": {
        "companySheet": {
          "addAssignedPersons": "Assigner des personnes",
          "assignedPersons": "Personnes assignées",
          "deleteRisk": {
            "body": "Souhaitez-vous continuer ?",
            "description": "Le risque sera supprimé de la liste, cette action est définitive.",
            "title": "Supprimer ce risque"
          },
          "form": {
            "accidentFrequencyRate": "Taux de fréquence",
            "accidentSeverityRate": "Taux de gravité",
            "activity": "Activité",
            "addPreventiveMeasure": "Ajouter une mesure",
            "addRisk": "Ajouter un risque",
            "address": "Adresse",
            "affectedWorkUnits": "Unités de travail concernées",
            "airConditioningAndHeatPumpInspectionComment": "Commentaires",
            "canteen": "Réfectoire",
            "certifications": "Certifications",
            "changeSinceLastTime": "Évolutions depuis la dernière mise à jour",
            "changes": "Évolutions",
            "city": "Ville",
            "collectiveBargainingAgreement": "Convention collective de référence",
            "commutingAccident": "Accident de trajet",
            "companyBranchManagerEmail": "Mail",
            "companyBranchManagerName": "Responsable de l'entreprise",
            "companyBranchName": "Raison sociale",
            "contactPersonName": "Interlocuteur pour la visite",
            "coolingTowerInspectionComment": "Commentaires",
            "daytimeWorkComment": "Commentaires",
            "diagnostics": "Diagnostics",
            "documentation": "Documentation",
            "doorsAndGatesInspectionComment": "Commentaires",
            "electricalInspectionComment": "Commentaires",
            "elevatorInspectionComment": "Commentaires",
            "existingCollectivePreventionAndProtection": "Prévention/protection collective existante",
            "existingIndividualPreventionAndProtection": "Prévention/protection individuelle existante",
            "fireSafetyInspectionComment": "Commentaires",
            "firstAid": "Premiers secours",
            "firstAidKitInspection": "Contrôle (prise en charge et périodicité)",
            "firstAidLocation": "Répartition",
            "generalInformation": "Informations générales",
            "hasAccessibleToilets": "Accessibilité handicapés",
            "hasAirConditioningAndHeatPumpInspection": "Climatisation et pompe à chaleur",
            "hasAsbestos": "Amiante",
            "hasCanteen": "Présence",
            "hasCanteenHeating": "Chauffage",
            "hasCanteenMicrowave": "Micro-ondes",
            "hasCanteenRefrigerator": "Réfrigérateur",
            "hasCanteenSink": "Évier",
            "hasCanteenStove": "Plaque de cuisson",
            "hasCompanyRestaurant": "Restaurant d'entreprise",
            "hasCoolingTowerInspection": "Tours aérofrigérantes",
            "hasDeliveryZone": "Zone de livraison",
            "hasDoorsAndGatesInspection": "Portes/portails",
            "hasElectricalHeating": "Chauffage électrique",
            "hasElectricalInspection": "Électricité",
            "hasElevatorInspection": "Ascenseur",
            "hasFireSafetyInspection": "Incendie",
            "hasFirstAidKit": "Trousse de secours",
            "hasFirstAidSkillsTraining": "Maintien et actualisation des compétences",
            "hasForcedAirVentilation": "Air pulsé",
            "hasFuelHeating": "Fuel",
            "hasGasHeating": "Gaz",
            "hasGenderSeparatedLockerRooms": "Séparé Homme/Femme",
            "hasHandCleaningSupplies": "Nécessaire nettoyage mains",
            "hasHearingProtection": "Protection auditive",
            "hasInternalRegulations": "Règlement intérieur",
            "hasLead": "Plomb",
            "hasLiftingEquipmentAndAccessoriesInspection": "Appareils et accessoires de levage",
            "hasLockerRoom": "Présence",
            "hasLockerRoomWithLockableMetalLockers": "Casiers métalliques avec cadenas",
            "hasMachineryInspection": "Machines",
            "hasMandatoryWorkplacePostings": "Affichage obligatoire",
            "hasMaseCertification": "MASE",
            "hasMechanicalVentilation": "VMC",
            "hasNaturalVentilation": "Ventilation naturelle (ouverture fenêtres)",
            "hasNewEmployeeHandbook": "Livret d'accueil nouveau·elle collaborateur·trice",
            "hasOhsas18001Certification": "OHSAS 18001",
            "hasOnSiteFirstAidResponder": "Présence de SST",
            "hasOnSiteNurse": "Présence d'un·e infirmier·ère",
            "hasOtherInspection": "Autres",
            "hasOtherProtectiveGear": "Autres",
            "hasOtherSafetyManagementSystem": "Autre SMS/SM",
            "hasPedestrianZone": "Zone piéton",
            "hasPressureEquipmentInspection": "Équipements sous pression",
            "hasPreventionPlan": "Plan de prévention",
            "hasProtectiveGlasses": "Lunettes de protection",
            "hasProtectiveGloves": "Gants de protection",
            "hasProtectiveMasks": "Masques de protection",
            "hasRadiantHeating": "Radiant",
            "hasReversibleAirConditioning": "Climatisation réversible",
            "hasRiskAssessmentDocument": "Document Unique",
            "hasSafetyInstructions": "Consignes de sécurité",
            "hasSafetyProtocol": "Protocole de sécurité",
            "hasSafetyRegister": "Registre Sécurité",
            "hasSafetyShoes": "Chaussures de sécurité",
            "hasShower": "Présence",
            "hasSocialAndEconomicCommittee": "CSE",
            "hasSpecificWorkClothing": "Tenues de travail spécifiques",
            "hasStaffParking": "Parking personnel",
            "hasStaffRepresentative": "Délégué·e·s du personnel",
            "hasSupplementalHeating": "Chauffage d'appoint",
            "hasThermalAndRefrigerationSystemsInspection": "Installations thermiques et frigorifiques",
            "hasToilets": "Présence",
            "hasVentilationSystemInspection": "Installation ventilation",
            "hasVisitorParking": "Parking visiteurs",
            "hasWashbasins": "Lavabos",
            "healthAndSafetyOfficerEmail": "Mail",
            "healthAndSafetyOfficerName": "Référent·e santé et sécurité",
            "healthMonitorings": "Unités de travail",
            "hearingProtectionMaintenance": "Entretien",
            "heatingVentilation": "Chauffage/Ventilation",
            "hoursOfDaytimeWork": "Travail en horaire de journée",
            "hoursOfNightWork": "Travail de nuit",
            "hoursOfShiftWork": "Travail posté",
            "hoursOfWorkStudy": "Travail en alternance",
            "id": "Numéro d'adhérent",
            "identifiedRisks": "Risques identifiés",
            "inspections": "Contrôles",
            "installation": "Installation",
            "institutionalSupport": "Avez-vous bénéficié d’aide et/ou d’accompagnement par un organisme institutionnel ? (ex : CARSAT, INRS, ARACT, etc)",
            "isClassifiedInstallationForEnvironmentalProtection": "Installation Classée pour la Protection de l'Environnement (ICPE)",
            "isPublicAccessBuilding": "Établissement recevant du public (ERP)",
            "jobTitle": "Poste",
            "liftingEquipmentAndAccessoriesInspectionComment": "Commentaires",
            "listChanges": "Listez les évolutions depuis la dernière mise à jour…",
            "lockerRoom": "Vestiaire",
            "lostTimeAccident": "Avec arrêt",
            "lostTimeAccidentComment": "Commentaires",
            "machineryInspectionComment": "Commentaires",
            "maintenance": "Entretien",
            "maintenanceFrequency": "Fréquence",
            "maintenanceManager": "Par",
            "monitoringType": "Suivi",
            "nafCodeId": "Code NAF",
            "natureOfActivity": "Nature de l'activité",
            "nightWorkComment": "Commentaires",
            "nonLostTimeAccident": "Sans arrêt",
            "nonLostTimeAccidentComment": "Commentaires",
            "numberOfAgencyWorkers": "Intérimaires",
            "numberOfApprenticeshipContracts": "Contrats d'apprentissage",
            "numberOfEmployeesWithInvalidity": "Invalidités",
            "numberOfFirstAidKits": "Nombre de trousses de secours",
            "numberOfFirstAidResponders": "Nombre de SST",
            "numberOfFixedTermContracts": "CDD",
            "numberOfFullTimeAffectedWorkUnits": "CDI",
            "numberOfFullTimeEmployees": "Temps plein",
            "numberOfLostTimeDays": "Nombre de jours d'arrêt",
            "numberOfMen": "Hommes",
            "numberOfOtherAffectedWorkUnits": "CDD/TT/Autres contrats",
            "numberOfOtherContract": "Autres contrats",
            "numberOfPermanentContracts": "CDI",
            "numberOfRecognitionOfDisabledWorkerStatus": "RQTH",
            "numberOfToilets": "Nombre",
            "numberOfUnder18YearsOld": "< 18 ans",
            "numberOfWomen": "Femmes",
            "observations": "Observations",
            "occupationalAccidents": "Accidents du travail",
            "occupationalAccidentsAndOccupationalDiseases": "Accidents du travail et maladies professionnelles",
            "occupationalDiseases": "Maladies professionnelles",
            "organizationUnit": "Ajouter une unité",
            "organizationUnitName": "Unité de travail",
            "otherHeatingVentilation": "Autres",
            "otherInspectionComment": "Commentaires",
            "otherProtectiveGearMaintenance": "Entretien",
            "personalProtectiveEquipment": "Équipements de protection individuelle (EPI)",
            "phoneNumber": "Numéro de téléphone",
            "postalCode": "Code postal",
            "premises": "Locaux",
            "premisesMaintenance": "Entretien des locaux",
            "pressureEquipmentInspectionComment": "Commentaires",
            "preventiveMeasureAuthor": "Auteur",
            "preventiveMeasureDate": "Date",
            "preventiveMeasureDescription": "Description",
            "preventiveMeasureN": "Mesure {number}",
            "preventiveMeasureResult": "Résultats",
            "preventiveMeasureType": "Type",
            "preventiveMeasures": "Mesures de prévention",
            "protectiveGlassesMaintenance": "Entretien",
            "protectiveGlovesMaintenance": "Entretien",
            "protectiveMasksMaintenance": "Entretien",
            "recognizedOccupationalDiseases": "Maladies professionnelles reconnues",
            "recommendations": "Préconisations",
            "reportedOccupationalDiseases": "Maladies professionnelles déclarées",
            "riskId": "Risque concerné",
            "safetyShoesMaintenance": "Entretien",
            "shiftWorkComment": "Commentaires",
            "shower": "Douche",
            "siren": "SIREN",
            "siret": "SIRET",
            "specificInformationAndTraining": "Informations/formations spécifiques",
            "specificWorkClothingMaintenance": "Entretien",
            "staffNumber": "Effectifs par catégorie",
            "staffRepresentative": "Délégué·e·s du personnel",
            "thermalAndRefrigerationSystemsInspectionComment": "Commentaires",
            "toilets": "Toilettes",
            "totalNumberOfStaff": "Total",
            "ventilationSystemInspectionComment": "Commentaires",
            "visitDate": "Date de la visite",
            "workRelatedIllness": "Maladie à caractère professionnel",
            "workStudyComment": "Commentaires",
            "workingConditions": "Conditions de travail",
            "workingHours": "Effectifs par temps de travail"
          },
          "saved": "Fiche entreprise enregistrée",
          "title": "Fiche Entreprise {date, date, ::y}"
        },
        "history": {
          "emptyState": {
            "title": "Aucune donnée n'a encore été enregistrée."
          },
          "title": "Historique"
        },
        "signature": {
          "description": "Veuillez signer la fiche entreprise pour la valider.",
          "disabledButton": "Impossible de valider une fiche entreprise déjà signée.",
          "title": "Signature de la fiche entreprise",
          "yousignIsDown": "Yousign est indisponible pour le moment, veuillez utiliser la signature sur papier."
        },
        "status": {
          "NOT_STARTED": "Non démarré",
          "REVIEW": "Relecture",
          "SIGNED": "Signé",
          "TO_BE_SIGNED": "À signer",
          "WRITING": "Rédaction"
        },
        "tabs": {
          "history": "Historique",
          "tracking": "Suivi"
        },
        "title": "Fiche de l'entreprise",
        "tracking": {
          "companySheetDate": "Fiche Entreprise {date, date, ::y}",
          "createCompanySheet": "Nouvelle fiche",
          "expiryDate": "Date d'échéance",
          "title": "Liste des mises à jour",
          "validationDate": "Date de validation",
          "validityPeriod": "Période de validité"
        },
        "updateDialog": {
          "description": "Modifie le statut et la date d'échéance de la fiche de l'entreprise",
          "disabledButton": "Impossible de modifier une fiche entreprise une fois signée.",
          "expiryDate": "Date d'échéance",
          "status": "Statut",
          "title": "Modifier les détails de la fiche"
        }
      },
      "documents": {
        "add": "Ajouter un document",
        "table": {
          "columns": {
            "actions": {
              "confirmDelete": {
                "message": "Cette action est irréversible.",
                "title": "Êtes-vous sûr·e de vouloir supprimer ce document ?"
              }
            },
            "createdAt": {
              "content": "{date, date, short}",
              "header": "Date d'ajout"
            },
            "createdBy": "Ajouté par",
            "documentType": {
              "header": "Type de document",
              "labels": {
                "ABILITY_CERTIFICATE": "Avis d'aptitude",
                "ACCOMMODATION_CERTIFICATE": "Proposition d'aménagement",
                "ADDITIONAL_EXAM_RESULT": "Résultats d'examens complémentaires",
                "APPOINTMENT_EXEMPTION_REQUEST": "Demande de dispense de visite",
                "APPOINTMENT_MODIFICATION_REQUEST": "Demande de modification de visite",
                "CHECKUP_CERTIFICATE": "Attestation de suivi",
                "CHECKUP_DOCUMENTS": "Document de téléconsultation",
                "COLLABORATORS_IMPORT": "Import de collaborateurs·trices",
                "COLLABORATORS_UPDATE": "Mise à jour de collaborateurs·trices",
                "COMPANY_SHEET": "Fiche d'entreprise",
                "CONFIDENTIAL_EMPLOYEE_DOCUMENT": "Document confidentiel collaborateur·trice",
                "CONSENT": "Consentement",
                "DMST": "DMST",
                "DRIVING_RISKY_VEHICLES_ABILITY_CERTIFICATE": "Non-contre-indication pour la conduite d’engins à risque",
                "DUERP": "DUERP",
                "EXTERNAL_REFERRAL_LETTER": "Lettre d'adressage extérieure",
                "IDENTITY_DOCUMENT": "Document d'identité",
                "IMPORTANT_ELECTRICAL_RISKS_ABILITY_CERTIFICATE": "Non-contre-indication pour les opérations électriques à risque important",
                "INABILITY_CERTIFICATE": "Avis d'inaptitude",
                "JOB_ASSESSMENT": "Étude de poste",
                "MEDICAL_INFORMATIONS_IMPORT": "Import de données médicales",
                "MEDICAL_OR_HOSPITALIZATION_REPORT": "Compte-rendu médical ou d'hospitalisation",
                "MULTIDISCIPLINARY_TEAM_REFERRAL_LETTER": "Lettre d'adressage par l'équipe pluridisciplinaire",
                "OTHER": "Autre document",
                "PDP": "PDP",
                "PRERETURN_LETTER": "Courrier de pré-reprise",
                "PRESCRIPTION": "Ordonnance",
                "RQTH_OR_INVALIDITY": "RQTH ou invalidité",
                "SICK_LEAVE": "Arrêt de travail",
                "TEMPORARY_INABILITY_CERTIFICATE": "Inaptitude temporaire"
              }
            },
            "fileName": "Nom du fichier"
          }
        },
        "title": "Documents",
        "upload": {
          "error": "Erreur lors de l'import du document",
          "success": "Document importé avec succès"
        }
      },
      "duerp": {
        "document": {
          "add": "Ajouter un fichier",
          "confirmDelete": "Êtes-vous sûr·e de vouloir supprimer le DUERP de l'adhérent {companyBranchName} ?",
          "empty": "Aucun DUERP n'a encore été mis en ligne pour cet adhérent.",
          "uploadedAt": "Importé le {date, date, long} par {createdBy}"
        },
        "history": {
          "none": "Aucun historique n'est disponible pour cet adhérent.",
          "title": "Historique"
        },
        "support": {
          "active": "Cet adhérent est accompagné pour son DUERP depuis le {date, date, short}.",
          "badge": {
            "none": "Non accompagné",
            "supported": "Accompagné"
          },
          "confirmEndSupport": "Vous êtes sur le point d'arrêter l'accompagnement DUERP de l'adhérent {companyBranchName}.<br />Êtes-vous sûr·e de vouloir continuer ?",
          "cta": "Lancer l'accompagnement",
          "dialogTitle": "Accompagnement adhérent",
          "endSupport": "Mettre un terme à l'accompagnement",
          "none": "Cet adhérent n'est pas accompagné pour son DUERP.",
          "title": "Suivi"
        },
        "title": "DUERP"
      },
      "employees": "{count, plural, one {{count} collaborateur·trice suivi·e} other {{count} collaborateurs·trices suivi·e·s}}",
      "informations": {
        "address": "Adresse du siège social",
        "generalInformations": "Informations générales",
        "hrReferent": "{count, plural, one {Référent·e RH} other {Référent·e·s RH}}",
        "legalName": "Raison sociale",
        "noHrReferent": "Aucun·e référent·e RH n'a encore été désigné·e.",
        "noNote": "Aucune note n'a encore été renseignée.",
        "note": "Note",
        "siret": "SIRET",
        "title": "Informations"
      },
      "staffRepresentatives": {
        "description": "{companyBranchName} dispose d'une ou plusieurs instances représentatives du personnel.",
        "descriptionEmpty": "{companyBranchName} n'a pas de représentants du personnel.",
        "title": "IRP"
      }
    },
    "dashboard": {
      "appointmentExemptionRequests": {
        "backToDashboard": "Retour au tableau de bord",
        "employeeRequestBadge": "Demande collab",
        "pendingCallout": "Vous avez {count, plural, one {{count} demande} other {{count} demandes}}  de dispense en attente.",
        "refuseDialog": {
          "callout": {
            "notification": "Le service RH sera notifié du refus et du motif indiqué ci-dessous.",
            "title": "Refus de la demande de dispense",
            "visitToBook": "La visite initiale devra être planifiée."
          },
          "fields": {
            "reviewerCommentLabel": "Motif du refus",
            "reviewerCommentPlaceholder": "Expliquez la raison du refus (conditions non remplies, document insuffisant, poste non identique…). Ce motif sera communiqué à l'employeur."
          },
          "submit": "Refuser la demande",
          "success": "Demande refusée avec succès.",
          "title": "Motif de refus",
          "validation": {
            "reviewerCommentMaxLength": "Le motif du refus ne peut pas dépasser {max, number} caractères.",
            "reviewerCommentMinLength": "Un minimum de {min, number} caractères est requis."
          }
        },
        "status": {
          "APPROVED": "Acceptée",
          "REJECTED": "Refusée"
        },
        "table": {
          "actions": {
            "accept": "Accepter",
            "refuse": "Refuser"
          },
          "columns": {
            "comment": "Commentaire",
            "company": "Adhérent",
            "contract": "Contrat",
            "files": "Fichiers",
            "patient": "Patient·e",
            "refusalReason": "Motif de refus"
          }
        },
        "tabs": {
          "archived": "Archivée(s)",
          "pending": "En attente de validation"
        },
        "title": "Dispenses de VIP initiales",
        "validateDialog": {
          "body": {
            "confirmation": "Vous êtes sur le point d'accepter la demande de dispense de {fullName}.",
            "consequence": "En confirmant, la visite initiale sera remplacée par cette dispense."
          },
          "submit": "Accepter la dispense",
          "success": "Demande acceptée avec succès.",
          "title": "Confirmer la demande de dispense"
        }
      },
      "backToDashboard": "Retour au tableau de bord",
      "dmstExportRequests": {
        "pendingCallout": "Vous avez {count, plural, one {{count} demande} other {{count} demandes}} d'export du DMST en attente."
      },
      "employeeNotArrivedYet": "Le·la collaborateur·trice n'est pas encore arrivé·e pour le rendez-vous.",
      "empty": {
        "description": "Consultez votre planning pour anticiper vos prochaines disponibilités.",
        "goToPlanning": "Consulter le planning",
        "title": "Aucune visite n'est planifiée aujourd'hui."
      },
      "requestsToggle": {
        "dmstExports": "Demandes d'export du DMST",
        "exemptions": "Dispenses de VIP initiale",
        "label": "Type de demandes",
        "pending": "demandes en attente"
      },
      "search": {
        "label": "Rechercher un·e collaborateur·trice",
        "placeholder": "Rechercher…"
      },
      "table": {
        "appointmentCancelled": "Cette visite a été annulée",
        "columns": {
          "appointmentType": "Type de visite",
          "company": "Adhérent",
          "name": "Collaborateurs·trices",
          "practitioner": "Professionnel·le de santé",
          "state": {
            "confirmed": "Confirmée",
            "header": "État",
            "notConfirmed": "Non confirmée"
          },
          "status": {
            "cancelled": "Annulée",
            "completed": "Terminée",
            "conditionsNotMet": "Conditions non réunies",
            "header": "Statut",
            "invalid": "Statut invalide",
            "lateEmployee": "Collaborateur·trice en retard",
            "lateMedicalStaff": "Médecin en retard",
            "noShow": "Collaborateur·trice absent·e",
            "noShowMedicalStaff": "Médecin absent",
            "ongoing": "En cours",
            "orientationError": "Erreur d'orientation",
            "pendingSubmission": "Brouillon",
            "unknown": "Rendez-vous manqué",
            "upcoming": "À venir",
            "waitingMedicalStaff": "Médecin en retard"
          },
          "time": {
            "content": "{start, date, ::d MMM y}<br/>{start, time, ::H mm} - {end, time, ::H mm}",
            "header": "Horaire"
          }
        },
        "greenDotPatientArrived": "Collaborateur·trice arrivé·e",
        "greenDotPatientOnline": "Collaborateur·trice connecté·e"
      },
      "title": {
        "metrics": {
          "title": "{count, plural, one {Vous avez {count} visite planifiée ou non clôturée.} other {Vous avez {count} visites planifiées ou non clôturées.}}"
        }
      }
    },
    "dmstExport": {
      "detail": {
        "awaitingValidation": "En attente de validation par le médecin.",
        "back": "Retour",
        "downloadCount": "Document consulté {count, plural, one {# fois} other {# fois}} par le·la collaborateur·trice.",
        "identity": "{name} • {companyBranch}",
        "identityDocument": "Pièce d'identité jointe à la demande",
        "identityDocumentPurged": "Supprimée après partage",
        "intro": "Les données médicales ne sont pas modifiées dans Paladin.",
        "introSteps": "Vérifiez l'identité du·de la collaborateur·trice, exportez le dossier, révisez-le hors-ligne, puis réimportez le PDF final avant de le partager.",
        "requestedOn": "Demande effectuée le {date, date, short}",
        "send": "Envoyer au·à la collaborateur·trice",
        "sendConfirmation": {
          "confirm": "Confirmer l'envoi",
          "description": "Le dossier médical de suivi sera transmis à {name} par lien sécurisé. Cette action est tracée et ne peut pas être annulée.",
          "title": "Envoyer le DMST au·à la collaborateur·trice"
        },
        "steps": {
          "documents": {
            "attachments": {
              "description": "Ajoutez d'autres fichiers à inclure dans l'export partagé (tous formats, 50 Mo max).",
              "empty": "Aucun fichier ajouté.",
              "remove": "Retirer",
              "title": "Autres fichiers à joindre"
            },
            "description": "Sélectionnez les pièces du dossier à joindre au PDF partagé. Elles s'ajouteront en annexe de l'export.",
            "deselectAll": "Tout désélectionner",
            "empty": "Aucun document disponible dans le DMST.",
            "selectedCount": "{selected} sur {total} {total, plural, one {document sélectionné} other {documents sélectionnés}}",
            "title": "Joindre les documents du DMST",
            "view": "Ouvrir le document"
          },
          "export": {
            "attachmentsNote": "Les pièces jointes ne sont pas téléchargées à cette étape, vous les sélectionnerez au moment du partage.",
            "consultations": "{count, plural, one {# consultation} other {# consultations}}",
            "description": "Génère un fichier .docx regroupant les {count, plural, one {# consultation} other {# consultations}} du dossier.",
            "download": "Exporter en .docx",
            "exported": "Exporté",
            "title": "Exporter le DMST"
          },
          "revise": {
            "description": "Ouvrez le .docx, ajustez son contenu si nécessaire, puis exportez-le au format PDF depuis votre traitement de texte.",
            "title": "Réviser le document hors-ligne"
          },
          "upload": {
            "confirm": "Confirmer l'import",
            "description": "Déposez le PDF final dans la demande. Il sera partagé tel quel au·à la collaborateur·trice.",
            "remove": "Retirer le PDF révisé",
            "title": "Importer le PDF révisé"
          }
        },
        "title": "Préparer l'export du DMST",
        "toasts": {
          "attachmentRemoved": "Fichier retiré.",
          "attachmentUploaded": "Fichier joint avec succès.",
          "downloadError": "Erreur lors du téléchargement.",
          "pdfImported": "PDF importé avec succès.",
          "pdfRemoved": "PDF révisé retiré.",
          "shared": "DMST envoyé au·à la collaborateur·trice.",
          "uploadError": "Erreur lors de l'envoi du fichier.",
          "validated": "DMST validé et envoyé."
        },
        "validate": "Valider et envoyer"
      },
      "list": {
        "columns": {
          "collaborator": "Collaborateurs·trices",
          "consultations": "Consultations",
          "requestedAt": "Date de la demande",
          "status": "Statut"
        },
        "empty": "Aucune demande dans cet onglet.",
        "status": {
          "IN_PROGRESS": "En cours de traitement",
          "PENDING": "Demandé",
          "PENDING_VALIDATION": "En attente de validation",
          "SHARED": "Partagé"
        },
        "tabs": {
          "shared": "Partagé(s)",
          "toProcess": "À traiter",
          "toValidate": "À valider"
        },
        "title": "Demandes d'export du DMST"
      }
    },
    "employees": {
      "metrics": {
        "employees": "{count, plural, one {{count} collaborateur·trice} other {{count} collaborateurs·trices}}"
      },
      "pdpBadge": "PDP",
      "search": {
        "label": "Rechercher un·e collaborateur·trice",
        "placeholder": "Rechercher…"
      },
      "table": {
        "columns": {
          "contractType": "Type de contrat",
          "jobTitle": "Poste de travail",
          "monitoringType": "Type de suivi",
          "name": "Collaborateurs·trices",
          "status": {
            "content": {
              "late": "En retard",
              "upToDate": "À jour"
            },
            "header": "Statut"
          }
        }
      },
      "tabs": {
        "absent": "Absences",
        "active": "Effectif total actif",
        "ghost": "Ghost",
        "pdp": "PDP"
      },
      "title": "Effectifs"
    },
    "parameters": {
      "tabs": {
        "facility": {
          "accessInstructions": "Instructions d'accès",
          "accessInstructionsHint": "300 caractères maximum",
          "accessInstructionsMaxLength": "Les instructions d'accès ne peuvent pas dépasser 300 caractères",
          "accessInstructionsPlaceholder": "Ex : digicode, étage, où se présenter à l'arrivée…",
          "address": "Adresse du centre",
          "email": "Email",
          "form": {
            "city": "Ville",
            "line": "Adresse du centre",
            "postalCode": "Code postal"
          },
          "phoneNumber": "Numéro de téléphone",
          "title": "Informations du centre de santé"
        },
        "personal": {
          "title": "Informations personnelles"
        }
      },
      "title": "Paramètres"
    },
    "pdp": {
      "details": {
        "header": {
          "closeCaseFile": {
            "callout": "La clôture du dossier indique que le plan PDP est terminé et que plus aucune modification ne pourra y être faite. Cette action est définitive.",
            "confirm": "Confirmer la clôture",
            "cta": "Clôturer le dossier",
            "notice": "Un email sera automatiquement envoyé au·à la collaborateur·trice pour l'informer de la clôture du dossier.",
            "success": "Le dossier PDP a bien été clôturé.",
            "title": "Clôturer le dossier PDP"
          },
          "interruptCaseFile": {
            "callout": "L'interruption du dossier est définitive et empêchera toute future modification.",
            "confirm": "Confirmer l'interruption",
            "cta": "Interrompre le dossier",
            "notice": "Un email sera automatiquement envoyé au·à la collaborateur·trice pour l'informer de l’interruption du dossier.",
            "success": "Le dossier PDP a bien été interrompu.",
            "title": "Interrompre le dossier PDP"
          },
          "otherActions": "Autres actions"
        },
        "tabs": {
          "actions": {
            "add": {
              "cta": "Ajouter une action",
              "submit": "Créer l'action",
              "title": "Nouvelle action"
            },
            "assignedTo": "Assigné à : <value>{practitioners}</value>",
            "createdBy": "Créé par {practitioner} le {date, date, short} à {date, time, short}",
            "deadline": "Échéance : <value>{deadline, date, short}</value>",
            "edit": {
              "cta": "Modifier cette action",
              "title": "Modifier l'action"
            },
            "empty": "Aucune action n’a encore été programmée.",
            "header": "Actions",
            "title": "Plan d'actions"
          },
          "history": {
            "title": "Historique"
          },
          "information": {
            "documents": {
              "confirmDelete": {
                "message": "Cette action est irréversible.",
                "title": "Êtes-vous sûr·e de vouloir supprimer ce document ?"
              },
              "createdAt": "Ajouté le {date, date, short} à {date, time, short}",
              "createdBy": "Par {name}",
              "empty": "Aucun document n’a encore été ajouté.",
              "title": "Documents"
            },
            "orientationReason": {
              "title": "Motif d'orientation"
            },
            "reportingSource": {
              "createdAt": "{date, date, short} à {date, time, short}",
              "createdBy": "Créé par",
              "source": "Source du signalement",
              "title": "Source du signalement"
            },
            "title": "Informations"
          }
        }
      },
      "initialization": {
        "creation": {
          "actions": {
            "create": "Créer le dossier"
          },
          "description": "Remplissez les informations nécessaires pour créer le dossier PDP.",
          "notice": "Un email sera automatiquement envoyé au·à la collaborateur·trice pour l'informer de la saisie de la cellule.",
          "success": "Le dossier PDP a bien été créé et intégré au DMST du·de la collaborateur·trice.",
          "title": "Création du dossier PDP"
        },
        "cta": "Saisir la cellule PDP",
        "information": {
          "actions": {
            "accept": "Le·la collaborateur·trice accepte",
            "refuse": "Le·la collaborateur·trice refuse"
          },
          "consent": {
            "given": "<strong>{name}</strong> a donné son consentement via son interface le <strong>{date, date, short}</strong>.<br />Veuillez confirmer oralement avec le·la collaborateur·trice.",
            "refused": "<strong>{name}</strong> a refusé de donner son consentement via son interface le <strong>{date, date, short}</strong>.<br />Veuillez confirmer oralement avec le·la collaborateur·trice.",
            "unknown": "<strong>{name}</strong> n'a pas encore donné son consentement.<br />Veuillez confirmer oralement avec le·la collaborateur·trice."
          },
          "description": "Demande de consentement du·de la collaborateur·trice",
          "information": {
            "content": {
              "item1": "Accompagnement personnalisé par une équipe pluridisciplinaire",
              "item2": "Suivi régulier adapté aux besoins spécifiques du·de la collaborateur·trice",
              "item3": "Coordination des soins entre différents professionnels de santé",
              "item4": "Support pour la gestion des traitements et du suivi médical"
            },
            "title": "Informations sur la PDP"
          },
          "notice": "Le consentement du·de la collaborateur·trice est obligatoire.<br />En cas de refus, celui-ci sera enregistré dans le dossier médical.",
          "title": "Saisir la cellule PDP"
        },
        "refusal": {
          "description": "Demande de refus de l'orientation vers l'équipe PDP",
          "fields": {
            "orientationReason": "Motif de l'orientation",
            "refusalReason": "Motif de refus",
            "reportingSource": "Source du signalement"
          },
          "success": "Le refus du·de la collaborateur·trice a bien été enregistré dans le DMST.",
          "title": "<strong>{name}</strong> a refusé l'orientation vers l'équipe PDP.<br />Le refus va être enregistré conformément aux obligations légales."
        },
        "signature": {
          "description": "Le consentement du·de la collaborateur·trice est obligatoire.",
          "title": "Demande de signature"
        }
      },
      "list": {
        "completionReason": "Motif de clôture :",
        "empty": "Aucun dossier PDP n'a encore été créé.",
        "interruptionReason": "Motif d'interruption :",
        "lifecycle": {
          "accepted": "Saisie acceptée",
          "at": "{date, date, short} à {date, time, short}",
          "completed": "Dossier clôturé",
          "created": "Dossier créé",
          "interrupted": "Dossier interrompu",
          "refused": "Saisie refusée",
          "with": "Avec {practitioner}"
        },
        "orientationReason": "Motif d'orientation :",
        "outcome": "Issue du dossier :",
        "refusalReason": "Motif du refus :",
        "rqthRequestAssociated": "Demande de reconnaissance RQTH :",
        "seeCaseFile": "Voir le dossier"
      },
      "status": {
        "COMPLETED": "Clôturé",
        "INTERRUPTED": "Interrompu",
        "IN_PROGRESS": "Cellule en cours",
        "REFUSED": "Refusé"
      }
    },
    "planning": {
      "calendar": {
        "absenceSlot": {
          "title": "Absence - {type}",
          "type": {
            "LEAVE": "Congés",
            "OTHER": "Autre"
          }
        },
        "activity": {
          "missingMetricsStatus": "Indicateurs à compléter",
          "tabs": {
            "information": {
              "seeCompanyBranch": "Voir l'adhérent",
              "title": "Informations",
              "travelTime": "{minutes, number} min",
              "travelTimeLabel": "Trajet"
            },
            "selfReportedMetrics": {
              "durationEmpty": "À compléter",
              "durationHours": "{hours, number} h",
              "durationHoursAndMinutes": "{hours, number} h {minutes, number} min",
              "durationMinutes": "{minutes, number} min",
              "hours": "Heures",
              "irpThemes": {
                "display": "Thèmes : <span>{value}</span>",
                "empty": "À compléter",
                "label": "Thèmes",
                "placeholder": "Sélectionner"
              },
              "minutes": "Minutes",
              "preparationTime": "Temps de préparation",
              "reportUrl": {
                "display": "Lien du rapport : <span>{value}</span>",
                "empty": "À compléter",
                "invalid": "Ce champ doit être une URL valide",
                "label": "Lien du rapport"
              },
              "reporting": "Rapport",
              "reportingDisplay": "Rapport : <span>{value}</span>",
              "restitutionTime": "Temps de restitution",
              "timeDisplay": "{label} : <span>{duration}</span>",
              "title": "Indicateurs"
            }
          },
          "title": "{activityType}",
          "titleCompanyBranch": "{activityType} avec {companyBranchName}"
        },
        "bookAppointment": {
          "action": "Planifier",
          "bookingSlotRange": "Créneau entre <strong>{start, time, ::H mm}</strong> et <strong>{end, time, ::H mm}</strong>",
          "fields": {
            "companyBranch": "Adhérent",
            "employee": "Collaborateur·trice",
            "endTime": "Horaire de fin",
            "practitioner": "Professionnel de santé",
            "startTime": "Horaire de début"
          },
          "title": "Planifier une visite"
        },
        "bookFreeAppointment": {
          "title": "Planifier une visite libre"
        },
        "editSlot": {
          "actions": {
            "delete": "Supprimer le créneau",
            "deleteConfirmation": {
              "cancel": "Annuler",
              "confirm": "Supprimer le créneau",
              "description": "Ce créneau est associé à des visites médicales planifiées.<br />En le supprimant, les rendez-vous seront automatiquement annulés et les collaborateurs·trices concerné·e·s recevront un email pour replanifier leur visite.<br />Souhaitez-vous poursuivre ?",
              "title": "Vous êtes sur le point de supprimer le créneau.<br />Êtes-vous sûr·e de vouloir continuer ?"
            },
            "reassign": "Réaffecter"
          },
          "title": "Modifier un créneau"
        },
        "recurringSchedule": {
          "delete": {
            "confirm": "Confirmer la suppression",
            "endsOn": "Se termine le {date, date, ::EEEE d MMMM y}",
            "title": "Êtes-vous sûr·e de supprimer cette plage de disponibilité périodique ?",
            "trigger": "Supprimer",
            "warning": "Les créneaux déjà générés ne seront pas supprimés."
          },
          "deleteAbsence": {
            "title": "Êtes-vous sûr·e de supprimer cette absence périodique ?",
            "warning": "Les absences déjà générées ne seront pas supprimées."
          },
          "edit": {
            "callout": "Les créneaux déjà générés ne seront pas modifiés. Les créneaux issus de cette mise à jour seront créés à partir du {date, date, ::EEEE d MMMM y}.",
            "endOnMustBeOnOrAfterHorizon": "La date doit être le {date, date, ::d MMMM y} ou après",
            "trigger": "Modifier"
          },
          "editAbsence": {
            "callout": "Les absences déjà générées ne seront pas modifiées. Les absences issues de cette mise à jour seront créées à partir du {date, date, ::EEEE d MMMM y}."
          },
          "generateSchedule": {
            "allSkipped": "Aucun créneau à générer",
            "button": "Générer les créneaux",
            "error": "Erreur : impossible de générer les créneaux",
            "success": "{count, plural, one {{count} créneau généré} other {{count} créneaux générés}}",
            "successAbsences": "{count, plural, one {{count} absence générée} other {{count} absences générées}}"
          },
          "new": "Nouvelle récurrence",
          "slot": "Plage de disponibilité",
          "title": "Emploi du temps"
        },
        "viewTabs": {
          "calendar": "Calendrier",
          "schedule": "Emploi du temps"
        }
      },
      "new": {
        "absenceSlot": {
          "actionsMenuAriaLabel": "Actions sur l'absence",
          "editTrigger": "Modifier",
          "fields": {
            "endDateTime": "Date et heure de fin",
            "practitioner": "Professionnel",
            "startDateTime": "Date et heure de début",
            "type": "Type d'absence"
          },
          "title": "Absence"
        },
        "activity": {
          "fields": {
            "activityType": "Type d'activité",
            "companyBranch": "Adhérent",
            "companyBranchRepresentative": "Représentant de l'adhérent",
            "description": "Description",
            "endDateTime": "Date et heure de fin",
            "location": "Lieu",
            "meetingType": "Type de réunion",
            "practitioner": "Professionnel",
            "startDateTime": "Date et heure de début",
            "subtype": "Sous-type",
            "travelTime": "Temps de trajet",
            "travelTimeHint": "En minutes"
          },
          "title": "Tiers-temps"
        },
        "appointment": {
          "bookingSlotRange": "Créneau du <strong>{start, date, fullUtc}</strong> entre <strong>{start, time, ::H mm}</strong> et <strong>{end, time, ::H mm}</strong>",
          "cancelConfirmation": {
            "confirm": "Confirmer la suppression",
            "description": "Si vous confirmez l'annulation, la consultation sera annulée sans être replanifiée.",
            "title": "Êtes-vous sûr·e de supprimer cette visite ?"
          },
          "confirmArrival": "Confirmer l'arrivée",
          "dateAndTime": "{date, date, ::EEEE d MMMM y} • De {from, time, ::H mm} à {to, time, ::H mm}",
          "fields": {
            "employee": "Collaborateur·trice",
            "practitioner": "Professionnel"
          },
          "identity": {
            "confirm": "Valider l'identité",
            "fields": {
              "address": "<bold>Adresse :</bold> {address}",
              "birthDate": "<bold>Date de naissance :</bold> {birthDate}",
              "birthLocation": "<bold>Lieu de naissance :</bold> {birthLocation}",
              "email": "<bold>Email :</bold> {email}",
              "firstName": "<bold>Prénom :</bold> {firstName}",
              "lastName": "<bold>Nom :</bold> {lastName}",
              "sex": "<bold>Sexe :</bold> {sex}"
            },
            "status": "Statut"
          },
          "isArrived": "Arrivée confirmée",
          "isProvisional": "En attente du retour du·de la collaborateur·trice",
          "location": {
            "companyBranch": "Dans les locaux de {name}",
            "remote": "À distance"
          },
          "notes": "Notes",
          "practitionerQualification": {
            "DOCTOR": "Médecin",
            "NURSE": "Infirmier·ère"
          },
          "seeMedicalRecord": "Consulter le dossier médical",
          "startVisit": "Démarrer la visite",
          "tabs": {
            "consents": "Consentements",
            "identity": "Identité",
            "information": "Informations"
          },
          "title": "Visite"
        },
        "createEventPopover": {
          "title": "Nouvel évènement"
        },
        "deleteAbsenceSlot": {
          "confirm": "Confirmer la suppression",
          "description": "Du {start, date, ::EEEE d MMMM y} à {start, time, ::H mm} au {end, date, ::EEEE d MMMM y} à {end, time, ::H mm}",
          "descriptionSameDay": "Le {date, date, ::EEEE d MMMM y} de {start, time, ::H mm} à {end, time, ::H mm}",
          "title": "Êtes-vous sûr·e de supprimer cette absence ?",
          "titleForOtherPractitioner": "Êtes-vous sûr·e de supprimer l'absence de {firstName} {lastName} ?",
          "trigger": "Supprimer"
        },
        "deleteActivity": {
          "confirm": "Confirmer la suppression",
          "title": "Êtes-vous sûr·e de supprimer cette activité tiers-temps ?",
          "titleForOtherPractitioner": "Êtes-vous sûr·e de supprimer l'activité tiers-temps de {firstName} {lastName} ?",
          "trigger": "Supprimer"
        },
        "deleteSlot": {
          "confirm": "Confirmer la suppression",
          "title": "Êtes-vous sûr·e de supprimer cette plage de disponibilité ?",
          "trigger": "Supprimer"
        },
        "practitionerPicker": {
          "label": "Professionnel",
          "team": "Toute l'équipe"
        },
        "reassignSlot": {
          "confirmation": {
            "description": "Toutes les visites de cette plage de disponibilité seront réattribuées à {name}.",
            "title": "Êtes-vous sûr·e de vouloir réattribuer cette plage de disponibilité ?"
          },
          "description": "La plage de disponibilité et l’ensemble des visites qu’elle contient seront réattribuées au nouveau professionnel de santé.",
          "practitioner": "Professionnel",
          "title": "Réattribuer une plage de disponibilité ",
          "trigger": "Réattribuer"
        },
        "recurringSlot": {
          "fields": {
            "daysOfWeek": "Répéter les",
            "endNever": "Jamais",
            "startInTwoMonths": "Dans 2 mois",
            "startOn": "Le :",
            "startOnMustBeInTheFuture": "La date doit être dans le futur",
            "templateEndsOn": "Se termine",
            "templateStartsOn": "À partir de"
          },
          "title": "Plage de disponibilité"
        },
        "slot": {
          "actionsMenuAriaLabel": "Actions sur le créneau",
          "editTrigger": "Modifier",
          "fields": {
            "activityType": "Type d'activité",
            "availabilityRangeDate": "Date de la plage de disponibilité",
            "bookingSlotDate": "Date",
            "companyBranch": "Adhérent",
            "endTime": "Heure de fin",
            "location": "Lieu",
            "startTime": "Heure de début"
          },
          "title": "Plage de disponibilité"
        }
      },
      "team": {
        "appointment": {
          "actions": {
            "confirmEmployeeArrival": "Confirmer l'arrivée"
          },
          "details": {
            "actions": {
              "cancel": "Annuler la consultation",
              "cancelConfirmation": {
                "cancel": "Annuler",
                "confirm": "Confirmer l'annulation",
                "description": "Si vous confirmez l'annulation, la visite sera annulée sans être replanifiée.",
                "title": "Vous êtes sur le point d'annuler la consultation.<br />Êtes-vous sûr·e de vouloir continuer ?"
              },
              "reassign": "Réaffecter"
            },
            "date": "Date de visite",
            "isProvisional": "En attente du retour du·de la collaborateur·trice",
            "practitioner": "Professionnel de santé",
            "slotType": "Type de consultation",
            "time": "Horaire",
            "title": "Informations de la consultation",
            "type": "Type de visite"
          },
          "patientContactInformation": {
            "title": "Informations de contact"
          },
          "patientIdentity": {
            "actions": {
              "validate": "Valider l'identité"
            },
            "status": {
              "provisional": "Provisoire",
              "validated": "Validé"
            },
            "title": "Informations personnelles"
          },
          "title": "Consultation"
        },
        "createAbsenceSlot": {
          "title": "Ajouter une absence"
        },
        "createSlots": {
          "actions": {
            "addTimeSlot": "Ajouter une plage",
            "applyToAllDays": "Appliquer à tous les jours",
            "openSlots": "Ouvrir les créneaux"
          },
          "fields": {
            "bookingSlotType": "Type de créneau",
            "end": "Au",
            "from": "De",
            "practitioners": "Professionnels de santé",
            "start": "Du",
            "to": "À"
          },
          "title": "Ajouter des créneaux"
        }
      }
    },
    "prevention": {
      "description": "Partagez facilement des <bold>contenus de prévention</bold> directement auprès de vos collaborateurs·trices pour <bold>renforcer la culture santé au travail</bold>.<br/><br/>Un espace pensé pour <bold>informer</bold>, <bold>sensibiliser</bold> et <bold>encourager</bold> les bons réflexes au quotidien."
    },
    "sidebar": {
      "companies": "Adhérents",
      "dashboard": "Tableau de bord",
      "employees": "Collaborateurs·trices",
      "newPlanning": "Nouveau planning",
      "parameters": "Paramètres",
      "planning": "Planning",
      "prevention": "Prévention",
      "teamView": "Vue équipe"
    }
  },
  "navigation": {
    "dashboard": "Tableau de Bord",
    "home": "Accueil",
    "newDA": "🐰✨ NEW ✨🐰",
    "parameters": "Paramètres",
    "roadmap": "Roadmap Paladin"
  },
  "pages": {
    "appointments": {
      "employeeNotArrivedYet": "Le·la collaborateur·trice n'est pas encore arrivé·e au rendez-vous",
      "noAppointments": "Aucune visite n'est prévue le {date, date, ::EEEE d MMMM y}",
      "table": {
        "confirmed": "Confirmation",
        "isArrived": "Présence",
        "visitTime": "Horaire"
      },
      "title": "Visites du {date, date, ::EEEE d MMMM}"
    },
    "center": {
      "parameters": {
        "address": {
          "line": {
            "title": "Adresse du centre"
          }
        },
        "submit": "Mettre à jour",
        "subtitle": "Utilisez cette page pour mettre à jour les informations du centre.",
        "title": "Informations du centre",
        "updateSuccess": "Paramètres enregistrés avec succès"
      }
    },
    "collaboratorAppointment": {
      "book": {
        "chooseExplanation": "Choisissez le moyen et le moment qui vous conviennent le mieux pour votre consultation :",
        "noAvailableSlot": "Aucun créneau disponible pour le moment.\nContactez votre responsable RH.",
        "noSuitableSlot": "Si aucun créneau ne vous convient, contactez votre responsable RH.",
        "scheduleAppointmentCTA": "Planifier votre visite",
        "welcome": "Bienvenue chez Sano.\n\nTout est conçu pour vous simplifier la vie : rendez-vous faciles, conseils clairs, et une gestion fluide de la santé au travail.\n\nComptez sur nous pour être à vos côtés, simplement et efficacement.\n\nL'équipe Sano"
      },
      "confirm": {
        "title": "Votre créneau a bien été confirmé."
      },
      "editBooking": {
        "currentBooking": "Votre rendez-vous actuel",
        "title": "Modifier votre créneau",
        "visitDate": "Date de la visite",
        "visitTime": "Horaire"
      },
      "recap": {
        "canEditBookingUntil": "Vous pouvez modifier cette date jusqu'au <bold>{until}</bold>.",
        "cannotEditBooking": "Si vous avez un problème avec ce créneau, merci de vous rapprocher de votre responsable RH.",
        "mailConfirm": "Vous recevrez un e-mail de confirmation qui rappellera les documents à amener.",
        "plannedFor": {
          "IN_PERSON_CONSULTATIONS": "Vous avez planifié votre visite pour le :",
          "TELECONSULTATIONS": "Vous avez planifié votre téléconsultation pour le :"
        },
        "thankYou": "Merci et à bientôt !"
      }
    },
    "documents": {
      "actions": {
        "cancelShareWithEmployees": "Annuler le partage aux collaborateurs·trices",
        "cancelShareWithMedicalService": "Annuler le partage au service médical",
        "delete": "Supprimer",
        "download": "Télécharger",
        "dropDocument": "Glissez et déposez vos fichiers ici pour les télécharger rapidement",
        "shareWithEmployees": "Partager aux collaborateurs·trices",
        "shareWithMedicalService": "Partager au service médical",
        "shareWithMemberBranch": "Partager"
      },
      "addOne": "Ajouter un document",
      "addedBy": {
        "label": "Ajouté par",
        "labels": {
          "facility": "Service médical"
        }
      },
      "companyBranch": {
        "companyBranches": "{count, plural, one {{count} adhérent} other {{count} adhérents}}",
        "createdAt": "Date de création",
        "name": "Nom de l'adhérent",
        "noCompanyBranches": "Aucun adhérent",
        "siret": "SIRET"
      },
      "createdAt": "Date d'ajout",
      "documentType": {
        "label": "Type de document",
        "labels": {
          "ABILITY_CERTIFICATE": "Avis d'aptitude",
          "ACCOMMODATION_CERTIFICATE": "Proposition d'aménagement",
          "ADDITIONAL_EXAM_RESULT": "Résultats d'examens complémentaires",
          "APPOINTMENT_EXEMPTION_REQUEST": "Demande de dispense de visite",
          "APPOINTMENT_MODIFICATION_REQUEST": "Demande de modification de visite",
          "CHECKUP_CERTIFICATE": "Attestation de suivi",
          "CHECKUP_DOCUMENTS": "Document de téléconsultation",
          "COLLABORATORS_IMPORT": "Import de collaborateurs·trices",
          "COLLABORATORS_UPDATE": "Mise à jour de collaborateurs·trices",
          "COMPANY_SHEET": "Fiche d'entreprise",
          "CONFIDENTIAL_EMPLOYEE_DOCUMENT": "Document confidentiel collaborateur·trice",
          "CONSENT": "Consentement",
          "DMST": "DMST",
          "DRIVING_RISKY_VEHICLES_ABILITY_CERTIFICATE": "Non-contre-indication pour la conduite d’engins à risque",
          "DUERP": "DUERP",
          "EXTERNAL_REFERRAL_LETTER": "Lettre d'adressage extérieure",
          "IDENTITY_DOCUMENT": "Document d'identité",
          "IMPORTANT_ELECTRICAL_RISKS_ABILITY_CERTIFICATE": "Non-contre-indication pour les opérations électriques à risque important",
          "INABILITY_CERTIFICATE": "Avis d'inaptitude",
          "JOB_ASSESSMENT": "Étude de poste",
          "MEDICAL_INFORMATIONS_IMPORT": "Import de données médicales",
          "MEDICAL_OR_HOSPITALIZATION_REPORT": "Compte-rendu médical ou d'hospitalisation",
          "MULTIDISCIPLINARY_TEAM_REFERRAL_LETTER": "Lettre d'adressage par l'équipe pluridisciplinaire",
          "OTHER": "Autre document",
          "PDP": "PDP",
          "PRERETURN_LETTER": "Courrier de pré-reprise",
          "PRESCRIPTION": "Ordonnance",
          "RQTH_OR_INVALIDITY": "RQTH ou invalidité",
          "SICK_LEAVE": "Arrêt de travail",
          "TEMPORARY_INABILITY_CERTIFICATE": "Inaptitude temporaire"
        }
      },
      "fileName": "Nom du fichier",
      "shareWithMemberBranch": {
        "description": "Avec quel adhérent souhaitez-vous partager les documents :",
        "shareCTA": "Partager",
        "title": "Partager un document à un adhérent"
      },
      "tableFooter": "{count, plural, =0 {Aucun document} one {1 document} other {{count} documents}}"
    },
    "downloadDocument": {
      "ariaLabel": "{count, plural, one {Télécharger le document} other {Télécharger les {count} documents}}",
      "expired": {
        "description": "Pour des raisons de sécurité, les fichiers sont disponibles pendant 14 jours.",
        "loginLinkText": "espace Paladin",
        "loginNote": "Vous pouvez toujours les retrouver en vous connectant à votre",
        "title": "Le lien de téléchargement a expiré."
      },
      "forbidden": {
        "description": "Vous n'êtes pas autorisé à accéder à ce document.",
        "title": "Accès refusé"
      },
      "loadingTooltip": "Chargement de vos fichiers...",
      "loadingTooltipSubtitle": "Veuillez patienter quelques instants.",
      "noDocument": {
        "description": "Cette visite ne comporte pas de document à télécharger.",
        "title": "Aucun document disponible"
      },
      "successDescription": "Le fichier sera disponible dans quelques instants dans votre dossier de téléchargement.",
      "successTitle": "Votre téléchargement a commencé.",
      "tooltip": "Cliquez ici pour télécharger vos fichiers",
      "tooltipCountdown": "{count, plural, =0 {Expire aujourd'hui dans {time}} one {{count} jour {time} restant} other {{count} jours {time} restants}}"
    },
    "employeeDetails": {
      "informations": "Informations",
      "informationsPage": {
        "documents": "Documents",
        "prevention": "Prévention",
        "title": "Informations du·de la collaborateur·trice"
      },
      "medicalRecords": "Historique Médical et Informations de Santé",
      "medicalRecordsPage": {
        "checkupPanel": {
          "draft": "Brouillon",
          "published": "État apte",
          "subtitle": "Examen du {date}",
          "title": "Visite d'information et de Prévention"
        },
        "history": "Historique des examens",
        "modal": {
          "resumeEditing": "Continuer l'édition",
          "signAndFinish": "Signer et envoyer le document",
          "title": "Finaliser l'examen"
        },
        "newExam": "Nouvel examen",
        "title": "Historique Médical et Informations de Santé"
      },
      "modificationHistory": "Historique",
      "modificationHistoryPage": {
        "createdBy": "Créé par {firstName} {lastName}",
        "createdByPaladin": "Créé par Paladin",
        "createdLabel": "Création de la fiche collaborateur·trice",
        "identityValidation": {
          "description": "Identité validée par {firstName} {lastName} le {date, date, ::d M y}",
          "title": "Validation d'identité"
        },
        "noShow": {
          "consultationType": {
            "IN_PERSON_CONSULTATION": "présentiel",
            "TELECONSULTATION": "téléconsultation"
          },
          "description": "Planifiée le {date, date, ::d MMMM y} de {from, time, ::H mm} à {to, time, ::H mm} en {appointmentType}",
          "title": "Non présentation à une {appointmentType}"
        },
        "title": "Historique",
        "updatedBy": "Modifié par {firstName} {lastName}",
        "updatedByPaladin": "Modifié par Paladin",
        "updatedField": "Changement de "
      },
      "scheduleAnAppointmentForEmployee": "Prendre un rendez-vous",
      "updateSuccess": "Informations mises à jour avec succès"
    },
    "employees": {
      "addEmployee": "Ajouter un·e collaborateur·trice",
      "addEmployeePage": {
        "addEmployee": "Ajouter un·e collaborateur·trice",
        "identityInformations": "Informations d'identité",
        "personalInformations": "Informations personnelles",
        "professionalInformations": "Informations professionnelles",
        "professionalRisks": "Risques professionnels",
        "success": "Collaborateur·trice ajouté·e avec succès"
      },
      "addFirstEmployee": "Ajouter votre premier·ère collaborateur·trice",
      "employee": {
        "label": "Collaborateurs·trices",
        "tableFooter": "{count, plural, =0 {Aucun·e collaborateur·trice} one {1 collaborateur·trice} other {{count} collaborateurs·trices}}"
      },
      "importCollaborators": {
        "fileUpload": {
          "downloadExample": "Télécharger un modèle",
          "howToStart": "Vous ne savez pas comment commencer ?",
          "importFile": "Importer un fichier",
          "importFileDescription": "Exporter les données de vos systèmes pour accélérer votre import de données.\nMerci d'ajouter un fichier .csv ou .xls.",
          "requiredFieldsDescription": "Les lignes sans ces informations ne seront pas importées.",
          "requiredFieldsList": {
            "email": "Adress e-mail personnelle",
            "firstName": "Prénom",
            "lastName": "Nom de famille",
            "startDate": "Date de début du contrat"
          },
          "requiredFieldsTitle": "Certains champs sont obligatoires pour permettre l'import :",
          "startImport": "Lancer l'import",
          "uploadButton": "Téléverser un fichier"
        },
        "mapping": {
          "error": {
            "description": "Erreur lors du chargement du mapping",
            "title": "Erreur"
          },
          "loading": {
            "description": "Merci de patienter.",
            "title": "Analyse du fichier en cours"
          },
          "mappingForm": {
            "aiConfidence": "Confiance",
            "aiMapping": "Champ détecté dans le fichier",
            "confidence": {
              "high": "Élevée",
              "low": "Faible",
              "medium": "Moyenne"
            },
            "description": "Vérifiez que chaque colonne est associée au bon champ Paladin",
            "example": "Aperçu des données",
            "exampleInfo": "Cet aperçu de données ne montre qu'une partie des valeurs du fichier.",
            "paladinField": "Champ Paladin",
            "previewButton": "Prévisualiser",
            "revertToAiMapping": "Revenir au mapping proposé",
            "title": "Associer les champs"
          },
          "missingFields": {
            "cancel": "Annuler",
            "confirm": "Ignorer les erreurs",
            "description": "Certains champs n'ont pas pu être mappés :",
            "title": "Champs non mappés"
          }
        },
        "next": "Suivant",
        "preview": {
          "descriptionFull": "Voici un aperçu des {count} collaborateurs·trices à importer. Vérifiez et validez les données avant de lancer l'import.",
          "descriptionSample": "Voici un aperçu de {count} collaborateurs·trices sélectionné·e·s aléatoirement. Vérifiez et validez les données avant de lancer l'import.",
          "importButton": "Importer les collaborateurs·trices",
          "title": "Prévisualisation de l'import des collaborateurs·trices"
        },
        "previous": "Précédent",
        "summary": {
          "backToEmployees": "Revenir à l'effectif",
          "imported": "collaborateurs·trices importé·e·s",
          "notImported": "collaborateurs·trices non importé·e·s",
          "title": "Résumé de l'import"
        },
        "title": "Ajouter vos collaborateurs·trices à Paladin"
      },
      "importFile": "Importer un fichier",
      "importMedicalData": "Importer des documents de suivi",
      "importMedicalInformations": {
        "addFile": "Ajouter un fichier",
        "addOtherFiles": "Ajouter d'autres fichiers",
        "importAttestation": "Importer une attestation",
        "importAttestations": {
          "description": "Exporter le plus de données possibles de vos systèmes pour accélérer votre import de données.\nVous pouvez aussi importer directement les attestations de suivi de vos collaborateurs·trices.",
          "importFiles": "Importer des fichiers (20 maximum à la fois)",
          "noAttestation": "Je n'ai pas d'attestation(s)",
          "title": "Importer des documents de suivi",
          "waitForFileToBeProcessed": "Vos fichiers sont en cours de chargement, veuillez patienter"
        },
        "recap": {
          "description": "Exporter le plus de données possibles de vos systèmes pour accélérer votre import de données. Vous pouvez aussi importer directement les attestations de suivi de vos collaborateurs·trices.",
          "title": "Rapport d'import"
        },
        "title": "Reprendre l'historique médical"
      },
      "medicalDataImport": {
        "confirmStep": {
          "approve": "Validée",
          "approveTooltip": "Valider la correspondance",
          "autoImportedCardText": "Informations médicales importées avec succès",
          "finishImport": "Compléter l'import",
          "importToValidateCardText": "Correspondances de données collaborateurs·trices à valider",
          "missingMedicalInformationCardText": "Informations médicales de collaborateurs·trices manquantes",
          "nChangesAdded": "{count, plural, one {{count, number} information médicale importée} other {{count, number} informations médicales importées}}",
          "nMatchToValidate": "{count, plural, one {{count, number} correspondance} other {{count, number} correspondances}} à valider",
          "refuse": "Rejetée",
          "refuseTooltip": "Rejeter la correspondance",
          "success": "Données médicales importées avec succès",
          "table": {
            "collaborator": "Collaborateur sur Paladin",
            "matching": "Correspondance"
          }
        },
        "recapStep": {
          "failed": {
            "description": "Nous n’avons pas réussi à lire les informations médicales et/ou à les associer avec vos collaborateurs·trices existant·e·s.\nVérifiez les documents et/ou les collaborateurs·trices que vous avez importé·e·s.",
            "retry": "Ré-essayer",
            "title": "Import échoué"
          },
          "success": {
            "description": "L’ensemble de vos données ont été synchronisées.\nDéfinissez maintenant les risques de votre entreprise et associez-les à vos collaborateurs·trices.",
            "title": "Import réalisé avec succès !"
          }
        }
      },
      "noHeadcountToDisplay": "Aucun effectif à afficher",
      "noMedicalDataToImport": "Les données médicales des collaborateurs·trices sont à jour.",
      "title": "Effectif",
      "update": "Mettre à jour",
      "updateCollaborators": {
        "summary": {
          "notUpdated": "collaborateurs·trices non mis·e·s à jour",
          "updated": "collaborateurs·trices mis·e·s à jour"
        }
      }
    },
    "homeCharts": {
      "incompleteData": {
        "subtitle": "Profils concernés",
        "title": "Données incomplètes"
      },
      "lateVisits": {
        "subtitle": "Afficher les visites",
        "title": "Visites en retard",
        "tooltip": "{count, plural, =0 {Aucune visite en retard en {date, date, ::MMMM y}} one {1 visite en retard en {date, date, ::MMMM y}} other {{count} visites en retard en {date, date, ::MMMM y}}}"
      },
      "noDataYet": "Pas encore de données",
      "noShow": {
        "emptyChartMessage": "Félicitations, toutes les visites ont été honorées.",
        "subtitle": "Afficher les non présentations",
        "title": "Absences à des visites"
      },
      "title": "Bonjour {name},",
      "visitsPlanningChart": {
        "lateVisits": "Visites en retard",
        "subtitle": "Dont",
        "title": "À programmer",
        "visitsToPlannify": "Visites à planifier"
      }
    },
    "medicalRecords": {
      "appointment": {
        "alreadyUploadedWarning": "⚠️ Attention le document existant sera remplacé ! ⚠️",
        "appointmentType": "Type de visite",
        "carriedOutBy": "Effectué par",
        "certificate": "Attestation de suivi",
        "date": "Date",
        "editCheckup": "Modifier la consultation",
        "empty": "Aucune visite n'a encore été planifiée.",
        "fit": "Apte",
        "seeCertificate": "Voir l'attestation",
        "status": "Statut",
        "unfit": "Inapte",
        "uploadCertificate": "Ajouter une attestation de suivi"
      },
      "documents": {
        "createdBy": "Ajouté par",
        "date": "Date d'ajout",
        "delete": {
          "message": "Cette action est irréversible.",
          "title": "Êtes-vous sûr·e de vouloir supprimer ce document ?"
        },
        "documentType": "Type de document",
        "empty": "Aucun document n'a encore été ajouté.",
        "fileName": "Nom du fichier",
        "sharedWith": "Niveau de partage",
        "upload": {
          "cta": "Ajouter un document",
          "documentTypeLabel": "Type de document",
          "documentTypePlaceholder": "Sélectionnez un type de document",
          "error": "Une erreur est survenue lors de l'ajout du document",
          "sharedWithLabel": "Ce document sera partagé avec",
          "submit": "Enregistrer le document",
          "success": "Document ajouté avec succès",
          "title": "Ajouter un document"
        }
      },
      "emptyState": {
        "noInformation": "Aucune information médicale n’a encore été enregistrée pour ce·tte collaborateur·trice."
      },
      "export": {
        "docx": "Exporter le DMST",
        "error": "L’export du DMST a échoué, merci de réessayer."
      },
      "footer": {
        "planVisit": "Planifier une visite"
      },
      "header": {
        "bornAt": "Né le {date, date, short} ({age, number} ans)",
        "workAt": "{jobTitle} chez <a>{company}</a>"
      },
      "health": {
        "currentTreatments": {
          "medications": "Médicaments",
          "paramedicalFollowUp": "Suivi paramédical / rééducation",
          "title": "Traitement en cours",
          "vaccineStatus": "Suivi vaccinal",
          "vaccines": "Vaccins"
        },
        "examByDevice": {
          "clinicalExam": "Examen clinique",
          "clinicalExamPlaceholder": "Entrer ici l'examen clinique…",
          "pathology": "Pathologie",
          "pathologyPlaceholder": "Rechercher une pathologie",
          "systems": {
            "abdominal": "Abdominal",
            "cardiovascular": "Cardiovasculaire",
            "dermatological": "Dermatologique",
            "ent": "ORL",
            "gastrointestinal": "Gastro-intestinal",
            "gynecological": "Gynécologique",
            "metabolicEndocrinological": "Métabolique/endocrinologique",
            "neurological": "Neurologique",
            "ophthalmological": "Ophtalmologique",
            "orthopedicRheumatological": "Orthopédique/rhumatologique",
            "psychiatry": "Psychiatrie",
            "respiratory": "Respiratoire",
            "uroNephrological": "Uro-néphrologique"
          },
          "title": "Examen par appareil"
        },
        "examDevice": {
          "clinicalExam": "Examen clinique",
          "clinicalExamPlaceholder": "Entrer ici l'examen clinique…",
          "commentaireExamenClinique": "Commentaire examen clinique",
          "pathology": "Pathologie",
          "pathologyPlaceholder": "Rechercher une pathologie",
          "systems": {
            "abdominal": "Abdominal",
            "cardiovascular": "Cardiovasculaire",
            "dermatological": "Dermatologique",
            "ent": "ORL",
            "gastrointestinal": "Gastro-intestinal",
            "gynecological": "Gynécologique",
            "metabolicEndocrinological": "Métabolique/endocrinologique",
            "neurological": "Neurologique",
            "ophthalmological": "Ophtalmologique",
            "orthopedicRheumatological": "Orthopédique/rhumatologique",
            "psychiatry": "Psychiatrie",
            "respiratory": "Respiratoire",
            "uroNephrological": "Uro-néphrologique"
          },
          "title": "Examen par appareil"
        },
        "examination": "Examen",
        "familyMedicalBackground": {
          "familyMedicalBackground": "Antécédents familiaux",
          "title": "Antécédents familiaux"
        },
        "interrogation": "Interrogatoire",
        "lifestyle": {
          "alcohol": "Alcool",
          "diet": "Alimentation",
          "drugs": "Drogue",
          "lifestyle": "Hygiène de vie",
          "list": "Oui ({list})",
          "physicalActivity": "Activité physique",
          "tobacco": "Tabac"
        },
        "medicalHistory": {
          "allergies": "Allergies",
          "medicalSurgicalHistory": "Antécédents médico-chirurgicaux",
          "otherPersonnalMedicalBackground": "Autres antécédents médicaux",
          "pathologies": "Pathologies",
          "surgeries": "Opérations"
        },
        "noNotes": "Aucune note n'a encore été renseignée à propos de ce·tte collaborateur·trice.",
        "notes": "Notes",
        "vaccines": {
          "expired": "Expiré",
          "injectedAt": "Injecté le",
          "status": "Statut",
          "statusLabels": {
            "NOT_UP_TO_DATE": "Non",
            "UNKNOWN": "Ne sait pas",
            "UP_TO_DATE": "Oui"
          },
          "upToDate": "À jour",
          "vaccine": "Vaccin",
          "vaccineStatus": "Statut vaccinal",
          "validUntil": "Valide jusqu'au"
        },
        "vitals": {
          "bloodPressure": "Tension artérielle",
          "bloodPressureUnit": "{bloodPressure} mmHg",
          "bloodSugarLevel": "Glycémie",
          "bloodSugarLevelUnit": "{bloodSugarLevel, number} g/L",
          "bmi": "IMC",
          "bmiExtremlyObese": "Obésité sévère",
          "bmiNormal": "Normal",
          "bmiObese": "Obésité modérée",
          "bmiOverweight": "Surpoids",
          "bmiUnderweight": "Maigreur",
          "diastolicBloodPressure": "Tension artérielle diastolique",
          "heartRate": "Fréquence cardiaque",
          "heartRateUnit": "{heartRate, number} bpm",
          "height": "Taille",
          "heightUnit": "{height, number} cm",
          "systolicBloodPressure": "Tension artérielle systolique",
          "vitalParameters": "Paramètres vitaux",
          "weight": "Poids",
          "weightUnit": "{weight, number} kg"
        }
      },
      "professionalMonitoring": {
        "handicapCard": {
          "declared": "Déclaré",
          "handicap": "Handicap",
          "invalidity": "Invalidité",
          "recognitionOfDisabledWorkerStatus": "RQTH",
          "undeclared": "Non déclaré"
        },
        "lastVisitCard": {
          "date": "Date de dernière visite",
          "doctor": "Nom du médecin",
          "empty": "Aucune visite médicale n'a encore été réalisée avec Sano.",
          "fit": "Adte",
          "lastVisit": "Dernière visite médicale",
          "recommendations": "Recommandations",
          "status": "Statut : ",
          "type": "Type de visite",
          "unfit": "Inapte"
        },
        "medicalHistoryCard": {
          "medicalHistory": "Antécédents médicaux professionnels"
        },
        "risksCard": {
          "declaredRisks": "Risques identifiés par l’employeur",
          "observedRisks": "Risques constatés en visite",
          "risks": "Risques identifiés",
          "title": "Risques"
        }
      },
      "profile": {
        "contactInformationCard": {
          "address": "Adresse",
          "contactInformation": "Coordonnées",
          "personalEmail": "Email personnel",
          "phoneNumber": "Téléphone",
          "professionalEmail": "Email professionnel"
        },
        "identityCard": {
          "birthDate": "Date de naissance",
          "birthName": "Nom de naissance",
          "birthPlace": "Lieu de naissance",
          "firstName": "Prénom",
          "fullName": "Nom complet",
          "identity": "Identité",
          "lastName": "Nom",
          "sex": "Sexe",
          "treatingPhysicianFullName": "Médecin traitant"
        },
        "jobCard": {
          "contractEndDate": "Date de fin de contrat",
          "contractStartDate": "Date de début de contrat",
          "contractType": "Type de contrat",
          "department": "Pôle",
          "description": "Description du poste de travail",
          "entity": "Division",
          "job": "Poste de travail",
          "jobLocation": "Mode de travail",
          "jobTitle": "Poste de travail",
          "pcsCode": "Code PCS",
          "specificConditions": "Conditions spécifiques du travail"
        },
        "socioFamilySituationCard": {
          "familyComposition": "Composition familiale",
          "psychosocialContext": "Contexte psychosocial",
          "socioFamilySituation": "Situation socio-familiale"
        },
        "transportCard": {
          "transport": "Conditions de transport",
          "transportMode": "Mode de transport",
          "transportTime": "Temps de transport"
        },
        "workEnvironmentCard": {
          "workEnvironment": "Perception de l’environnement de travail"
        }
      },
      "summary": {
        "alertsCard": {
          "clinicalExamNotes": "Notes de l'examen clinique",
          "currentPathologies": "Pathologies actuelles",
          "keyAlerts": "Alertes clés",
          "pdp": "Plan de Prévention à la Désinsertion Professionnelle (PDP)",
          "since": "Depuis le {since, date, short}"
        },
        "followUpCard": {
          "followUp": "Suivi professionnel",
          "risk": "Risques associés"
        },
        "healthCard": {
          "alcohol": "Alcool : ",
          "allergies": "Allergies",
          "diet": "Alimentation : ",
          "drug": "Drogue : ",
          "health": "Santé",
          "physicalActivity": "Activité physique : ",
          "sleep": "Sommeil : ",
          "tobacco": "Tabac : ",
          "vaccination": "Suivi vaccinal"
        },
        "lastVisitCard": {
          "lastVisit": "Dernière visite médicale",
          "lastVisitClinicalExamNotes": "Notes de l'examen clinique",
          "lastVisitDate": "Date de dernière visite",
          "lastVisitDoctor": "Nom du médecin",
          "lastVisitStatus": "Statut",
          "lastVisitType": "Type de visite"
        }
      },
      "tabs": {
        "adminManagement": "Admin",
        "context": "Contexte",
        "documents": "Documents",
        "health": "Santé",
        "history": "Historique",
        "identity": "Identité",
        "pdp": "PDP",
        "professionalMonitoring": "Suivi professionnel",
        "summary": "Résumé médical",
        "visits": "Visites"
      }
    },
    "medicalRecordsAdd": {
      "addressLine": "Localisation du poste physique",
      "canCloseWindow": "Vous pouvez fermer cette fenêtre et terminer la visite.",
      "close": "Fermer",
      "conclusionDocumentEdit": {
        "abilityDocument": {
          "comments": {
            "fieldLabel": "Commentaires",
            "placeholder": "Entrer ici les commentaires",
            "title": "Commentaires, hors mesures individuelles prévues à l’article L. 4624-3"
          },
          "generateDocumentCTA": "Générer l'attestation d'aptitude",
          "legalExplanation": "NB : Tous les articles auxquels il est fait référence dans le présent document relèvent du code du travail.<br/><br/><u>Voies et délais de recours par le·la collaborateur·trice ou par l'employeur·euse :</u><br/><br/>Les avis reposant sur des éléments de nature médicale émis par le médecin du travail peuvent être contestés dans un délai de 15 jours à compter de leur notification auprès du conseil de prud'hommes territorialement compétent (art. R. 4624-45 du code du travail)",
          "visitType": {
            "initial": "Examen médical d'aptitude à l'embauche (art. R. 4624-24)",
            "renewal": "Renouvellement de l'examen médical d'aptitude (art. R. 4624-28)",
            "title": "Type d'examen"
          }
        },
        "accommodationDocument": {
          "generateDocumentCTA": "Générer le document",
          "legalExplanation": "NB : Tous les articles auxquels il est fait référence dans le présent document relèvent du code du travail.<br/><br/><u>Voies et délais de recours par le·la collaborateur·trice ou par l’employeur·euse :</u><br/><br/>Les avis reposant sur des éléments de nature médicale émis par le médecin du travail peuvent être contestés dans un délai de 15 jours à compter de leur notification auprès du conseil de prud’hommes territorialement compétent (art. R. 4624-45 du code du travail)."
        },
        "accomodationDescription": {
          "fieldLabel": "Description",
          "placeholder": "Entrer ici la description",
          "title": "Description de l’aménagement de poste ou du temps de travail proposé"
        },
        "backToForm": "Retour",
        "conclusionDocumentTypeDescription": {
          "ABILITY": "Réservé aux travailleurs bénéficiant d'un suivi individuel renforcé",
          "ABILITY_WITH_ACCOMODATION_OR_RESTRICTION": "(art. L. 4624-3 du code du travail)",
          "DRIVING_RISKY_VEHICLES_ABILITY": "Selon les articles R. 4544-10 et R.4544-11 du Code du Travail",
          "FOLLOW_UP_CERTIFICATE": "Individuel de l'état de santé (art L. 4624-1 du code du travail)",
          "IMPORTANT_ELECTRICAL_RISKS_ABILITY": "Selon les articles R. 4544-10 et R.4544-11 du Code du Travail",
          "INABILITY": "(art. L. 4624-4 du code du travail)",
          "NO_CONCLUSION": "Sans conclusion",
          "TEMPORARY_INABILITY": "(art L. 4624-1 du code du travail)"
        },
        "conclusionDocumentTypeTitle": {
          "ABILITY": "Avis d'aptitude",
          "ABILITY_WITH_ACCOMODATION_OR_RESTRICTION": "Proposition de mesures individuelles d'aménagement, d'adaptation ou de transformation du poste de travail ou de mesures d'aménagement du temps de travail",
          "DRIVING_RISKY_VEHICLES_ABILITY": "Attestation médicale de non-contre-indication pour la conduite d’engins à risque",
          "FOLLOW_UP_CERTIFICATE": "Attestation de suivi",
          "IMPORTANT_ELECTRICAL_RISKS_ABILITY": "Attestation médicale de non-contre-indication pour les opérations électriques à risque important",
          "INABILITY": "Avis d'inaptitude",
          "NO_CONCLUSION": "Sans conclusion",
          "TEMPORARY_INABILITY": "Inaptitude temporaire"
        },
        "description": "Description du document de conclusion",
        "doctorReferralWithoutDelay": "Réorientation vers le médecin du travail sans délai",
        "documentsGeneration": {
          "description": "Remplissez les documents sélectionnés.",
          "document": "Document {n, number}/{total, number}",
          "title": "Génération des documents"
        },
        "drivingRiskyVehiclesAbility": {
          "generateDocumentCTA": "Générer l’attestation de suivi",
          "informationText": "Ne présente aucune contre-indication médicale à la formation à la conduite des équipements de travail suivants, lorsque l’activité l’expose à un risque pour lui-même ou pour les tiers :\n\n•\tÉquipements de travail mobiles automoteurs\n•\tChariots automoteurs de manutention\n•\tPlates-formes élévatrices mobiles de personnel\n•\tÉquipements de levage nécessitant une conduite ou une manipulation en sécurité\n\nLa présente attestation est délivrée conformément aux exigences de l’arrêté du 9 juin 2023 et permet l’accès à la formation préalable à l’obtention d’une autorisation de conduite, lorsqu’elle est requise par l’employeur. Elle est remise en deux exemplaires au·à la collaborateur·trice qui en transmet un exemplaire à son employeur·euse. Elle est valable pour une durée de 5 ans.",
          "legalExplanation": "NB : Une copie de cette attestation est conservée au sein du dossier médical de santé au travail du·de la collaborateur·trice (DMST). En cas de perte, un duplicata de ce document peut être demandé à tout moment en s'adressant au service de prévention et de santé au travail ou au service de santé au travail en agriculture."
        },
        "employeeInformation": {
          "title": "Collaborateur·trice"
        },
        "followUpDocument": {
          "generateDocumentCTA": "Générer l'attestation de suivi",
          "legalExplanation": "NB : Tous les articles auxquels il est fait référence dans le présent document relèvent du code du travail. Le travailleur, l’employeur ou le médecin du travail peuvent solliciter l’organisation d’une visite à la demande par le médecin du travail (R. 4624-34 du code du travail)."
        },
        "importantElectricalRisksAbility": {
          "generateDocumentCTA": "Générer l’attestation de suivi",
          "informationText": "Ne présente pas de contre-indications médicales à la réalisation d'opérations au voisinage de pièces nues sous tension ou de travaux sous tension.\n\nLa présente attestation est remise en deux exemplaires au·à la collaborateur·trice concerné·e qui en transmet un exemplaire à son employeur·euse en vue de la délivrance de l'habilitation prévue aux articles R. 4544-10 et R. 4544-11 si celle-ci est nécessaire. Ils conservent cette attestation durant sa période de validité de 5 ans.",
          "legalExplanation": "NB : Une copie de cette attestation est conservée au sein du dossier médical de santé au travail du·de la collaborateur·trice (DMST). En cas de perte, un duplicata de ce document peut être demandé à tout moment en s'adressant au service de prévention et de santé au travail ou au service de santé au travail en agriculture."
        },
        "inabilityDocument": {
          "conclusions": {
            "title": "Conclusions et indications relatives au reclassement (art. L. 4624-4)"
          },
          "exemptedFromReclassification": {
            "description": "Cas exceptionnel privant le·la collaborateur·trice de son droit à reclassement par l’employeur·euse et permettant son licenciement sans consultation du CSE sur les propositions de reclassement.",
            "healthObstacleToReclassification": "« L'état de santé du·de la collaborateur·trice fait obstacle à tout reclassement dans un emploi »",
            "maintenancePrejudicialToHealth": "« Tout maintien du·de la collaborateur·trice dans un emploi serait gravement préjudiciable à sa santé »",
            "or": "ou",
            "title": "Le cas échéant, cas de dispense de l'obligation de reclassement  (articles L. 1226-2-1, L. 1226-12 et L. 1226-20 du code du travail)"
          },
          "generateDocumentCTA": "Générer l'avis d'inaptitude",
          "inabilityDeclaration": {
            "arrivalTime": "Heure d'arrivée :",
            "companySheetUpdate": "Date de la dernière actualisation de la fiche d'entreprise",
            "departureTime": "Heure de départ :",
            "employerExchange": "Echange avec l'employeur en date du :",
            "firstVisitDate": "Date de la 1ère visite :",
            "ifRelevant": "Le cas échéant :",
            "jobStudy": "Étude de poste en date du :",
            "secondVisitDate": "Date de la 2ème visite :",
            "title": "Déclaration d'inaptitude (Mentions obligatoires en application de l’art. R. 4624-42 du code du travail)",
            "workingConditionsStudy": "Étude des conditions de travail en date du :"
          },
          "legalExplanation": "NB : Tous les articles auxquels il est fait référence dans le présent document relèvent du code du travail.<br/><br/><u>Voies et délais de recours par le·la collaborateur·trice ou par l’employeur·euse :</u><br/><br/>Les avis reposant sur des éléments de nature médicale émis par le médecin du travail peuvent être contestés dans un délai de 15 jours à compter de leur notification auprès du conseil de prud’hommes territorialement compétent (art. R. 4624-45 du code du travail). ",
          "visitType": {
            "initialExam": "Examen médical à l’embauche (art. R. 4624-24)",
            "intermediateVisit": "Visite intermédiaire (art. R. 4624-28)",
            "reinforcedMonitoring": "Suivi individuel renforcé :",
            "renewalExam": "Examen médical périodique (art. R. 4624-28)",
            "title": "Type d'examen ou de visite"
          }
        },
        "jobInformation": {
          "employments": "OU EMPLOI(s) (travailleurs temporaires, saisonniers, salariés des associations intermédiaires, mannequins…)",
          "individualMeasures": "Le poste fait l'objet de mesures individuelles prévues à l'article L. 4624-3 :",
          "no": "Non",
          "reinforcedMonitoring": "Le poste fait l'objet d'un suivi individuel renforcé prévu à l'article L. 4624-2 :",
          "title": "Poste de travail",
          "yesSince": "Oui, depuis le"
        },
        "nextVisitDateLabel": "A revoir au plus tard le :",
        "practitionerLegalIntroduction": {
          "description": "Je soussigné·e, {practitionerName}, {practitionerRole} de {facilityName}, atteste par la présente que :",
          "practitionerRoleLabel": {
            "DOCTOR": "médecin du travail",
            "NURSE": "infirmier·ère"
          }
        },
        "title": "SERVICE DE PRÉVENTION ET DE SANTÉ AU TRAVAIL",
        "validateAndSign": "Valider",
        "visitDate": {
          "date": "Date",
          "endTime": "Heure de départ :",
          "startTime": "Heure d'arrivée :",
          "title": "Date de l'examen ou de la visite"
        },
        "visitType": {
          "title": "Type d'examen ou de visite (*)"
        },
        "visitTypeDescription": {
          "INTERMEDIATE_VISIT": "Visite intermédiaire effectuée dans le cadre du suivi individuel renforcé (art R. 4624-28)",
          "MID_CAREER_VISIT": "Visite de mi-carrière (art. L. 4624-2-2)",
          "POST_PROFESSIONAL_VISIT": "Visite post-professionnelle (art. L. 4624-2-1)",
          "RETURN_VISIT": "Visite de reprise (art. R. 4624-31)",
          "VIP": {
            "initiale": "Initiale (art. R. 4624-10)",
            "periodique": "Périodique (art. R. 4624-16)",
            "title": "Visite d'information et de prévention"
          },
          "VISIT_REQUESTED_BY_EMPLOYEE": "Visite à la demande du·de la collaborateur·trice (art. R. 4624-34)",
          "VISIT_REQUESTED_BY_MB": "Visite à la demande de l'employeur (art. R. 4624-34)",
          "VISIT_REQUESTED_BY_MB_OR_EMPLOYEE": "Visite à la demande (art. R. 4624-34)"
        },
        "visitTypeExplanation": "(*) Si le médecin du travail constate une inaptitude, utiliser l'avis d'inaptitude."
      },
      "dontForgetToLoadDocument": "N'oubliez pas de scanner {count, plural, one {le document une fois signé, et de le} other {les documents une fois signés, et de les}} charger dans le DMST.",
      "downloadDocumentToSign": "Téléchargez {count, plural, one {le document pour l''} other {les documents pour les }}imprimer pour signature :",
      "downloadDocuments": "Télécharger {count, plural, one {le document} other {les documents}}",
      "finishExam": "Finaliser l'examen",
      "loadDocument": "Charger {count, plural, one {le document} other {les documents}} dans le DMST",
      "signatureType": {
        "chooseSignatureType": "Choisissez le type de signature",
        "electronic": "Signature électronique",
        "selectSignatureType": "Veuillez sélectionner le mode de signature adapté.",
        "wetInk": "Sur papier"
      },
      "specificConditionsLabel": "Risques déclarés par l'employeur",
      "subtitle": "Examen médical",
      "success": "Examen médical sauvegardé avec succès",
      "successDraft": "Examen médical sauvegardé en brouillon avec succès",
      "tabs": {
        "conclusion": "Examen médical et conclusion",
        "lifestyle": "Hygiène de vie",
        "medicalBackground": "Antécédents, traitements, vaccins",
        "workstation": "Poste de travail"
      },
      "title": "Nouvel examen",
      "titles": {
        "administrativeStatus": "Situation administrative / handicaps",
        "clinicalExamination": "Examen clinique",
        "conclusion": "Examen médical et conclusion",
        "currentTreatment": "Traitement en cours",
        "habits": "Habitudes et comportement de santé",
        "lifestyle": "Hygiène de vie",
        "medicalBackground": "Antécédents, traitements, vaccins",
        "medicalBackgroundDetailed": "Antécédents médicaux détaillés",
        "medicalConclusion": "Conclusion médicale de l'examen",
        "otherActions": "Autres actions",
        "physicalActivity": "Activité physique et alimentation",
        "professionalRisks": "Risques professionnels",
        "socioFamilySituation": "Situation socio-familiale",
        "vaccinationFollowup": "Suivi vaccinal",
        "visitContext": "Contexte de la visite",
        "vitalsParameters": "Paramètres vitaux",
        "workstationDescription": "Description du poste"
      },
      "videoCall": {
        "appointmentState": {
          "finished": "Consultation terminée"
        },
        "deviceSelection": {
          "audioInput": "Microphone",
          "speakers": "Enceintes",
          "videoInput": "Webcam"
        },
        "employeeState": {
          "connected": "Collaborateur·trice connecté·e",
          "missing": "Collaborateur·trice absent·e",
          "waiting": "En attente du·de la collaborateur·trice"
        },
        "identityValidation": {
          "cta": "Valider l'identité",
          "description": "Merci de valider l'identité du·de la collaborateur·trice au début de la consultation.",
          "title": "Informations d'identité",
          "warning": "Vous devez lancer la téléconsultation et vérifier que la personne connectée correspond à la pièce d'identité présentée avant de valider son identité."
        },
        "liveChat": {
          "placeholder": "Votre message",
          "send": "Envoyer le message",
          "sendBy": "Envoyé par {name} à {date, time, ::H mm}",
          "sendByYou": "vous",
          "subtitle": "Partagez des messages de manière sécurisée avec {name}.",
          "title": "Envoyer un message",
          "titleSharedMessages": "Messages partagés",
          "titleSharedMessagesWith": "Messages échangés avec le {name}"
        },
        "startVideoCall": "Lancer la téléconsultation",
        "title": "Téléconsultation",
        "videoCallCancelled": "Consultation annulée"
      },
      "yousignIsDown": "Yousign est indisponible pour le moment, veuillez utiliser la signature sur papier."
    },
    "meeting": {
      "expired": {
        "cta": "Revenir à la consultation",
        "description": "Votre attestation ainsi que les documents de prévention vous seront transmis très prochainement par email.\n\nAu plaisir de vous revoir bientôt chez Sano !",
        "sharedFile": {
          "fromDoctor": "Partagé avec vous par {name}"
        },
        "subtext": "Mauvaise manipulation ?",
        "title": "Votre consultation est terminée"
      },
      "identityValidation": {
        "addIdentity": "Ajouter votre pièce d'identité",
        "description": "Avant de commencer, une petite vérification d'identité.",
        "description2": "Merci d'ajouter une pièce d'identité officielle :",
        "description3": "<strong>Carte d'identité</strong> recto/verso, <strong>passport</strong> ou <strong>titre de séjour</strong> en cours de validité.",
        "description4": "C'est rapide et ça ne sera demandé qu'à votre première consultation.",
        "infoBarBirth": "Né",
        "infoBarBirthLocation": "à <location>{location}</location>",
        "infoBarBirthday": "le <date>{date, date, ::d M y}</date>",
        "infoBarCompany": "Travaille chez <company>{company}</company>",
        "skip": "Je ne souhaite pas partager ma pièce d'identité",
        "title": "Vérification d'identité requise"
      },
      "lateStaff": {
        "description": "Nous vous prions de nous excuser pour le retard de votre professionnel·le de santé.\n\nVous allez recevoir d'ici peu un email vous permettant de choisir un nouveau créneau de consultation.\n\nMerci de votre compréhension,\nL'équipe médicale Sano",
        "title": "Toutes nos excuses"
      },
      "live": {
        "consultGuide": "Consultez notre guide pour résoudre les problèmes les plus fréquents",
        "encounteringProblem": "Un problème de son ou d'image ?",
        "waitingForDoctor": "En attente du médecin"
      },
      "noShow": {
        "description": "Votre médecin du travail a attendu patiemment… mais la téléconsultation est terminée.\n\nPas de panique, personne ne vous en veut.\n\nMais comme dans tout bon concert, quand la salle est vide au lever de rideau… le show ne peut pas commencer.\n\n<bold>La bonne nouvelle ?</bold>\n\nIl est toujours possible de reprogrammer un rendez-vous.\n Et la prochaine fois, on vous garde une place au premier rang.\n\nL'équipe Sano",
        "title": "Oups !\nTrop tard…"
      },
      "waitingRoom": {
        "future": {
          "inMinutes": "Dans <span>{minutes, number}</span> minutes"
        },
        "lateStaff": {
          "action": "Je ne peux pas attendre",
          "description": "Si vous ne pouvez pas attendre plus longtemps, vous avez la possibilité d'annuler ce rendez-vous et d'en planifier un nouveau.",
          "modal": {
            "cancel": "Attendre",
            "confirm": "Je ne peux pas attendre",
            "description": "Désolé pour ce contretemps.\n            <br />\n            Si vous décidez de quitter la visite, nous vous enverrons un e-mail pour reprogrammer un rendez-vous.\n            <br />\n            Sinon, restez connecté·e : le professionnel de santé arrive bientôt.",
            "title": "Vous n'avez plus le temps d'attendre ?"
          },
          "subtitle": "Il (elle) ne devrait pas tarder.",
          "title": "Votre médecin a plus de 10 minutes de retard..."
        },
        "past": {
          "title": "Le médecin arrivera dans quelques instants."
        },
        "stayConnected": "Merci de rester connecté sur cette page",
        "title": "Votre consultation commencera bientôt"
      },
      "welcome": {
        "abortDeleteDocument": "Conserver",
        "cancelDeleteDocument": "Annuler la suppression",
        "confirmDeleteDocument": "Supprimer le document",
        "deleteDocumentDescription": "Vous êtes sur le point de supprimer le document \"{fileName}\".",
        "deleteDocumentDescriptionAsEmployee": "Une fois supprimé, le {qualification} {lastName} n'y aura plus accès.",
        "deleteDocumentDescriptionAsMedicalStaff": "Une fois supprimé, {firstName} {lastName} n'y aura plus accès.",
        "deleteDocumentTitle": "Êtes-vous sûr·e de vouloir supprimer ce document ?",
        "join": "Rejoindre la consultation",
        "testAudioInput": "Microphone",
        "testAudioInputError": "Erreur lors de la sélection du microphone",
        "testAudioOutput": "Enceintes",
        "testAudioOutputError": "Erreur lors de la sélection des enceintes",
        "testCamera": "Webcam",
        "testCameraError": "Erreur lors de la sélection de la webcam",
        "testTitle": "Tester votre matériel"
      }
    },
    "memberCompanyOnboarding": {
      "step0": {
        "startTheOnboarding": "Débuter l'onboarding",
        "welcome": "Bienvenue chez Sano.\n\nTout est conçu pour vous simplifier la vie : rendez-vous faciles, conseils clairs, et une gestion fluide de la santé au travail.\n\nComptez sur nous pour être à vos côtés, simplement et efficacement.\n\nL'équipe Sano"
      },
      "step1": {
        "createTheAccount": "Créer le compte",
        "welcome": "Bienvenue chez Sano,",
        "welcomeDescription": "votre partenaire en santé et sécurité au travail."
      },
      "step2": {
        "additionalInformations": "Nous avons juste besoin de quelques informations supplémentaires."
      }
    },
    "memberHome": {
      "initialConfigurationStep": {
        "collaboratorStep": {
          "callToAction": {
            "label": "Ajouter les collaborateurs·trices",
            "labelCompleted": "Collaborateurs·trices ajouté·e·s"
          },
          "description": "Ajoutez vos collaborateurs·trices manuellement, via import en masse ou en connectant votre SIRH.",
          "title": "Ajouter les collaborateurs·trices"
        },
        "medicalHistoryStep": {
          "callToAction": {
            "label": "Ajouter l'historique médical",
            "labelCompleted": "Historique médical ajouté"
          },
          "description": "Importez les documents de suivi existants (ex. attestations de suivi) pour compléter les données de vos collaborateurs·trices, comme la date de la dernière visite.",
          "title": "Reprendre l'historique médical"
        }
      }
    },
    "parameters": {
      "centerInformations": "Informations du centre",
      "companyInformation": {
        "subtitle": "Utilisez cette page pour mettre à jour les informations de votre entreprise.",
        "updateSuccess": "Paramètres enregistrés avec succès"
      },
      "companyInformations": "Informations de l'entreprise",
      "userInformations": "Informations personnelles"
    },
    "planning": {
      "add": {
        "addAvailability": "Ouvrir les créneaux",
        "title": "Ouvrir des créneaux"
      },
      "addAvailabilities": "Ajouter des créneaux",
      "book": {
        "action": "Planifier la visite",
        "allowEmployeeToRescheduleAppointment": "Permettre au·à la collaborateur·trice de modifier le rendez-vous",
        "cantRescheduleAppointmentInLessThanOneMonth": "Un créneau ne peut pas être modifié moins d'un mois avant la date de la visite par un·e collaborateur·trice",
        "edit": {
          "action": "Modifier le rendez-vous",
          "title": "Modifier le rendez-vous"
        },
        "endTime": "Horaire de fin",
        "reschedule": {
          "success": "Rendez-vous modifié avec succès"
        },
        "startTime": "Horaire de début",
        "success": "Rendez-vous planifié avec succès",
        "timeSlotRange": "Créneau entre <strong>{start, time, ::HH mm}</strong> et <strong>{end, time, ::HH mm}</strong>",
        "title": "Planifier une visite",
        "visitDateRecap": "Date de la visite : {date, date, short}"
      },
      "cancelAppointmentDialog": {
        "cancelButtonText": "Conserver la consultation",
        "confirmButtonText": "Annuler la consultation",
        "description1": "Vous êtes sur le point d'annuler la consultation suivante :",
        "description2": "Visite d'information et de prévention pour <bold>{employeeName}</bold>. Visite prévue le <bold>{date, date, ::d MMMM y} de {from, time, ::H mm} à {to, time, ::H mm}</bold> par le <bold>{staffName}</bold>.",
        "description3": "Si vous continuez avec l'annulation, la consultation sera annulée sans être replanifiée.",
        "title": "Vous êtes sur le point d'annuler une consultation"
      },
      "cancelBookingSlotDialog": {
        "cancelButtonText": "Conserver le créneau",
        "confirmButtonText": "Annuler le créneau",
        "description1": "En annulant ce créneau, vous allez annuler ces visites :",
        "description2": "Si vous continuez avec l'annulation, les collaborateurs·trices recevront un email pour replanifier celles-ci.",
        "title": "Vous êtes sur le point d'annuler un créneau"
      },
      "cantScheduleAppointmentOrEditBookingSlotInPast": "Il n'est pas possible d'ajouter des visites ou de modifier un créneau passé",
      "edit": {
        "bookingSlotDate": "Date du créneau",
        "delete": "Supprimer le créneau",
        "endTime": "Horaire de fin",
        "informations": "Informations sur le créneau",
        "pickABootkingSlot": "Veuillez choisir un créneau",
        "startTime": "Horaire de début",
        "title": "Créneaux  de consultation"
      },
      "editAppointment": {
        "action": "Enregistrer les modifications",
        "cancel": "Annuler la consultation",
        "contactInformations": "Informations de contact",
        "employeeArrived": "Confirmer l'arrivée",
        "personalInformations": "Informations personnelles",
        "reassign": "Réaffecter",
        "subtitle": "Informations sur la consultation",
        "title": "Consultation"
      },
      "editBookSwitch": {
        "book": "Planifier une visite",
        "edit": "Modifier un créneau"
      },
      "reassignAppointment": {
        "noDoctorAvailable": "Aucun médecin disponible"
      },
      "reassignBookingSlot": {
        "information": "L'ensemble des visites seront transférées.",
        "noDoctorAvailable": "Aucun médecin disponible",
        "selectDoctor": "Sélectionnez un médecin"
      },
      "teamOf": "Équipe {name}"
    },
    "risks": {
      "addRiskToMemberBranch": {
        "addAll": "Tout ajouter",
        "description": "Sélectionnez les risques professionnels propres à votre activité pour faciliter le suivi et la conformité de votre entreprise.",
        "removeRisk": {
          "description": "{count, plural, =0 {Ce risque n’est associé à aucun·e collaborateur·trice.} one {Ce risque est associé <b>à {count} collaborateur·trice</b>. La suppression entraînera la <b>modification du suivi de ce collaborateur·trice</b>. Cette action est irréversible.} other {Ce risque est actuellement associé <b>à {count} collaborateurs·trices</b>. La suppression entraînera la <b>modification du suivi de ces collaborateurs·trices</b>. Cette action est irréversible.}}",
          "success": "Le risque a bien été supprimé",
          "title": "Voulez-vous supprimer le risque ?"
        },
        "searchPlaceholder": "Rechercher des risques...ex. L’entreprise privilégie le télétravail.",
        "selectedRisks": "Risques sélectionnés",
        "title": "Ajouter des risques"
      },
      "linkRisk": {
        "collaborator": {
          "link": "Le·la collaborateur·trice a été associé·e au risque",
          "unlink": "Le·la collaborateur·trice n’est plus associé·e au risque"
        },
        "department": {
          "link": "Le pôle a été associé au risque",
          "unlink": "Le pôle n’est plus associé au risque"
        },
        "description": "Associer les risques déclarés à vos collaborateurs·trices.",
        "linkRiskToCollaborator": "Associer des collaborateurs·trices",
        "nCollaborators": "{count, plural, one {{count} collaborateur·trice} other {{count} collaborateurs·trices}}",
        "noRiskAssociatedToMemberBranch": "Aucun risque n'est associé à votre entreprise. Veuillez d'abord ajouter des risques avant de pouvoir les associer à vos collaborateurs·trices.",
        "organizationUnit": {
          "link": "La division a été associée au risque",
          "unlink": "La division n’est plus associée au risque"
        },
        "title": "Associer les risques.",
        "workstation": {
          "link": "Le poste de travail a été associé au risque",
          "unlink": "Le poste de travail n’est plus associé au risque"
        }
      },
      "riskDetails": {
        "emptyState": {
          "description": "Utilisez la barre de recherche pour ajouter un·e collaborateur·trice, un pôle  ou un poste de travail.",
          "title": "Ce risque n’est pas encore associé à des collaborateurs·trices"
        },
        "header": {
          "title": "{count, plural, =0 {Aucun·e collaborateur·trice} one {1 collaborateur·trice} other {{count} collaborateurs·trices}}"
        },
        "remove": {
          "department": "Supprimer le pôle",
          "organizationUnit": "Supprimer la division",
          "workstation": "Supprimer le poste de travail"
        },
        "search": {
          "placeholder": "Rechercher un·e collaborateur·trice, un pôle  ou un poste de travail..."
        }
      }
    },
    "user": {
      "parameters": {
        "submit": "Mettre à jour",
        "subtitle": "Utilisez cette page pour mettre à jour vos informations personnelles.",
        "title": "Informations personnelles",
        "updateSuccess": "Paramètres enregistrés avec succès"
      }
    },
    "visits": {
      "cancelAppointmentDialog": {
        "cancelButtonText": "Conserver le rendez-vous",
        "confirmButtonText": "Annuler le rendez-vous",
        "description1": "Vous êtes sur le point d'annuler ce rendez-vous :",
        "title": "Êtes-vous sûr de vouloir annuler ce rendez-vous"
      },
      "table": {
        "actions": {
          "cancelVisit": "Annuler la visite",
          "cancelVisitError": "Erreur lors de l'annulation de la visite",
          "cancelVisitSuccess": "Visite annulée avec succès",
          "editVisit": "Modifier la visite",
          "noAction": "Aucune action",
          "sendInvitation": "Renvoyer l'invitation",
          "sendInvitationError": "Erreur lors de l'envoi de l'invitation",
          "sendInvitationSuccess": "Invitation renvoyée avec succès"
        },
        "documents": "Documents",
        "employee": "Collaborateurs·trices",
        "employeeArrivedTooltip": "Le·la collaborateur·trice s'est bien présenté·e au rendez-vous",
        "filters": {
          "onlyAppointmentToSchedule": "À planifier",
          "onlyLateAppointmentToSchedule": "En retard",
          "onlyNoShow": "Non présentation"
        },
        "planifyBefore": "À planifier avant",
        "planifyBeforeDate": "le {date}",
        "status": "Statut",
        "visit": {
          "state": {
            "NO_SHOW": "Non-présentation"
          }
        },
        "visitCancelled": "Visite annulée",
        "visitNotConfirmed": "Non-présentation",
        "visitType": "Type de visite",
        "when": "Date et horaire"
      },
      "title": "Visites"
    }
  },
  "sidebar": {
    "analytics": "Analytics",
    "companies": "Adhérents",
    "contactMyHealthService": "Contacter mon service de santé",
    "dashboard": "Tableau de Bord",
    "declareAnAbsence": "Déclarer un arrêt",
    "declareAnAccidentAtWork": "Déclarer un accident du travail",
    "documents": "Documents",
    "employees": "Effectif",
    "modifyTheStaff": "Modifier l'effectif",
    "numberOfEmployees": "{count, plural, =0 {Aucun·e collaborateur·trice} one {1 collaborateur·trice} other {{count} collaborateurs·trices}}",
    "planning": "Planning",
    "planningCalendar": "Vue calendrier",
    "planningResources": "Vue équipe",
    "requestAVisit": "Demander une visite",
    "visits": "Visites"
  },
  "user": {
    "identityStatus": {
      "temporary": "Provisoire",
      "validated": "Validée"
    },
    "nYearsOlds": "{years, number} ans",
    "nameWithQualification": "{qualification} {lastName}",
    "phoneStatus": {
      "toVerify": "À vérifier",
      "verified": "Vérifié"
    },
    "phoneVerificationPendingReview": {
      "description": "Le numéro de téléphone que vous avez renseigné ne correspond pas à celui enregistré sur votre compte.",
      "hint": "Pour débloquer votre compte, veuillez <a>contacter le support</a>",
      "hintEmployee": "Pour débloquer votre compte, veuillez contacter le service RH de votre entreprise.",
      "title": "Vérification de votre numéro de téléphone en cours"
    },
    "username": "{firstName} {lastName}",
    "usernameWithQualification": "{qualification} {firstName} {lastName}"
  }
}
